/* eslint-disable */
import React, { Component } from 'react'; //different
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import Main from './main';
import Casino from './casino';
import NavMenu from './navmenu';
import Slot from './slot';
import Arcade from './arcade';
import Sport from './sport';
import Fising from './fising';
import Promotion from './promotion';
import Login from './login';
import Logout from './logout';
import Affiliate from './affiliate';
import Linklistall from './linklistall';
import Linklistalldemo from './linklistaldemo';
import Loss from './loss';
import instance from "./axios-instance";
import Systems from "./SystemFunction";
import SweetAlert from 'react-bootstrap-sweetalert';
import jwt_decode from "jwt-decode";
import Swal from 'sweetalert2'
import Freegame from './slotfree';
import Register from './register';
import Luckyfortune from './luckyfortune';
import io from "socket.io-client";
import moment from 'moment';
import Spinwheels from './spinweel';
import Paoyingchub from './game/paoyingchub';
import { Flag } from '@mui/icons-material';
import md5 from 'md5';
import Popup from "./popup";
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import MainSettingContext from './MainSettingContext';
import Toprank from "./toprank";
import Strategy from './strategy';
import Event from './event';
import Redeemreward from "./redeemreward";
import Rebate from "./rebate";
import Deposit2 from "./deposit2";
import { t } from './i18n';
import './i18nApp';
import SiteConfig from './SiteConfig';
class App extends Component {
  get lang() { return localStorage.getItem('lang') || 'th'; }
  constructor(props) {
    super(props)
    this.state = {
      mainsettingData: null,
      tabdeposit: 1,
      checkboxcookie: false,
      loading: true,
      username: null,
      userid: null,
      phoneNumber: "",
      balance: 0,
      prolistx: [],
      mainacc: null,
      qrcode: null,
      stateregis: 1,
      checkboxacc: 0,
      products_page_count: 1,
      loginstate: false,
      fullname: null,
      lname: null,
      link: "",
      alert: null,
      depositstate: 0,
      stateforget: 1,
      depositamount: 0,
      stateopterror: "",

      paymentlist: null,
      tblpaymentgatewayx: null,
      btnisActive: true,
      otpphone: "",
      token: window.localStorage.getItem("token"),
      accnumber: null,
      accnumbertxt: null,
      withdrawamount: 0,
      rankpoint: 0,
      changepassword: false,
      linelink: "",
      errortext: "",
      trueaccount: null,
      datas: null,
      otpphoneforget: "",
      affpercent: 0,
      userrecomend: "",
      historylist: [],
      useradvice: [],
      cashoutlist: [],
      tblnextrank: [],
      tblrankall: [],
      maxwithdrawstatus: 0,
      tblprofile: [],

      prodetail: [],
      oldpassword: "",
      linkaff: "",
      webnamex: "",
      inviteSet: "",
      truegiftlink: "",
      proderedeem: [],
      proderedeemlist: [],
      buttoncliam: false,
      limit: null,
      rankpic: "1.jpeg",
      rankname: null,
      rankob: null,
      cashoutSet: [],
      tblPopupMenu1: [],
      tblPopupMenu2: [],
      tblPopupMenu: null,
      termAndCondition: false,
      errorstatus: false,
      // ── ฝากหลายช่องทาง (config-driven เหมือน Thmese6) ──
      depositChannel: 'auto',
      depositConfig: null,
      depositConfigLoaded: false,
      mainaccAutoslip: null,
      truewalletInfo: null,
      cryptowallets: [],
      activeCryptoIdx: 0,
      cryptoThbAmount: "",
      cryptoCopied: null,
      slipFile: null,
      slipPreview: null,
      slipUploading: false,
      slipSuccess: false,
      truemoneyAmount: "",
      truemoneyPhone: "",
      truemoneySubmitting: false,
    }
    this.handleClick = this.handleClick.bind(this);
    this.forgetotpandregister = this.forgetotpandregister.bind(this);
  }
  copyCode = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        this.notify("warning", 'CopyCode!!!');
      })
      .catch((err) => {
        console.error("Clipboard error:", err.message); // Log error
      });
  };

  adjustAmount = (operator) => {
    const adjustment = 10; // ค่า data-value
    let newAmount = parseInt(this.state.depositamount || 0, 10); // แปลง depositamount เป็นตัวเลข

    if (operator === "+") {
      newAmount += adjustment; // เพิ่มค่า
    } else if (operator === "-") {
      newAmount -= adjustment; // ลดค่า
    }

    if (newAmount < 0) {
      newAmount = 0;
    }

    this.setState({ depositamount: newAmount });
  };
  openAccout(evt, cityName) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("js-profile-account-modal");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tabaccount");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    document.getElementById(cityName).style.display = "block";
    evt.currentTarget.className += " active";
  }
  showClockRealTime = (datestart) => {

    var months_th_mini = t(this.lang, 'ap2_months_mini');
    var today = new Date(datestart);
    var endday = months_th_mini[today.getMonth()];

    return endday;
  }
  handleClick = async (e, price) => {
    if (price <= this.state.balance) {
      this.setState({
        withdrawamount: price
      });
    }
    else {
      await Swal.fire({
        title: 'Warning!',
        text: t(this.lang, 'ap_withdraw_insufficient'),
        icon: 'warning',
        confirmButtonText: t(this.lang, 'ap_ok')
      })
    }
  }

  getpopup = () => {
    instance.post("/api/v1/popuplist", {
      System: Systems,
      Cat_ID: 0,
      page: 1,
      type: 1
    }).then(async (res) => {
      if (res.data.status === 200) {
        console.log(160, res.data.message.banklist);
        this.setState({
          tblPopupMenu1: res.data.message.tblPopupMenu1,
          tblPopupMenu: res.data.message.banklist,
          tblPopupMenu2: res.data.message.tblPopupMenu2,
        });



      }
    }).catch(async (err) => {
      if (err.response.status === 401 || err.response.status === 403) {
        localStorage.clear();
        await Swal.fire({
          title: 'Warning!',
          text: t(this.lang, 'ap_session_expired'),
          icon: 'warning',
          confirmButtonText: t(this.lang, 'ap_ok')
        })
        window.location.href = '/';
      }
    });

  }
  checkpro = async (e, proid) => {
    var token = localStorage.getItem('auth_token');
    if (token != null) {
      var decoded = jwt_decode(token);
      var Username = decoded.message.playerid;
      await instance.post("/api/v1/checkpromotion", {
        userid: Username,
        System: Systems,
        Proid: proid,
      }, {
        headers: { Authorization: `Bearer ${token}` }
      }).then(async (res) => {
        if (res.data.status === 200) {
          console.log("checkpro", res.data);
          if (res.data.type === 0) {
            this.setState({
              prodetail: res.data.message.tblpromotions[0],
            });
          }
          else if (res.data.type === 1) {
            this.setState({
              proderedeem: res.data.message.tblpromotionredeems,
              proderedeemlist: res.data.message.tblpromotionredeems,
            });
          }

        }
        else if (res.data.status === 201) {
          this.setState({
            prodetail: [],
            picnonpro: "/media/cache/strip/202109/promotion/7AB3F352-6DE2-44CC-A5FC-D4359FCB2122.png",
          });

        }
        else if (res.data.status === 202) {
          await Swal.fire({
            title: 'error!',
            text: t(this.lang, 'ap_promo_pending_can_topup'),
            icon: 'error',
            confirmButtonText: t(this.lang, 'ap_ok')
          })
          return false;
        }

      }).catch(async (err) => {
        if (err.response.status === 401 || err.response.status === 403) {
          localStorage.clear();
          await Swal.fire({
            title: 'Warning!',
            text: t(this.lang, 'ap_session_expired'),
            icon: 'warning',
            confirmButtonText: t(this.lang, 'ap_ok')
          })
          window.location.href = '/';
        }
      });
    }
  }

  redeempro = async (e, proid) => {
    e.preventDefault();
    var token = localStorage.getItem('auth_token');
    if (token != null) {
      var decoded = jwt_decode(token);
      var Username = decoded.message.playerid;
      console.log(Username, proid);
      await instance.post("/api/v1/redeempromotion", {
        userid: Username,
        System: Systems,
        Proid: proid,
      }, {
        headers: { Authorization: `Bearer ${token}` }
      }).then(async (res) => {
        if (res.data.status === 200) {
          this.checkpro(null, 999)
          await Swal.fire({
            title: 'Success!',
            text: t(this.lang, 'ap_promo_received'),
            icon: 'success',
            confirmButtonText: t(this.lang, 'ap_ok')
          })
        }
        else if (res.data.status === 201) {
          await Swal.fire({
            title: 'error!',
            text: t(this.lang, 'ap_promo_not_eligible'),
            icon: 'error',
            confirmButtonText: t(this.lang, 'ap_ok')
          })
          e.preventDefault();
          return false;
        }
        else if (res.data.status === 204) {
          await Swal.fire({
            title: 'error!',
            text: t(this.lang, 'ap_quota_used_today'),
            icon: 'error',
            confirmButtonText: t(this.lang, 'ap_ok')
          })
          e.preventDefault();
          return false;
        }
        else if (res.data.status === 202) {
          await Swal.fire({
            title: 'error!',
            text: t(this.lang, 'ap_promo_already_used'),
            icon: 'error',
            confirmButtonText: t(this.lang, 'ap_ok')
          })
          e.preventDefault();
          return false;
        }

      }).catch(async (err) => {
        console.log(err);
        if (err.response.status === 401 || err.response.status === 403) {
          localStorage.clear();
          await Swal.fire({
            title: 'Warning!',
            text: t(this.lang, 'ap_session_expired'),
            icon: 'warning',
            confirmButtonText: t(this.lang, 'ap_ok')
          })
          window.location.href = '/';
        }
      });
    }
  }

  async recheccredit(evt) {

    evt.currentTarget.className += " fa-spin";
    var token = localStorage.getItem('auth_token');
    var decoded = jwt_decode(token);
    var Username = decoded.message.playerid;
    this.setState({
      userid: decoded.message.playerid,
      username: decoded.message.playerid,
      firstname: decoded.message.firstname,
      lastname: decoded.message.lastname,
      loginstate: true,
    });
    try {
      await instance.post("/api/v1/checkpoint", {
        userid: Username,
        System: Systems,
        Function: 'recheccredit-App.js'
      }, {
        headers: { Authorization: `Bearer ${token}` }
      }).then(async (res) => {
        if (res.data.status === 200) {
          localStorage.setItem('auth_token', res.data.token)
          this.setState({
            accnumber: res.data.message.accnumber,
            userid: res.data.message.member_id,
            username: res.data.message.playerid,
            fullname: res.data.message.firstname,
            point: res.data.message.Point,
            balance: res.data.databalance,
            loginstate: true,
          });
          var i, tablinks;
          tablinks = document.getElementsByClassName("btn btn-link -reload-btn p-0");
          for (i = 0; i < tablinks.length; i++) {
            tablinks[i].className = tablinks[i].className.replace(" fa-spin", "");
          }
        }
        else if (res.data.status === 401) {
          localStorage.clear();
          await Swal.fire({
            title: 'Warning!',
            text: t(this.lang, 'ap_session_expired'),
            icon: 'warning',
            confirmButtonText: t(this.lang, 'ap_ok')
          })
          window.location.href = '/';
        }

      }).catch(async (err) => {
        if (err.response.status === 401 || err.response.status === 403) {
          localStorage.clear();
          await Swal.fire({
            title: 'Warning!',
            text: t(this.lang, 'ap_session_expired'),
            icon: 'warning',
            confirmButtonText: t(this.lang, 'ap_ok')
          })
          window.location.href = '/';
        }
      });
    }
    catch (ex) {
    }
  }

  handleClickdeposit = async (e, price) => {
    this.setState({
      depositamount: price

    });
  }
  onChangexdep = (event) => {
    const value = event.target.value;
    if (/^\d*$/.test(value)) {
      this.setState({ depositamount: value });
    }
  };

  onChangexgiftlink = event => {
    if (event.target !== undefined) {

      this.setState({ truegiftlink: event.target.value });
    }
  };

  checkpromotions = async (e, num) => {
    e.preventDefault();
  }


  confirmdeposittrue = async (e, num) => {
    e.preventDefault();

    var token = localStorage.getItem('auth_token');

    if (token != null && this.state.btnisActive === true) {
      var decoded = jwt_decode(token);
      var Username = decoded.message.playerid;
      if (this.state.truegiftlink !== "") {
        this.setState({ statetrue: t(this.lang, 'ap_processing_please_wait'), btnisActive: false });
        Username = decoded.message.playerid;
        await instance.post("/api/v1/redeemtrue", {
          username: Username,
          System: Systems,
          linkurl: this.state.truegiftlink
        }, {
          headers: { Authorization: `Bearer ${token}` }
        }).then(async (res) => {
          if (res.data.status == 200) {
            console.log(res.data.amountx);
            this.setState({ btnisActive: true, statetrue: t(this.lang, 'ap_enter_gift_link_min10') });
            await Swal.fire({
              title: 'Success!',
              text: t(this.lang, 'ap_truemoney_topup_success') + res.data.amountx + "  " + t(this.lang, 'ap_baht') + " ",
              icon: 'success',
              confirmButtonText: t(this.lang, 'ap_ok')
            })
          }
          else if (res.data.status == 202) {
            this.setState({ btnisActive: true, statetrue: t(this.lang, 'ap_enter_gift_link_min10') });
            await Swal.fire({
              title: 'Warning!',
              text: t(this.lang, 'ap_gift_link_used'),
              icon: 'warning',
              confirmButtonText: t(this.lang, 'ap_ok')
            })
          }
          else if (res.data.status == 203) {
            this.setState({ btnisActive: true, statetrue: t(this.lang, 'ap_enter_gift_link_min10') });
            await Swal.fire({
              title: 'Warning!',
              text: t(this.lang, 'ap_gift_link_not_yours'),
              icon: 'warning',
              confirmButtonText: t(this.lang, 'ap_ok')
            })
          }
          else if (res.data.status == 205) {
            this.setState({ btnisActive: true, statetrue: t(this.lang, 'ap_enter_gift_link_min10') });
            await Swal.fire({
              title: 'Warning!',
              text: t(this.lang, 'ap_truemoney_closed'),
              icon: 'warning',
              confirmButtonText: t(this.lang, 'ap_ok')
            })
          }
          else {
            this.setState({ btnisActive: true, statetrue: t(this.lang, 'ap_enter_gift_link_min10') });
            await Swal.fire({
              title: 'Warning!',
              text: t(this.lang, 'ap_gift_link_failed'),
              icon: 'warning',
              confirmButtonText: t(this.lang, 'ap_ok')
            })
          }
        });
      }
      else if (this.state.truegiftlink === "") {
        await Swal.fire({
          title: 'Warning!',
          text: t(this.lang, 'ap_no_gift_link'),
          icon: 'warning',
          confirmButtonText: t(this.lang, 'ap_ok')
        })
      }
    }
    else {
      await Swal.fire({
        title: 'Warning!',
        text: t(this.lang, 'ap_processing_please_wait2'),
        icon: 'warning',
        confirmButtonText: t(this.lang, 'ap_ok')
      })
    }
  }
  // ── ฝากหลายช่องทาง (config-driven เหมือน Thmese6) ──
  setDepositChannel = (ch) => {
    this.setState({ depositChannel: ch });
    if (!this.state.depositConfigLoaded) this.loadDepositConfig();
  };

  loadDepositConfig = async () => {
    const token = localStorage.getItem('auth_token');
    if (!token) return;
    try {
      const res = await instance.post("/api/v1/getdepositconfig",
        { System: Systems },
        { headers: { Authorization: `Bearer ${token}` } });
      if (res.data && res.data.status === 200) {
        this.setState({
          depositConfig: res.data.config || {},
          depositConfigLoaded: true,
          mainaccAutoslip: res.data.mainaccAutoslip || res.data.mainacc || null,
          truewalletInfo: res.data.truewallet || null,
          cryptowallets: res.data.cryptowallets || [],
        });
      }
    } catch (err) {
      console.error("[deposit] loadDepositConfig error:", err);
    }
  };

  handleTrueDeposit = async () => {
    const { truemoneyAmount, truemoneyPhone } = this.state;
    if (!truemoneyAmount || !truemoneyPhone) {
      await this.notify("warning", t(this.lang, 'ap_true_fill_all'));
      return;
    }
    const token = localStorage.getItem('auth_token');
    if (!token) return;
    const decoded = jwt_decode(token);
    const Username = decoded.message.playerid;
    this.setState({ truemoneySubmitting: true });
    try {
      const res = await instance.post("/api/v1/deposittruewallet", {
        username: Username, System: Systems,
        amount: truemoneyAmount, phone: truemoneyPhone,
      }, { headers: { Authorization: `Bearer ${token}` } });
      if (res.data && (res.data.status === 200 || res.data.status === 201)) {
        await this.notify("success", t(this.lang, 'ap_true_submit_success'));
        this.setState({ truemoneyAmount: "", truemoneyPhone: "" });
      } else {
        await this.notify("warning", (res.data && res.data.message) ? res.data.message : t(this.lang, 'ap_true_submit_failed'));
      }
    } catch (err) {
      console.error("[deposit] trueDeposit error:", err);
      await this.notify("warning", t(this.lang, 'ap_true_submit_failed'));
    }
    this.setState({ truemoneySubmitting: false });
  };

  copyToClipboard = (text, key) => {
    navigator.clipboard.writeText(text);
    this.setState({ cryptoCopied: key });
    setTimeout(() => this.setState({ cryptoCopied: null }), 2000);
  };

  handleSlipChange = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    this.setState({ slipFile: file, slipPreview: URL.createObjectURL(file), slipSuccess: false });
  };

  handleSlipUpload = async () => {
    const { slipFile } = this.state;
    if (!slipFile) {
      await this.notify("warning", t(this.lang, 'ap_slip_select_first'));
      return;
    }
    const token = localStorage.getItem('auth_token');
    if (!token) return;
    const decoded = jwt_decode(token);
    const Username = decoded.message.playerid;
    this.setState({ slipUploading: true });
    try {
      // 1) อัปโหลดรูปสลิปขึ้น object storage (worker)
      const ext = (slipFile.name.match(/\.([a-z0-9]+)$/i)?.[1] || "jpg").toLowerCase();
      const filename = `slip_${Username}_${Date.now()}.${ext}`;
      const formData = new FormData();
      formData.append("System", Systems);
      formData.append("file", slipFile, filename);
      formData.append("filename", filename);
      const resUpload = await fetch("https://r2-public.wordbalance931.workers.dev/upload/slip", {
        method: "POST",
        headers: { Authorization: "Bearer langter" },
        body: formData,
      });
      const up = await resUpload.json().catch(() => ({}));
      const slip = up?.link || up?.url || null;
      if (!slip) {
        await this.notify("warning", t(this.lang, 'ap_slip_upload_failed'));
        this.setState({ slipUploading: false });
        return;
      }
      // 2) แจ้งสลิปเข้าระบบ betner
      const now = new Date();
      const mainacc = this.state.mainacc || {};
      const res = await instance.post("/api/v1/updateslip", {
        playerid: Username,
        username: Username,
        amount: Number(this.state.depositamount) || 0,
        date: now.getFullYear() + "-" + String(now.getMonth() + 1).padStart(2, '0') + "-" + String(now.getDate()).padStart(2, '0'),
        hour: String(now.getHours()).padStart(2, '0'),
        minute: String(now.getMinutes()).padStart(2, '0'),
        bank: mainacc.acro || mainacc.bank_id || "",
        slipimg: slip,
        slip,
        System: Systems,
        type: 5,
      }, { headers: { Authorization: `Bearer ${token}` } });
      if (res.data && res.data.status === 200) {
        this.setState({ slipSuccess: true, slipFile: null, slipPreview: null });
        await this.notify("success", t(this.lang, 'ap_slip_upload_success'));
      } else {
        await this.notify("warning", (res.data && res.data.message) ? res.data.message : t(this.lang, 'ap_slip_upload_failed'));
      }
    } catch (err) {
      console.error("[deposit] slipUpload error:", err);
      await this.notify("warning", t(this.lang, 'ap_slip_upload_failed'));
    }
    this.setState({ slipUploading: false });
  };

  renderDepositChannelBar = () => {
    const lang = this.lang;
    if (!this.state.depositConfigLoaded && !this._cfgLoading) { this._cfgLoading = true; this.loadDepositConfig(); }
    const cfg = this.state.depositConfig || {};
    const ch = this.state.depositChannel;
    const items = [{ key: 'auto', icon: 'fa-bolt', label: t(lang, 'ap_ch_auto') }];
    if (cfg.hasBankAutoslip) items.push({ key: 'bank', icon: 'fa-university', label: t(lang, 'ap_ch_bank') });
    if (cfg.hasTruewallet) items.push({ key: 'truewallet', icon: 'fa-wallet', label: t(lang, 'ap_ch_truewallet') });
    if (cfg.hasTruegift) items.push({ key: 'true', icon: 'fa-gift', label: t(lang, 'ap_ch_true') });
    if (cfg.hasCrypto) items.push({ key: 'crypto', icon: 'fa-coins', label: t(lang, 'ap_ch_crypto') });
    return (
      <div className="x-deposit-channel-bar">
        {items.map((it) => (
          <button
            key={it.key}
            type="button"
            className={"x-deposit-channel-item" + (ch === it.key ? " -active" : "")}
            onClick={() => this.setDepositChannel(it.key)}
          >
            <i className={"fas " + it.icon} />
            <span>{it.label}</span>
          </button>
        ))}
      </div>
    );
  };

  renderBankSlipPanel = () => {
    const lang = this.lang;
    const { mainaccAutoslip: mainacc, slipPreview, slipUploading, slipSuccess } = this.state;
    return (
      <div className="x-deposit-bankslip">
        {mainacc !== null && mainacc !== undefined && mainacc !== '' ? (
          <div className="x-deposit-bank-info-container -v2 mb-3">
            <div className="media m-auto">
              <img src={mainacc.img_path} className="-img rounded-circle" width="50" height="50" alt="bank" />
              <div className="-content-wrapper">
                <span className="-name">{t(lang, 'ap_bank_prefix')}{mainacc.fullname_th}</span>
                <span className="-own-name">{mainacc.first_name_en + " " + mainacc.last_name_en}</span>
                <span className="-number">{mainacc.accnumber.substring(0, 3) + "-" + mainacc.accnumber.substring(3, 9) + "-" + mainacc.accnumber.substring(9, 12)}</span>
              </div>
              <div className="-copy-wrapper">
                <a
                  role="button"
                  style={{ cursor: "pointer" }}
                  onClick={() => { navigator.clipboard.writeText(mainacc.accnumber); this.notify("success", t(lang, 'ap_copied')); }}
                  className="btn -btn js-copy-to-clipboard"
                >{t(lang, 'ap_copy')}</a>
              </div>
            </div>
          </div>
        ) : (
          <div className="text-center my-4"><i className="fas fa-spinner fa-spin" style={{ fontSize: 22 }} /></div>
        )}
        <div className="x-danger-zone -v2 mb-3"><span>{t(lang, 'ap_use_registered_account_only')}</span></div>
        <div className="x-slip-upload-box">
          <label className="-slip-label">{t(lang, 'ap_slip_upload_label')}</label>
          <label htmlFor="depositSlipInput" className="x-slip-dropzone">
            {slipPreview
              ? <img src={slipPreview} alt="slip" className="-slip-preview" />
              : <div className="-slip-placeholder"><i className="fas fa-cloud-upload-alt" /><span>{t(lang, 'ap_slip_choose')}</span></div>}
          </label>
          <input id="depositSlipInput" type="file" accept="image/*" onChange={this.handleSlipChange} style={{ display: 'none' }} />
          <button type="button" className="btn btn-block btn-primary mt-3" onClick={this.handleSlipUpload} disabled={slipUploading}>
            {slipUploading
              ? <span><i className="fas fa-spinner fa-spin" /> {t(lang, 'ap_slip_uploading')}</span>
              : t(lang, 'ap_slip_confirm')}
          </button>
          {slipSuccess && <div className="x-slip-success mt-2"><i className="fas fa-check-circle" /> {t(lang, 'ap_slip_upload_success')}</div>}
        </div>
        <div className="x-admin-contact mt-3">
          <span className="x-text-with-link-component">
            <label className="-text-message">{t(lang, 'ap_found_problem')}</label>
            <a href={this.state.linelink} className="-link-message" target="_blank" rel="noopener noreferrer"><u>{t(lang, 'ap_contact_support')}</u></a>
          </span>
        </div>
      </div>
    );
  };

  renderTrueWalletPanel = () => {
    const lang = this.lang;
    const { truewalletInfo, truemoneyAmount, truemoneyPhone, truemoneySubmitting } = this.state;
    return (
      <div className="x-deposit-true">
        <div className="x-true-head">
          <i className="fas fa-wallet -true-logo" style={{ color: '#ff6a00' }} />
          <span>TrueMoney Wallet</span>
        </div>
        {truewalletInfo && truewalletInfo.telnumber ? (
          <div className="x-tw-acc">
            <span className="-label">{t(lang, 'ap_true_dest')}</span>
            <span className="-num">{truewalletInfo.telnumber}</span>
            <span className="-nm">{truewalletInfo.name}</span>
          </div>
        ) : null}
        <div className="-x-input-icon x-input-operator mb-2 flex-column">
          <input type="number" className="x-form-control text-center form-control" placeholder={t(lang, 'ap_true_amount_ph')}
            value={truemoneyAmount} onChange={(e) => this.setState({ truemoneyAmount: e.target.value })} />
        </div>
        <div className="-x-input-icon x-input-operator mb-3 flex-column">
          <input type="tel" className="x-form-control text-center form-control" placeholder={t(lang, 'ap_true_phone_ph')}
            value={truemoneyPhone} onChange={(e) => this.setState({ truemoneyPhone: e.target.value })} />
        </div>
        <div className="text-center">
          <button type="button" className="btn btn-primary my-0 my-lg-3" disabled={truemoneySubmitting} onClick={this.handleTrueDeposit}>
            {truemoneySubmitting ? <span><i className="fas fa-spinner fa-spin" /> {t(lang, 'ap_processing')}</span> : t(lang, 'ap_true_submit')}
          </button>
        </div>
      </div>
    );
  };

  renderCryptoPanel = () => {
    const lang = this.lang;
    const { cryptowallets, activeCryptoIdx, cryptoThbAmount, cryptoCopied } = this.state;
    if (!cryptowallets || cryptowallets.length === 0) return <div className="text-center my-4"><i className="fas fa-spinner fa-spin" style={{ fontSize: 22 }} /></div>;
    const w = cryptowallets[activeCryptoIdx] || cryptowallets[0];
    const rate = parseFloat(w.rate) || 36;
    const thb = parseFloat(cryptoThbAmount) || 0;
    const out = thb > 0 ? (Math.ceil((thb / rate) * 1000) / 1000).toFixed(3) : null;
    return (
      <div className="x-deposit-crypto">
        {cryptowallets.length > 1 && (
          <div className="x-crypto-pills">
            {cryptowallets.map((cw, i) => (
              <button key={i} type="button" className={"x-crypto-pill" + (i === activeCryptoIdx ? " -active" : "")}
                onClick={() => this.setState({ activeCryptoIdx: i, cryptoCopied: null })}>
                {cw.currency} <small>({cw.network})</small>
              </button>
            ))}
          </div>
        )}
        <div className="x-crypto-rate"><i className="fas fa-coins" /> 1 {w.currency} = {rate.toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {t(lang, 'ap_baht')}</div>
        <div className="x-crypto-conv">
          <span className="-cur">฿</span>
          <input type="number" min="0" placeholder={t(lang, 'crypto_thb_label')} value={cryptoThbAmount} onChange={(e) => this.setState({ cryptoThbAmount: e.target.value })} />
          <span className="-unit">THB</span>
        </div>
        {out && (
          <div className="x-crypto-out">
            <div><div className="-lbl">≈ {w.currency}</div><div className="-val">{out}</div></div>
            <button type="button" className="x-crypto-copy" onClick={() => this.copyToClipboard(out, 'usdt')}>{cryptoCopied === 'usdt' ? '✓' : <i className="far fa-copy" />}</button>
          </div>
        )}
        {w.qrcode_img && <div className="text-center my-2"><img src={w.qrcode_img} alt="qr" className="x-crypto-qr" /></div>}
        {w.wallet_address && (<>
          <div className="-slip-label mt-2">{t(lang, 'crypto_wallet_address')}</div>
          <button type="button" className="x-crypto-addr" onClick={() => this.copyToClipboard(w.wallet_address, 'addr')}>
            <span>{w.wallet_address}</span>
            <span className="-chip">{cryptoCopied === 'addr' ? '✓ ' + t(lang, 'ap_copied') : t(lang, 'ap_copy')}</span>
          </button>
        </>)}
        <small className="x-crypto-warn">⚠️ {t(lang, 'crypto_send_warn_prefix')} {w.currency} ({w.network}) {t(lang, 'crypto_send_warn_suffix')}</small>
      </div>
    );
  };

  renderTrueDepositPanel = () => {
    const lang = this.lang;
    return (
      <div className="x-deposit-true">
        <div className="x-true-head">
          <i className="fas fa-gift -true-logo" style={{ color: '#ff6a00' }} />
          <span>{t(lang, 'ap_true_gift_title')}</span>
        </div>
        <p className="x-true-hint">{t(lang, 'ap_true_gift_hint')}</p>
        <div className="-x-input-icon x-input-operator mb-3 flex-column">
          <input
            type="text"
            className="x-form-control text-center form-control"
            placeholder="https://gift.truemoney.com/campaign/?v=..."
            value={this.state.truegiftlink}
            onChange={(e) => this.setState({ truegiftlink: e.target.value })}
          />
        </div>
        <div className="text-center">
          <button
            type="button"
            className="btn btn-primary my-0 my-lg-3"
            disabled={!this.state.btnisActive}
            onClick={(e) => this.confirmdeposittrue(e, 0)}
          >
            {this.state.btnisActive ? t(lang, 'ap_true_submit') : (this.state.statetrue || t(lang, 'ap_processing'))}
          </button>
        </div>
        <div className="x-admin-contact mt-2">
          <span className="x-text-with-link-component">
            <label className="-text-message">{t(lang, 'ap_found_problem')}</label>
            <a href={this.state.linelink} className="-link-message" target="_blank" rel="noopener noreferrer"><u>{t(lang, 'ap_contact_support')}</u></a>
          </span>
        </div>
      </div>
    );
  };

  confirmdeposit = async (e, num) => {
    console.log(493, num)
    e.preventDefault();
    var token = localStorage.getItem('auth_token');
    if (token != null) {
      var decoded = jwt_decode(token);
      var Username = decoded.message.playerid;
      if (num === 0) {
        if ((this.state.depositamount >= this.state.limit.min) && (this.state.depositamount <= this.state.limit.max)) {
          if (num === 0) {
            if (token != null) {
              Username = decoded.message.playerid;
              instance.post("/api/v1/getqrcode", {
                username: Username,
                System: Systems,
                amount: this.state.depositamount
              }, {
                headers: { Authorization: `Bearer ${token}` }
              }).then(async (res) => {
                console.log("/api/v1/getqrcode",res.data)

                this.setState({
                  mainacc: res.data.mainacc,
                  qrcode: res.data.picture,
                  tabdeposit: 2,
                  listacc: res.data.tblmain,
                  counter: 300,
                  qrcodecheck: true,
                });
                await this.notify("success", t(this.lang, 'ap_scan_qr_within_5min'));
              });

            }

            this.setState({
              depositstate: 1
            });
          }
        }
        else {
          await this.notify("warning", t(this.lang, 'ap_min_deposit_prefix') + this.state.limit.min + t(this.lang, 'ap_max_deposit_mid') + this.state.limit.max + ' ');

        }
      }
      else if (num === 1) {
        this.setState({
          depositstate: 1
        });
      }
      else if (num === 2) {
        if ((this.state.depositamount >= this.state.limit.min) && (this.state.depositamount <= this.state.limit.max)) {
          if (num === 2) {
            if (token != null) {
              Username = decoded.message.playerid;
              instance.post("/api/v1/getqrcode", {
                username: Username,
                System: Systems,
                amount: this.state.depositamount
              }, {
                headers: { Authorization: `Bearer ${token}` }
              }).then(async (res) => {
                console.log(res.data.tblpaymentgatewayx)
                this.setState({
                  mainacc: res.data.mainacc,
                  qrcode: res.data.tblpaymentgatewayx.QRcode,
                  listacc: res.data.tblmain,
                  tabdeposit: 2,
                  counter: 300,
                  qrcodecheck: true,
                });
                await this.notify("success", t(this.lang, 'ap_scan_qr_within_5min'));
              });

            }

            this.setState({
              depositstate: 2
            });
          }
        }
        else {
          await this.notify("warning", t(this.lang, 'ap_min_deposit_prefix') + this.state.limit.min + t(this.lang, 'ap_max_deposit_mid') + this.state.limit.max + ' ');

        }
      }
      else if (num === 5) {
        document.getElementById("truemonney").click()
      }
      else if (num === 6) {
        document.getElementById("depositPaymentModalxz").click()
      }
      else {
        this.setState({
          depositstate: 0
        });
      }
    }



  }
  notify = async (mode, msg) => {
    console.log(mode, msg);
    if (mode == "success") {
      await toast.success(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeonClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    else if (mode == "warning") {
      await toast.warning(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeonClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    else if (mode == "error") {
      await toast.error(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeonClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    else if (mode == "info") {
      await toast.info(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeonClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    await this.waitnotify();
  }
  waitnotify = async () => {
    setTimeout(() => { console.log('World!') }, 5000)
  }
  redeemrank = async (e, index) => {
    e.preventDefault();

    var token = localStorage.getItem('auth_token');
    if (token != null) {
      var decoded = jwt_decode(token);
      var Username = decoded.message.playerid;
      Swal.fire({
        icon: 'warning',
        title: t(this.lang, 'ap_claim_rank_question'),
        showCancelButton: true,
        confirmButtonText: 'Save',
      }).then(async (result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          await instance.post("/api/v1/userredeemrank", {
            User_id: Username,
            rankno: index.no,
            System: Systems,
            amount: index.claimamount
          }, {
            headers: { Authorization: `Bearer ${token}` }
          }).then(async (res) => {
            if (res.data.status === 200) {
              const datas = res.data.message;
              this.calllisthistory(Username);
              this.checklogin();
              Swal.fire(t(this.lang, 'ap_action_done'), '', 'success')
            }
            else {
              Swal.fire(t(this.lang, 'ap_action_failed_wait'), '', 'error')
            }
          });

        }
      })
    }

  }
  async opencliamcashout(evt, cityName) {
    var token = localStorage.getItem('auth_token');
    if (token != null) {
      var decoded = jwt_decode(token);
      var Username = decoded.message.playerid;
      await instance.post("/api/v1/cliamcashout", {
        userid: Username,
        System: Systems,
      }, {
        headers: { Authorization: `Bearer ${token}` }
      }).then(async (res) => {
        if (res.data.status === 200) {
          var decoded = jwt_decode(token);
          var Username = decoded.message.playerid;
          this.rechecklogin(Username, token);
          await Swal.fire({
            title: 'Success!',
            text: t(this.lang, 'ap_received_money_done'),
            icon: 'success',
            confirmButtonText: t(this.lang, 'ap_ok')
          })

        }
        else if (res.data.status === 201) {
          await Swal.fire({
            title: 'error!',
            text: t(this.lang, 'ap_no_balance'),
            icon: 'error',
            confirmButtonText: t(this.lang, 'ap_ok')
          })
          return false;
        }
        else if (res.data.status === 202) {
          await Swal.fire({
            title: 'error!',
            text: t(this.lang, 'ap_action_failed'),
            icon: 'error',
            confirmButtonText: t(this.lang, 'ap_ok')
          })
          return false;
        }

      }).catch(async (err) => {
        if (err.response.status === 401 || err.response.status === 403) {
          localStorage.clear();
          await Swal.fire({
            title: 'Warning!',
            text: t(this.lang, 'ap_session_expired'),
            icon: 'warning',
            confirmButtonText: t(this.lang, 'ap_ok')
          })
          window.location.href = '/';
        }
      });
    }
  }

  resetpassword = async (e, type) => {
    e.preventDefault();
    const { tblpaymentgatewayx, phoneNumber, fname, password, oldpassword, passwordcf, checkboxacc, accnumbertxt } = this.state;
    console.log(type, password, oldpassword, passwordcf);
    var token = localStorage.getItem('auth_token');
    if (password === passwordcf) {
      var Username = null;
      var decoded = null;
      if (type === 1 && token != null) {
        decoded = jwt_decode(token);
        Username = decoded.message.playerid;
        instance.post("/api/v1/resetpassword", {
          username: Username,
          oldpass: oldpassword,
          System: Systems,
          newpass: password,
          type: type
        }, {
          headers: { Authorization: `Bearer ${token}` }
        }).then(async (res) => {
          if (res.data.status === 200) {
            await Swal.fire({
              title: 'Success!',
              text: t(this.lang, 'ap_password_changed'),
              icon: 'Success',
              confirmButtonText: t(this.lang, 'ap_ok')
            })
          }
          else if (res.data.status === 201) {
            await Swal.fire({
              title: 'error!',
              text: t(this.lang, 'ap_old_password_wrong'),
              icon: 'error',
              confirmButtonText: t(this.lang, 'ap_ok')
            })
          }
          else if (res.data.status === 203) {
            await Swal.fire({
              title: 'error!',
              text: t(this.lang, 'ap_error_try_again'),
              icon: 'error',
              confirmButtonText: t(this.lang, 'ap_ok')
            })
          }
          else if (res.data.status === 202) {
            await Swal.fire({
              title: 'error!',
              text: t(this.lang, 'ap_same_password'),
              icon: 'error',
              confirmButtonText: t(this.lang, 'ap_ok')
            })
          }
        });
      }
      else if (type === 2) {
        instance.post("/api/v1/resetpassword", {
          username: phoneNumber,
          oldpass: oldpassword,
          newpass: password,
          System: Systems,
          type: type
        }).then(async (res) => {
          if (res.data.status === 200) {
            await Swal.fire({
              title: 'success!',
              text: t(this.lang, 'ap_password_changed'),
              icon: 'success',
              confirmButtonText: t(this.lang, 'ap_ok')
            })
          }
          else if (res.data.status === 201) {
            await Swal.fire({
              title: 'error!',
              text: t(this.lang, 'ap_old_password_wrong'),
              icon: 'error',
              confirmButtonText: t(this.lang, 'ap_ok')
            })
          }
          else if (res.data.status === 203) {
            await Swal.fire({
              title: 'error!',
              text: t(this.lang, 'ap_error_try_again'),
              icon: 'error',
              confirmButtonText: t(this.lang, 'ap_ok')
            })
          }
          else if (res.data.status === 202) {
            await Swal.fire({
              title: 'error!',
              text: t(this.lang, 'ap_same_password'),
              icon: 'error',
              confirmButtonText: t(this.lang, 'ap_ok')
            })
          }
        });
      }
      else if (type === 3) {
        instance.post("/api/v1/resetpassword", {
          username: phoneNumber,
          oldpass: oldpassword,
          newpass: password,
          System: Systems,
          type: type
        }).then(async (res) => {
          if (res.data.status === 200) {
            await Swal.fire({
              title: 'success!',
              text: t(this.lang, 'ap_password_changed'),
              icon: 'success',
              confirmButtonText: t(this.lang, 'ap_ok')
            })
          }
          else if (res.data.status === 201) {
            await Swal.fire({
              title: 'error!',
              text: t(this.lang, 'ap_old_password_wrong'),
              icon: 'error',
              confirmButtonText: t(this.lang, 'ap_ok')
            })
          }
          else if (res.data.status === 203) {
            await Swal.fire({
              title: 'error!',
              text: t(this.lang, 'ap_error_try_again'),
              icon: 'error',
              confirmButtonText: t(this.lang, 'ap_ok')
            })
          }
          else if (res.data.status === 202) {
            await Swal.fire({
              title: 'error!',
              text: t(this.lang, 'ap_same_password'),
              icon: 'error',
              confirmButtonText: t(this.lang, 'ap_ok')
            })
          }
        });
      }
    }
    else {
      await Swal.fire({
        title: 'error!',
        text: t(this.lang, 'ap_password_mismatch'),
        icon: 'error',
        confirmButtonText: t(this.lang, 'ap_ok')
      })
    }
  }


  nextstep = async (e, num) => {
    e.preventDefault();
    const { stateregis, phoneNumber, checkboxacc, fname, otpphone, accnumbertxt } = this.state

    console.log(num);
    if (num === 1) {
      const check = await this.forgetotpandregister(6);
      console.log(1, phoneNumber.length, check.checked);
      if (phoneNumber.length === 10 && check.checked) {
        this.setState({
          stateregis: 2
        });
      }
      else {
        if (phoneNumber.length !== 10) {
          this.setState({
            stateopterror: t(this.lang, 'ap_phone_invalid')
          });
        }
        else if (!check.checked && check.status === 201) {
          this.setState({
            stateopterror: t(this.lang, 'ap_phone_in_use')
          });
        }
        else {
          this.setState({
            stateopterror: t(this.lang, 'ap_too_frequent')
          });
        }

        document.getElementById("phoneNumber").style = "border-color: #ef4444;";
        document.getElementById("checkotpforgetphonenormal").style.display = "block";
      }
    }
    else if (num === 2) {

      if (checkboxacc !== 0 && fname !== "" && accnumbertxt !== "") {
        this.setState({
          stateregis: 3
        });
      }
      else {
        await Swal.fire({
          title: 'Warning!',
          text: t(this.lang, 'ap_select_bank_or_complete'),
          icon: 'warning',
          confirmButtonText: t(this.lang, 'ap_ok')
        })
      }
    }
    else if (num === 3) {
      this.setState({
        stateregis: 4
      });
    }
    else if (num === 5) {
      var check = await this.forgetotpandregister(7);
      if (otpphone !== "" && check.checked) {
        this.setState({
          stateregis: 2
        });
      }
      else if (otpphone === "" || otpphone.length < 4) {
        this.setState({
          stateopterror: t(this.lang, 'ap_otp_incomplete')
        });
        document.getElementById("otpphone").style = "border-color: #ef4444;";
        document.getElementById("checkotp").style.display = "block";
      }

      else {
        this.setState({
          stateopterror: t(this.lang, 'ap_otp_wrong')
        });
        document.getElementById("otpphone").style = "border-color: #ef4444;";
        document.getElementById("checkotp").style.display = "block";
      }



    }
    else if (num === 11) {
      this.setState({
        stateregis: 1
      });
    }
    else if (num === 22) {
      this.setState({
        stateregis: 2
      });
    }
  }

  forgetotpandregister = async (type) => {
    const { phoneNumber, otpphoneforget, otpphone } = this.state;
    var recheck = false;
    if (type === 4) {
      await instance.post("/api/v1/resetpassword", {
        username: phoneNumber,
        System: Systems,
        type: type
      }).then(async (res) => {
        recheck = res.data.message;
      });
    }
    else if (type === 5) {
      await instance.post("/api/v1/resetpassword", {
        username: phoneNumber,
        pin: otpphoneforget,
        System: Systems,
        type: type
      }).then(async (res) => {
        recheck = res.data.message;

      });
    }
    else if (type === 6) {
      await instance.post("/api/v1/resetpassword", {
        username: phoneNumber,
        System: Systems,
        type: type
      }).then(async (res) => {
        recheck = res.data.message;
      });
    }
    else if (type === 7) {
      await instance.post("/api/v1/resetpassword", {
        username: phoneNumber,
        pin: otpphone,
        System: Systems,
        type: type
      }).then(async (res) => {
        recheck = res.data.message;

      });
    }
    return recheck
  }

  nextstepforget = async (e, num) => {
    e.preventDefault();
    console.log(num);
    const { phoneNumber, otpphoneforget } = this.state
    if (num === 1) {
      const check = await this.forgetotpandregister(4);
      if (phoneNumber.length === 10 && check.checked) {
        this.setState({
          stateforget: 2
        });
      }
      else {
        if (phoneNumber.length !== 10) {
          this.setState({
            stateopterror: t(this.lang, 'ap_phone_invalid')
          });
        }
        else if (!check.checked && check.status === 201) {
          this.setState({
            stateopterror: t(this.lang, 'ap_phone_not_found')
          });
        }
        else {
          this.setState({
            stateopterror: t(this.lang, 'ap_too_frequent')
          });
        }
        document.getElementById("phoneNumberforget").style = "border-color: #ef4444;";
        document.getElementById("checkotpforgetphone").style.display = "block";
      }
    }
    else if (num === 2) {
      const check = await this.forgetotpandregister(5)
      console.log(check)
      if (otpphoneforget !== "" && check.checked) {
        this.setState({
          stateforget: 3
        });
      }
      else if (otpphoneforget === "" || otpphoneforget.length < 4) {
        this.setState({
          stateopterror: t(this.lang, 'ap_otp_incomplete')
        });
        document.getElementById("otpphoneforget").style = "border-color: #ef4444;";
        document.getElementById("checkotpforget").style.display = "block";
      }
      else {
        this.setState({
          stateopterror: t(this.lang, 'ap_otp_wrong')
        });
        document.getElementById("otpphoneforget").style = "border-color: #ef4444;";
        document.getElementById("checkotpforget").style.display = "block";
      }

    }
    else if (num === 11) {
      this.setState({
        stateforget: 1
      });
    }
  }

  submitwithdraw = async (e) => {
    if (parseFloat(this.state.withdrawamount) <= parseFloat(this.state.balance)) {
      if (parseFloat(this.state.withdrawamount) >= 100) {
        var token = localStorage.getItem('auth_token');
        if (token != null) {
          var decoded = jwt_decode(token);
          var Username = decoded.message.playerid;
          instance.post("/api/v1/userwithdraw", {
            User_id: Username,
            System: Systems,
            amount: this.state.withdrawamount
          }, {
            headers: { Authorization: `Bearer ${token}` }
          }).then(async (res) => {
            if (res.data.status === 200) {
              await Swal.fire({
                title: 'Success!',
                text: t(this.lang, 'ap_withdraw_done'),
                icon: 'success',
                confirmButtonText: t(this.lang, 'ap_ok')
              })
              window.location.reload(false);
            }
            else if (res.data.status === 206) {
              await Swal.fire({
                title: 'Success!',
                text: t(this.lang, 'ap_withdraw_partial_prefix') + res.data.amountturnover + t(this.lang, 'ap_withdraw_partial_suffix'),
                icon: 'success',
                confirmButtonText: t(this.lang, 'ap_ok')
              })
            }
            else if (res.data.status === 203) {
              await Swal.fire({
                title: 'Error!',
                text: t(this.lang, 'ap_turnover_remaining_prefix') + res.data.amountturnover + t(this.lang, 'ap_turnover_remaining_suffix'),
                icon: 'error',
                confirmButtonText: t(this.lang, 'ap_ok')
              })
            }
          });
        }
        else {
          await Swal.fire({
            title: 'error!',
            text: t(this.lang, 'ap_withdraw_problem'),
            icon: 'error',
            confirmButtonText: t(this.lang, 'ap_ok')
          })
        }
      }
      else {
        await Swal.fire({
          title: 'Warning!',
          text: t(this.lang, 'ap_min_withdraw_100'),
          icon: 'warning',
          confirmButtonText: t(this.lang, 'ap_ok')
        })
      }
    }
    else {
      await Swal.fire({
        title: 'Warning!',
        text: t(this.lang, 'ap_withdraw_insufficient'),
        icon: 'warning',
        confirmButtonText: t(this.lang, 'ap_ok')
      })
    }

  }

  onChangex = event => {


    if (event.target !== undefined) {
      let nam;
      let val;
      if (event.target.name === "otpphone") {
        document.getElementById("otpphone").style = "";
        document.getElementById("checkotp").style.display = "none";
      }
      else if (event.target.name === "phoneNumber") {
        document.getElementById("phoneNumberforget").style = "";
        document.getElementById("checkotpforgetphone").style.display = "none";
      }
      else if (event.target.name === "otpphoneforget") {
        document.getElementById("otpphoneforget").style = "";
        document.getElementById("checkotpforget").style.display = "none";
      }
      else if (event.target.name === "otpphoneforget") {
        document.getElementById("phoneNumber").style = "";
        document.getElementById("checkotpforgetphonenormal").style.display = "none";
      }

      if (event.target.name === undefined) {
        nam = event.name;
        val = event.value;
      } else {
        nam = event.target.name;
        val = event.target.value;
      }
      this.setState({ [nam]: val });
    }
  };

  logout = (e) => {

  }

  openchangepassword = (e) => {
    e.preventDefault();
    // เปิดเป็น modal แยกเหมือนต้นฉบับ (แทน collapse inline ที่พัง)
    try {
      if (window.jQuery) {
        window.jQuery('#accountModal').modal('hide');
        window.jQuery('#accountModalMobile').modal('hide');
        window.jQuery('#changePasswordModal').modal('show');
      }
    } catch (err) { }
  }

  cancelwithdraw = async (e, index) => {
    e.preventDefault();
    var token = localStorage.getItem('auth_token');
    if (token != null) {
      var decoded = jwt_decode(token);
      var Username = decoded.message.playerid;
      Swal.fire({
        icon: 'warning',
        title: t(this.lang, 'ap_cancel_withdraw_question'),
        showCancelButton: true,
        confirmButtonText: 'Save',
      }).then(async (result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          await instance.post("/api/v1/userwithdrawcancel", {
            User_id: Username,
            tid: index.tid,
            System: Systems,
            amount: index.amount
          }, {
            headers: { Authorization: `Bearer ${token}` }
          }).then(async (res) => {
            if (res.data.status === 200) {
              const datas = res.data.message;
              this.calllisthistory(Username);
              Swal.fire(t(this.lang, 'ap_action_done'), '', 'success')
            }
            else {
              Swal.fire(t(this.lang, 'ap_action_failed_wait'), '', 'error')
            }
          });

        }
      })
    }

  }

  cancelredeempromotion = async (e, index) => {
    e.preventDefault();
    var token = localStorage.getItem('auth_token');
    if (token != null) {
      var decoded = jwt_decode(token);
      var Username = decoded.message.playerid;
      Swal.fire({
        icon: 'warning',
        title: t(this.lang, 'ap_cancel_promo_question'),
        showCancelButton: true,
        confirmButtonText: 'Save',
      }).then(async (result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          await instance.post("/api/v1/usercancelpromotion", {
            User_id: Username,
            no: index.no,
            System: Systems,
          }, {
            headers: { Authorization: `Bearer ${token}` }
          }).then(async (res) => {
            if (res.data.status === 200) {
              this.checkpro(null, 999);
              Swal.fire(t(this.lang, 'ap_action_done'), '', 'success')
            }
            else {
              Swal.fire(t(this.lang, 'ap_action_failed_wait'), '', 'error')
            }
          });

        }
      })
    }

  }
  couponredeem = async (e, index) => {
    e.preventDefault();
    var token = localStorage.getItem('auth_token');
    if (token != null) {
      var decoded = jwt_decode(token);
      var Username = decoded.message.playerid;
      await instance.post("/api/v1/usercoupon", {
        User_id: Username,
        System: Systems,
        couponkey: this.state.couponkey,
        type: 1
      }).then(async (res) => {
        if (res.data.status === 200) {
          const datas = res.data.message;
          await Swal.fire({
            title: 'Success!',
            text: t(this.lang, 'ap_coupon_used_done'),
            icon: 'success',
            confirmButtonText: t(this.lang, 'ap_ok')
          })
        }
        else {
          await Swal.fire({
            title: 'Warning!',
            text: t(this.lang, 'ap_coupon_not_found'),
            icon: 'warning',
            confirmButtonText: t(this.lang, 'ap_ok')
          })
        }
      });
    }

  }

  async calllisthistory(userid) {
    await instance.post("/api/v1/userwithdrawlist", {
      userid: userid,
      Cat_ID: 0,
      System: Systems,
      page: 1,
      type: 1
    }).then((res) => {
      if (res.data.status === 200) {
        const datas = res.data.message;
        this.setState({
          historylist: datas.withdrawlist
        });

      }
      else {
      }
    });

  }


  promotionlist = () => {
    instance.post("/api/v1/getpromotion", {
      System: Systems,
    }).then(async (res) => {
      if (res.data.status === 200) {
        this.setState({
          prolistx: res.data.message,
        });
      }
    }).catch(async (err) => {

      if (err.response.status === 401 || err.response.status === 403) {
        localStorage.clear();
        await Swal.fire({
          title: 'Warning!',
          text: t(this.lang, 'ap_session_expired'),
          icon: 'warning',
          confirmButtonText: t(this.lang, 'ap_ok')
        })
        window.location.href = '/';
      }
    });
  }
  async saveclickaff(linkid) {
    await instance.post("/api/v1/saveclickaff", {
      linkid: linkid,
      System: Systems,
    }).then((res) => {
      if (res.data.status == 200) {
        var date = new Date()
        this.setState({
          userrecomend: res.data.username,
          link: linkid
        });
        var username = res.data.username
        var object = { date, username }
        localStorage.setItem('aff', JSON.stringify(object))
      }
    }).catch(async (err) => {
    });

  }
  async componentDidMount() {
    try { if (window.jQuery) { window.jQuery(document).off("show.bs.modal.switchfix").on("show.bs.modal.switchfix", "#loginModal, #registerModal", function () { var o = this.id === "loginModal" ? "#registerModal" : "#loginModal"; window.jQuery(o).modal("hide"); }); } } catch (e) {}
    const endpoint = "https://apisock.newworld.center";
    const socket = io.connect(endpoint);
    var roomid = Systems;
    var obj = { roomid }
    var json = JSON.stringify(obj);
    socket.on('connect', function (data) {
      var roomid = "alphasix"
      var obj = { roomid }
      var json = JSON.stringify(obj);
      socket.emit('new', json);
    });
    const space = window.location.host
    const search = window.location.href;
    var test = search.split("aff=")[1]
    if (test != undefined) {
      this.saveclickaff(test.split("&")[0]);

    }

    var params = search.split("reg=")[1]
    if (params != undefined) {
      this.saveclick(params);
      this.setState({
        userrecomend: params.split("&")[0],
      });
    }


    var token = localStorage.getItem('register');
    if (token != null) {

      var codev = JSON.parse(token)
      console.log(1359, codev);
      var Username = codev.username;

      this.setState({
        userrecomend: Username,
      });
    }


    token = localStorage.getItem('aff');
    if (token != null) {
      codev = JSON.parse(token)
      console.log(1370, codev);
      Username = codev.username;
      this.setState({
        userrecomend: Username,
      });
    }
    this.promotionlist();
    this.checkpro(null, 999)
    try {
      const cacheKey = "mainSettingCache";
      const cacheTTL = 6 * 60 * 60 * 1000; // 6 ชั่วโมงในมิลลิวินาที
      const cachedData = JSON.parse(localStorage.getItem(cacheKey));
  
      if (cachedData && (Date.now() - cachedData.timestamp < cacheTTL)) {
          console.log("Using cached data for main setting");
          const data = cachedData.data;
  
          this.setState({
              maxwithdrawstatus: data.tblcatagoryx[0].withdrawmax,
              linelink: data.message[1].value,
              webnamex: data.message[7].value,
              logoimg: data.tblsetting && data.tblsetting[0] ? data.tblsetting[0].imglogo : "",
              System: data.tblcatagoryx[0].System,
              cashoutSet: data.tblcashoutsetting[0],
              inviteSet: data.tblinvitedsetting[0],
              datas: data.message,
              limit: {
                  min: data.tblcatagoryx[0].limitdeposit,
                  max: data.tblcatagoryx[0].maxdeposit,
              },
          });
      } else {
          await instance.post("/api/v1/mainsetting", {
              System: Systems,
          }).then((res) => {
              if (res.data.status === 200) {
                  const datas = res.data.message;
                  const min = res.data.tblcatagoryx[0].limitdeposit;
                  const max = res.data.tblcatagoryx[0].maxdeposit;
                  const maxwithdrawstatus = res.data.tblcatagoryx[0].withdrawmax;
                  const limit = { min, max };
  
                  this.setState({
                      maxwithdrawstatus: maxwithdrawstatus,
                      linelink: datas[1].value,
                      webnamex: datas[7].value,
                      logoimg: res.data.tblsetting && res.data.tblsetting[0] ? res.data.tblsetting[0].imglogo : "",
                      System: res.data.tblcatagoryx[0].System,
                      cashoutSet: res.data.tblcashoutsetting[0],
                      inviteSet: res.data.tblinvitedsetting[0],
                      datas: datas,
                      limit: limit,
                  });
  
                  localStorage.setItem(cacheKey, JSON.stringify({
                      timestamp: Date.now(),
                      data: res.data,
                  }));
              } else {
              }
          });
      }
  } catch (ex) {
      console.log(ex);
  }
  

    await this.checklogin();
    await this.getpopup();
  }

  onChange = async event => {

    if (event.target !== undefined) {
      let nam;
      let val;
      if (event.target.name === undefined) {
        nam = event.name;
        val = event.value;
      } else {
        nam = event.target.name;
        val = event.target.value;
      }
      if (nam === "withdrawamount") {

        if (this.state.maxwithdrawstatus === 1) {

          this.setState({ [nam]: this.state.balance });
          await Swal.fire({
            title: 'Warning!',
            text: t(this.lang, 'ap_force_withdraw_all'),
            icon: 'warning',
            confirmButtonText: t(this.lang, 'ap_ok')
          })
        }
        else if (Number(val) <= Number(this.state.balance)) {
          this.setState({ [nam]: val });
        }
        else {
          await Swal.fire({
            title: 'Warning!',
            text: t(this.lang, 'ap_withdraw_insufficient'),
            icon: 'warning',
            confirmButtonText: t(this.lang, 'ap_ok')
          })
        }
      } else {
        this.setState({ [nam]: val });
      }

    }
  };

  async checkuseradvice() {
    instance.post("/api/v1/checkuseradvice", {
      User_id: this.state.username,
      page: 1,
      System: Systems,
    }).then((res) => {
      if (res.data.status === 200) {
        console.log(res.data.message.useradvicelist);
        this.setState({
          useradvice: res.data.message.useradvicelist
        });
      }
      else {
      }
    });
  }

  closemodal = async (e) => {

    console.log(1159, this.state.checkboxcookie);
    if (this.state.checkboxcookie) {
      var date = new Date()
      var checked = this.state.checkboxcookie
      var object = { date, checked }
      console.log(object);
      localStorage.setItem('cookie', JSON.stringify(object))
    }
  }

  async recheckbox() {
    var checked = false;
    if (this.state.checkboxcookie) checked = false;
    else checked = true;
    this.setState({
      checkboxcookie: checked,
    });

  }

  async checklogin() {

    var token = localStorage.getItem('auth_token');
    if (token != null) {
      var cookie = localStorage.getItem('cookie');
      console.log(1188, cookie);
      if (cookie != 'null' && cookie != null) {
        var persons = JSON.parse(cookie);
        if (persons.checked != null) {
          this.setState({

            checkboxcookie: persons.checked,
          });
        }
      }

      var decoded = jwt_decode(token);
      var Username = decoded.message.playerid;
      await this.rechecklogin(Username, token);
    }
    else {
      this.setState({
        loginstate: false,
      });
    }
  }

  redeem = (e) => {
    e.preventDefault();
    console.log('tag', this.state.loginstate);
    if (!this.state.loginstate) {
      var title = 'error'
      var text = t(this.lang, 'ap_not_login')
      var object = { title, text }
      this.modalerror(object);
    }
    else {
      window.location.href = '/promotions';
    }
  }

  redeemlink = (e, link) => {
    e.preventDefault();
    console.log('tag', this.state.loginstate);
    if (!this.state.loginstate) {
      var title = 'error'
      var text = t(this.lang, 'ap_not_login')
      var object = { title, text }
      this.modalerror(object);
    }
    else {
      window.location.href = link;
    }
  }


  async modalerror(object) {
    await Swal.fire({
      title: object.title + "!",
      text: object.text,
      icon: object.title,
      confirmButtonText: t(this.lang, 'ap_ok')
    })
  }
  validatergisterForm = async (e) => {
    e.preventDefault();
    const { phoneNumber, fname, password, passwordcf, checkboxacc, accnumbertxt } = this.state;

    if (password.length < 6) {
      var title = 'Error!'
      var text = t(this.lang, 'ap_password_min6')
      var object = { title, text }
      this.modalerror(object);
    }

    else if (phoneNumber === "") {

      title = 'Error!'
      text = t(this.lang, 'ap_no_phone_input')
      object = { title, text }
      this.modalerror(object);

    }
    else if (accnumbertxt === "") {
      title = 'Error!'
      text = t(this.lang, 'ap_no_account_input')
      object = { title, text }
      this.modalerror(object);

    }
    else if (fname === "") {

      title = 'Error!'
      text = t(this.lang, 'ap_no_name_input')
      object = { title, text }
      this.modalerror(object);

    }
    else if (checkboxacc === 0) {
      title = 'Error!'
      text = t(this.lang, 'ap_no_bank_selected')
      object = { title, text }
      this.modalerror(object);
    }
    else if (password !== passwordcf) {
      title = 'Error!'
      text = t(this.lang, 'ap_register_pass_mismatch')
      object = { title, text }
      this.modalerror(object);
    }

    else {
      instance.post("/api/v1/register", {
        User_id: phoneNumber,
        name: fname,
        password: password,
        accbank: checkboxacc,
        accno: accnumbertxt,
        System: Systems,
        Useradvise: this.state.userrecomend
      })
        .then(async (res) => {
          if (res.data.status === 200) {
            await Swal.fire({
              title: 'Success!',
              text: t(this.lang, 'ap_register_done_login'),
              icon: 'success',
              confirmButtonText: t(this.lang, 'ap_ok')
            })
            window.location.href = '/';
          }
          else if (res.data.status === 202) {
            this.setState({
              errorstatus: 1,
              errortext: t(this.lang, 'ap_username_taken')
            });
          }
          else {
            this.setState({
              errorstatus: 1,
              errortext: t(this.lang, 'ap_username_or_name_invalid')
            });
          }
        });
    }


  }



  rechecklogin = async (Username, token) => {
    try {

      console.log(1406, Username);
      const search = window.location.href;
      const paramx = new URLSearchParams(search);
      const space = window.location.host
      var userhash = md5(Username);
      const linkaff = "https://" + space + "/register?reg=" + userhash;
      await instance.post("/api/v1/checkpoint", {
        userid: Username,
        System: Systems,
        Update: userhash,
        Function: 'rechecklogin-App.js'
      }, {
        headers: { Authorization: `Bearer ${token}` }
      }).then(async (res) => {
        console.log(1751, res.data);
        if (res.data.status === 200) {

          await instance.post("/api/v1/gettrue", {
            userid: Username,
            System: Systems,
          }, {
            headers: { Authorization: `Bearer ${token}` }
          }).then(async (res) => {
            if (res.data.status === 200) {
              console.log(res.data," true account data");
              this.setState({
                trueaccount: res.data.message.tbltruewallet[0],
              });

            }
          }).catch(async (err) => {
          });
          this.calllisthistory(Username);
          console.log(443, res.data);
          localStorage.setItem('auth_token', res.data.token)
          var rankall = res.data.tblrankall;
          const found = rankall.find(obj => {
            return obj.checked === 1;
          });

          this.setState({
            tblrankall: res.data.tblrankall,
            linkaff: linkaff,
            buttoncliam: (found === undefined) ? true : false,
            tblnextrank: res.data.tblnextrank,
            rankpic: (res.data.tblrank.image == null || res.data.tblrank.image == "") ? "https://apixgen.javisx.com/build/rank/1.jpeg" : (res.data.tblrank.picrack == null || res.data.tblrank.picrack == "") ? "https://apixgen.javisx.com/build/rank/" + res.data.tblrank.image : res.data.tblrank.picrack,
            rankname: res.data.tblrank.name,
            rankob: res.data.tblrank,
            tblprofile: res.data.message,
            rankpoint: res.data.rankpoint,
            accnumber: res.data.message.accnumber,
            userid: res.data.message.member_id,
            username: res.data.message.playerid,
            fullname: res.data.message.firstname,
            point: res.data.message.Point,
            balance: res.data.databalance,
            loginstate: true,
          });
        }
        else if (res.data.status === 401) {
          localStorage.clear();
          await Swal.fire({
            title: 'Warning!',
            text: t(this.lang, 'ap_session_expired'),
            icon: 'warning',
            confirmButtonText: t(this.lang, 'ap_ok')
          })
          window.location.href = '/';
        }

      }).catch(async (err) => {
        if (err.response.status === 401 || err.response.status === 403) {
          localStorage.clear();
          await Swal.fire({
            title: 'Warning!',
            text: t(this.lang, 'ap_session_expired'),
            icon: 'warning',
            confirmButtonText: t(this.lang, 'ap_ok')
          })
          window.location.href = '/';
        }
      });
    }
    catch (ex) {
    }

  }


  render() {
    const { prolistx, cashoutSet, trueaccount, stateopterror, changepassword, username, balance, accnumber, fullname, mainacc, limit, rankob, rankpoint, tblnextrank, userrecomend, linkaff, tblprofile, proderedeem, proderedeemlist, prodetail } = this.state
    const lang = this.lang;



    var accnumberx;
    var limits = limit
    if (accnumber != null) {
      accnumberx = accnumber[0];
    }

    return (
      <div className="-full-flex-wrap ">
        {/* </div> <div className="-full-flex-inner-bg -bg"> */}
        <div className="">
          <div className="d-none d-lg-block">
            <div className="x-feed-news-header">
              <div className="-feed-news-inner-wrapper" data-animatable="fadeInUp" data-delat={200}>
                <div className="-icon-container">
                  <i className="fas fa-volume-up" />
                </div>
                <div className="-track">
                  <div className="-track-item -duration-normal-content">
                    {(SiteConfig.TextSlide[this.lang] || SiteConfig.TextSlide.th)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <MainSettingContext.Provider value={{ ...(this.state.mainsettingData || {}) }}>
        <BrowserRouter >

          <Routes>
            <Route path="/*" element={<Main />} />
            <Route path="/casino" element={<Casino />} />
            <Route path="/slot" element={<Slot />} />
            <Route path="/sport" element={<Sport />} />
            <Route path="/arcade" element={<Arcade />} />
            <Route path="/fising" element={<Fising />} />
            <Route path="/loss" element={<Loss />} />
            <Route path="/Lucky-fortune" element={<Luckyfortune />} />
            <Route path="/affiliate" element={<Affiliate />} />
            <Route path="/promotions" element={<Promotion />} />
            <Route path="/freegame" element={<Freegame />} />
            <Route path="/listgameall/*" element={<Linklistall />} />
            <Route path="/listgamealldemo/*" element={<Linklistalldemo />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/register/*" element={<Register />} />
            <Route path='/Paoyingchub' element={<Promotion />} />
            <Route path="/toprank" element={<Toprank />} />
            <Route path="/strategy" element={<Strategy />} />
            <Route path="/event" element={<Event />} />
            <Route path="/redeemreward" element={<Redeemreward />} />
            <Route path="/rebate" element={<Rebate />} />
            <Route path="/deposit2" element={<Deposit2 />} />
          </Routes>
        </BrowserRouter>
        </MainSettingContext.Provider>
        <footer className="x-footer ">
          <div className="container-fluid -footer-wrapper">
            <div className="-footer-inner-wrapper">
              <div className="-describe-wrapper">
                <div className="-content-wrapper">
                  <h6 className="-title">
                    {t(this.lang,'ap2_footer_title_a')}<br /> {t(this.lang,'ap2_footer_title_b')}
                  </h6>
                  <h6 className="-content">
                    {t(this.lang,'ap2_footer_content')}
                  </h6>
                </div>
              </div>
              <div className="-tag-wrapper">
                <div className="-content-wrapper">
                  <div className="-title">TAG</div>
                  <div className="container x-footer-seo">
                    <div className="-tags">
                      <a href="/" className="btn">
                        Ae sexy
                      </a>
                      <a href="/" className="btn">
                        Ae sexy casino
                      </a>
                      <a href="/" className="btn">
                        Ae sexycasino
                      </a>
                      <a href="/" className="btn">
                        {t(this.lang,'ap2_tag_casino')}
                      </a>
                      <a href="/" className="btn">
                        {t(this.lang,'ap2_tag_casino_online')}
                      </a>
                      <a href="/" className="btn">
                        {t(this.lang,'ap2_tag_baccarat')}
                      </a>
                      <a href="/" className="btn">
                        Ae sexybet
                      </a>
                      <a href="/" className="btn">
                        Ae sexy 55
                      </a>
                      <a href="/" className="btn">
                        Ae sexy bet444
                      </a>
                      <a href="/" className="btn">
                        Ae sexygaming
                      </a>
                      <a href="/" className="btn">
                        Ae sexycasino gaming
                      </a>
                      <a href="/" className="btn">
                        {t(this.lang,'ap2_tag_live_casino')}
                      </a>
                      <a href="/" className="btn">
                        bet online
                      </a>
                      <a href="/" className="btn">
                        Ae sexylive casino
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="-provider-wrapper">
                <div className="px-3">
                  <div
                    className="x-contact-directly"
                    data-animatable="fadeInUp"
                    data-delay={100}
                  >
                    <div className="-text-wrapper -empty">
                    </div>
                    <div className="-qr-wrapper -empty"></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="-footer-bottom-wrapper">
              <div>
                <a
                  href="/termcondition"
                  target="_blank"
                  className="-term-btn"
                >
                  Terms and Conditions
                </a>
              </div>
              <div>
                <p className="mb-0">Copyright © 2021Ae sexyCasino All Rights Reserved.</p>
              </div>
            </div>
          </div>
        </footer>
        <div className="modal x-modal -social-share-main-modal -v2 social-share-modal-1"
          id="socialsharemodal1"
          data-loading-container=".js-modal-content"
          data-ajax-modal-always-reload="true"
          tabIndex={-1}
          role="dialog"
          aria-hidden="true"
        >
          <div
            className="modal-dialog -modal-size  modal-dialog-centered modal-dialog-scrollable -modal-medium -modal-social-share"
            role="document"
          >
            <div className="modal-content -modal-content">
              <button
                type="button"
                className="close f-1 "
                data-dismiss="modal"
                aria-label="Close"
              >
                <i className="fas fa-times" />
              </button>
              <div className="modal-header -modal-header">
                <h3 className="x-title-modal m-auto">{t(lang,'ap_share_earn_title')}</h3>
              </div>
              <div className="modal-body -modal-body">
                <div className="-social-share-header">
                  <div className="-img-container">
                    <img
                      className="-img img-fluid"
                      src="https://ae-sexy.bet/media/cache/strip/202109/social-promotion/b5028d57f2bd5215f70a78bfe4f98715.png"
                      alt="แชร์ แลก ทรัพย์"
                    />
                  </div>
                </div>
                <div className="d-flex flex-column">
                  <div id="form-social-share-container">
                    <div className="-social-share-form">
                      <div>
                        <p>
                          1. {t(lang,'ap_go_to_page')}{" "}
                          <b>
                            <a
                              href="#"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Ae sexy
                            </a>
                          </b>
                          <a
                            href="#"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {" "}
                          </a>{" "}
                          {t(lang,'ap_share_pinned_post')}
                        </p>
                        <p>
                          2. {t(lang,'ap_copy_caption_hashtag')}
                          {t(lang,'ap_paste_caption_hashtag')}
                        </p>
                        <p>
                          * {t(lang,'ap_fb_public_share')}
                          {t(lang,'ap_like_page')}{" "}
                          <b>
                            <a
                              href="#"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Ae sexy
                            </a>
                          </b>
                          <br />
                          ** {t(lang,'ap_copy_each_link')}
                          {t(lang,'ap_attach_evidence_each')}
                          <br />
                          3. {t(lang,'ap_share_complete_attach')}
                          {t(lang,'ap_to_get_bonus')}
                          <br />
                          4. {t(lang,'ap_admin_check_next_day')}
                          {t(lang,'ap_credit_after_check')}
                          {t(lang,'ap_no_evidence_forfeit')}<br />*
                          {t(lang,'ap_real_active_account')}
                          {t(lang,'ap_for_verification')}
                          <br />* {t(lang,'ap_fb_friends_300')}
                          {t(lang,'ap_people_more')}
                          <br />*
                          {t(lang,'ap_group_public_1000')}
                          {t(lang,'ap_people_more2')}
                          <br />* {t(lang,'ap_limit_1_per_day')}
                          <br />
                        </p>
                        <p>
                          **{t(lang,'ap_withdraw_share_condition')}
                          {t(lang,'ap_within_14_days')}**
                        </p>
                      </div>
                      * {t(lang,'ap_member_must')}<u className="-text-link">{t(lang,'ap_open_public_post')}</u>
                      {t(lang,'ap_verify_or_forfeit')}
                      <hr className="x-hr-border-primary" />
                      <form
                        noValidate=""
                        name="social_share_submit"
                        method="post"
                        data-loading-container=".modal-body"
                        data-container=".x-social-share-main-modal"
                        data-ajax-form="/account/_ajax_/social-share-submit/1/create"
                      >
                        <div className="-social-share-detail-container">
                          <div className="row flex-wrap -text-step-container">
                            <div className="col-sm-6">
                              <div className="-text-step-container-wrapper">
                                <div className="-number-container">1</div>
                                <div className="-text-step-detail">
                                  <div>
                                    {t(lang,'ap_copy_caption_comment')}
                                    {t(lang,'ap_paste_caption_hashtag2')}
                                  </div>
                                  <a
                                    role="button"
                                    className="btn mt-2 js-copy-to-clipboard -social-share-btn"
                                    data-container="form-social-share-container"
                                    data-message={"<i class='fas fa-check'></i> " + t(lang,'ap2_share_copied_msg')}
                                    data-copy-me={t(lang,'ap2_share_caption')}
                                    data-html="true"
                                  >
                                    <i className="fas fa-copy" /> {t(lang,'ap_copy')}
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-6 mt-sm-0 mt-3">
                              <div className="-text-step-container-wrapper">
                                <div className="-number-container">2</div>
                                <div className="-text-step-detail">
                                  <div>
                                    {t(lang,'ap_share_now_good')}
                                  </div>
                                  <a
                                    href="#"
                                    target="_blank"
                                    className="btn btn-primary mt-2 -social-share-btn"
                                  >
                                    <div>
                                      <i className="fas fa-share mr-2" />
                                      <span>{t(lang,'ap_share_now')}</span>
                                    </div>
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-6 mt-3">
                              <div className="-text-step-container-wrapper">
                                <div className="-number-container">3</div>
                                <div className="-text-step-detail">
                                  <div>
                                    {t(lang,'ap_attach_evidence_get')}
                                    {t(lang,'ap_bonus_wait_confirm')}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row justify-content-center">
                          <div className="-form-container col-12 col-sm-10">
                            <div className="-x-input-icon mt-3">
                              <i className="fas fa-link -icon" />
                              <input
                                type="text"
                                id="social_share_submit_links_0"
                                name="social_share_submit[links][0]"
                                required="required"
                                inputMode="url"
                                className="x-form-control js-ss-input-link form-control"
                                placeholder={t(lang,'ap_evidence_link1')}
                              />
                            </div>
                            <div className="-x-input-icon mt-3">
                              <i className="fas fa-link -icon" />
                              <input
                                type="text"
                                id="social_share_submit_links_1"
                                name="social_share_submit[links][1]"
                                required="required"
                                inputMode="url"
                                className="x-form-control js-ss-input-link form-control"
                                placeholder={t(lang,'ap_evidence_link2')}
                              />
                            </div>
                            <div className="-x-input-icon mt-3">
                              <i className="fas fa-link -icon" />
                              <input
                                type="text"
                                id="social_share_submit_links_2"
                                name="social_share_submit[links][2]"
                                required="required"
                                inputMode="url"
                                className="x-form-control js-ss-input-link form-control"
                                placeholder={t(lang,'ap_evidence_link3')}
                              />
                            </div>
                            <div className="text-center -btn-wrapper">
                              <button
                                type="submit"
                                className="btn btn-primary -submit js-promotion-submit-btn"
                                disabled=""
                              >
                                <i className="fas fa-upload mr-2" />
                                <span>{t(lang,'ap_send_evidence')}</span>
                              </button>
                            </div>
                          </div>
                        </div>
                        <input
                          type="hidden"
                          id="social_share_submit__token"
                          name="social_share_submit[_token]"
                          defaultValue="8nAUfnfxPzJzIkOFtYeozOYW4F-ob5rBvmL74L8oJl0"
                        />
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="x-modal modal -alert-modal"
          id="alertModal"
          tabIndex={-1}
          role="dialog"
          aria-hidden="true"
          data-loading-container=".js-modal-content"
          data-ajax-modal-always-reload="true"
          data-animatable="fadeInRight"
          data-delay={700}
          data-dismiss-alert="true"
        >
          <div className="modal-dialog -modal-size  " role="document">
            <div className="modal-content -modal-content">
              <button
                type="button"
                className="close f-1 "
                data-dismiss="modal"
                aria-label="Close"
              >
                <i className="fas fa-times" />
              </button>
              <div className="modal-body -modal-body">
                <div className="d-flex -alert-body">
                  <div className="text-center mr-3 -alert-body-wrapper">
                    <img
                      src="/build/web/igame-index-lobby-wm/img/ic-alert-success.png"
                      alt="SUCCESS"
                      className="-img-alert js-ic-success img-fluid lazyload"
                    />
                    <img
                      src="/build/web/igame-index-lobby-wm/img/ic-alert-failed.png"
                      alt="FAIL"
                      className="-img-alert js-ic-fail img-fluid lazyload"
                    />
                  </div>
                  <div className="my-auto js-modal-content -title" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="x-modal modal  "
          id="notificationCenterModal"
          tabIndex={-1}
          role="dialog"
          aria-hidden="true"
          data-loading-container=".modal-body"
          data-ajax-modal-always-reload="true"
          data-container="#notificationCenterModal .modal-body"
        >
          <div
            className="modal-dialog -modal-size  modal-dialog-centered modal-dialog-scrollable "
            role="document"
          >
            <div className="modal-content -modal-content">
              <button
                type="button"
                className="close f-1 "
                data-dismiss="modal"
                aria-label="Close"
              >
                <i className="fas fa-times" />
              </button>
              <div className="modal-header -modal-header">
                <div className="-outer-wrapper">
                  <img
                    src="/build/web/igame-index-lobby-ae-sexy/img/notification-title-bg.png"
                    className="-title-bg"
                    alt="Notification bg image png"
                    width={320}
                    height={64}
                  />
                  <h3 className="x-title-modal">
                    <img
                      src="/build/web/igame-index-lobby-ae-sexy/img/notification-ic-bell.png"
                      className="-ic-title"
                      alt="Notification icon bell image png"
                      width={40}
                      height={40}
                    />
                    <span className="-text">{t(lang,'ap_notify_board')}</span>
                  </h3>
                </div>
              </div>
              <div className="modal-body -modal-body">
                <div className="js-modal-content" />
              </div>
            </div>
          </div>
        </div>

        <div
          className="x-modal modal "
          id="loginModal"
          tabIndex={-1}
          role="dialog"
          aria-hidden="true"
          data-loading-container=".js-modal-content"
          data-ajax-modal-always-reload="true"

        >
          <div
            className="modal-dialog -modal-size modal-dialog-centered modal-dialog-scrollable -dialog-in-tab"
            role="document"

          >
            <div className="modal-content -modal-content" >
              <button
                type="button"
                className="close f-1 -in-tab"
                data-dismiss="modal"
                aria-label="Close"
              >
                <i className="fas fa-times" />
              </button>
              <div className="x-modal-account-security-tabs">
                <a
                  style={{ textDecoration: "none" }}
                  type="button"
                  data-target="#registerModal" data-toggle="modal"
                  className="-btn -register"
                >
                  {t(lang,'ap_register')}
                </a>
                <button
                  type="button"
                  data-toggle="modal"
                  className="-btn -login js-modal-account-security-tab-button -active"
                  data-modal-target="#loginModal"
                >
                  {t(lang,'ap_login')}
                </button>
              </div>
              <div className="modal-body -modal-body">
                <Login />
              </div>
            </div>
          </div>
        </div>
        <div
          className="x-modal modal "
          id="registerModal"
          tabIndex={-1}
          role="dialog"
          aria-hidden="true"
          data-container="#registerModal"
        >
          <div
            className="modal-dialog -modal-size modal-dialog-centered modal-dialog-scrollable "
            role="document"
          >
            <div className="modal-content -modal-content">
              <button
                type="button"
                className="close f-1 -in-tab"
                data-dismiss="modal"
                aria-label="Close"
              >
                <i className="fas fa-times" />
              </button>
              <div className="x-modal-account-security-tabs">
                <button
                  type="button"
                  data-target="#registerModal" data-toggle="modal"
                  className="-btn -register js-modal-account-security-tab-button -active"
                >
                  {t(lang,'ap_register')}
                </button>
                <button
                  type="button"
                  className="-btn -login js-modal-account-security-tab-button "
                  data-modal-target="#loginModal"
                >
                  {t(lang,'ap_login')}
                </button>
              </div>
              <div className="modal-body -modal-body">
                <Register />
              </div>
            </div>
          </div>
        </div>
        <div
          className="x-modal modal "
          id="resetPasswordModal"
          tabIndex={-1}
          role="dialog"
          aria-hidden="true"
          data-container="#resetPasswordModal"
        >
          <div
            className="modal-dialog -modal-size modal-dialog-centered modal-dialog-scrollable "
            role="document"
          >
            <div className="modal-content -modal-content">
              <button
                type="button"
                className="close f-1 "
                data-dismiss="modal"
                aria-label="Close"
              >
                <i className="fas fa-times" />
              </button>
              <div className="modal-header -modal-header">
                <h3 className="x-title-modal m-auto">{t(lang,'ap_forgot_password_title')}</h3>
              </div>
              <div className="modal-body -modal-body">
                <div className="x-modal-separator-container ">
                  <div className="-top " style={{ display: this.state.stateforget === 1 ? "" : "none" }}>
                    <div className="text-center d-flex flex-column">
                      <div className="text-center -img-container">
                        <img
                          src="/build/web/igame-index-lobby-wm/img/ic-reset-password.png"
                          alt="ลืมรหัสผ่าน"
                          className="img-fluid -ic-register"
                          width={160}
                          height={101}
                        />
                      </div>
                      <div className="-x-input-icon mb-3 flex-column text-center">
                        <img
                          src="/build/web/igame-index-lobby-wm/img/ic-input-phone.png"
                          className="-icon img-fluid"
                          alt="SA Casino phone icon"
                          width={10}
                          height={14}
                        />
                        <input
                          type="text"
                          onChange={this.onChangex}
                          id="phoneNumberforget"
                          name="phoneNumber"
                          required="required"
                          pattern="[0-9]*"
                          className="x-form-control form-control"
                          placeholder={t(lang,'ap_phone_registered_placeholder')}
                          autoFocus="autoFocus"
                          autoComplete="on"
                          inputMode="text"
                        />
                        <div id="checkotpforgetphone" className="invalid-feedback ">
                          <ul className="list-unstyled mb-0"><li>{stateopterror}</li></ul>
                        </div>
                      </div>
                      <div className="text-center">
                        <button
                          type="submitx"
                          onClick={(e) => {
                            this.nextstepforget(e, 1)
                          }}
                          className="btn  btn-primary my-lg-3 mt-0"
                        >
                          {t(lang,'ap_confirm')}
                        </button>
                      </div>
                    </div>
                    <input

                      type="hidden"
                      id="forgetpassword"
                      name="forgetpassword"
                      defaultValue="HqmR014dfy9ntoczFlsBdXJxpTTrQApRUP7nq2Q8zsc"
                    />
                  </div>
                  <div className="-top " style={{ display: this.state.stateforget === 2 ? "" : "none" }}>
                    <h3 className="x-title-modal mx-auto text-center ">
                      {t(lang,'ap_confirm_otp')}
                    </h3>
                    <div className="-img-container text-center">
                      <picture>
                        {/* <source
                          type="image/webp"
                          srcSet="https://sacasino.co/build/web/ezc-sa-casino/img/register-icon-otp-v2.webp"
                        />
                        <source
                          type="image/png?v=5"
                          srcSet="https://sacasino.co/build/web/ezc-sa-casino/img/register-icon-otp-v2.webp"
                        />
                        <img
                          alt="กรอกรหัส OTP เพื่อยืนยันตัวตน"
                          className="img-fluid -ic-otp"
                          width={150}
                          height={150}
                          src="https://sacasino.co/build/web/ezc-sa-casino/img/register-icon-otp-v2.webp"
                        /> */}
                      </picture>
                    </div>

                    <div className="-fake-inner-body">
                      <div >
                        <div className="-x-input-icon mb-3 text-center">
                          <img
                            src="/build/web/igame-index-lobby-wm/img/ic-input-phone.png"
                            className="-icon"
                            alt="SA Casino phone icon"
                            width={10}
                            height={14}
                          />
                          <input
                            onChange={this.onChangex}
                            type="text"
                            id="otpphoneforget"
                            name="otpphoneforget"
                            required="required"
                            pattern="[0-9]*"
                            maxLength="4"
                            className="x-form-control form-control"
                            placeholder={t(lang,'ap_otp_4digit_placeholder')}
                            autoFocus="autoFocus"
                            autoComplete="on"
                            inputMode="text"
                          />
                          <div id="checkotpforget" className="invalid-feedback ">
                            <ul className="list-unstyled mb-0"><li>{stateopterror}</li></ul>
                          </div>
                        </div>
                        <div className="text-center">
                          <a href="#0" style={{ cursor: "pointer" }}
                            onClick={(e) => {
                              this.nextstepforget(e, 11)
                            }} className="text-muted mt-3">
                            {t(lang,'ap_cancel')}
                          </a>
                        </div>
                        <div className="text-center">

                          <button
                            onClick={(e) => {
                              this.nextstepforget(e, 2)
                            }}
                            type="submitx"
                            className="btn   btn-primary mt-lg-3 mt-0"
                            disabled=""
                          >
                            {t(lang,'ap_next')}
                          </button>
                        </div>
                        <input
                          type="hidden"
                          id="request_otp__token"
                          name="request_otp[_token]"
                          defaultValue="ds26nEjb1GacmW8racC7ScvGiCgTEnPl5xKWBzZyMWc"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="-top " style={{ display: this.state.stateforget === 3 ? "" : "none" }}>
                    <h3 className="x-title-modal mx-auto text-center ">
                      {t(lang,'ap_confirm_password_title')}
                    </h3>
                    <div className="-fake-inner-body">
                      <div >
                        <div className="text-center">
                          <div className="-x-input-icon mb-3 text-center">
                            <img
                              src="/build/web/igame-index-lobby-wm/img/ic-input-lock.png"
                              className="-icon"
                              alt="SA Casino phone icon"
                              width={10}
                              height={14}
                            />
                            <input
                              onChange={this.onChangex}
                              type="password"
                              id="password"
                              name="password"
                              required="required"
                              className="x-form-control form-control"
                              placeholder={t(lang,'ap_enter_password_placeholder')}
                              autoFocus="autoFocus"
                              autoComplete="on"
                              inputMode="text"
                            />
                          </div>
                          <div className="-x-input-icon mb-3 text-center">
                            <img
                              src="/build/web/igame-index-lobby-wm/img/ic-input-lock.png"
                              className="-icon"
                              alt="SA Casino phone icon"
                              width={10}
                              height={14}
                            />
                            <input
                              onChange={this.onChangex}
                              type="password"
                              id="passwordcf"
                              name="passwordcf"
                              required="required"
                              className="x-form-control form-control"
                              placeholder={t(lang,'ap_enter_password_placeholder')}
                              autoFocus="autoFocus"
                              autoComplete="on"
                              inputMode="text"
                            />
                            <div className="mt-3 -spacer  text-center" style={{ display: (this.state.errorstatus ? "" : "none") }}>
                              <div className="x-danger-zone -v2  text-center">
                                <span>{this.state.errortext}</span>
                              </div>
                            </div>
                          </div>
                          <a
                            href="#0" style={{ cursor: "pointer" }}
                            onClick={(e) => {
                              this.nextstepforget(e, 11)
                            }} className="text-muted mt-3">
                            {t(lang,'ap_cancel')}
                          </a>
                          <button
                            onClick={(e) => {
                              this.resetpassword(e, 2)
                            }}
                            type="submitx"
                            className="btn btn-primary mt-lg-3 mt-0 -submit"
                            disabled=""
                          >
                            {t(lang,'ap_confirm')}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="-bottom ">
                    <div className="x-admin-contact ">
                      <span className="x-text-with-link-component">
                        <label className="-text-message ">{t(lang,'ap_found_problem')}</label>
                        <a
                          href={this.state.linelink}
                          className="-link-message "
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <u>{t(lang,'ap_contact_support')}</u>
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="x-modal modal "
          id="alertModal"
          tabIndex={-1}
          role="dialog"
          aria-hidden="true"
          data-loading-container=".js-modal-content"
          data-ajax-modal-always-reload="true"
        >
          <div className="modal-dialog -modal-size  " role="document">
            <div className="modal-content -modal-content">
              <button
                type="button"
                className="close f-1 "
                data-dismiss="modal"
                aria-label="Close"
              >
                <i className="fas fa-times" />
              </button>
              <div className="modal-header -modal-header">
                <h3 className="x-title-modal d-inline-block m-auto">
                  <span>{t(lang,'ap_notify')}</span>
                </h3>
              </div>
              <div className="modal-body -modal-body">
                <div className="text-center my-3">
                  <img
                    src="/build/web/igame-index-lobby-wm/img/ic-alert-success.png"
                    alt="SUCCESS"
                    className="js-ic-success -img img-fluid lazyload"
                    width={100}
                    height={100}
                  />
                  <img
                    src="/build/web/igame-index-lobby-wm/img/ic-alert-failed.png"
                    alt="FAIL"
                    className="js-ic-fail -img img-fluid lazyload"
                    width={100}
                    height={100}
                  />
                </div>
                <div className="js-modal-content text-center f-4" />
              </div>
            </div>
          </div>
        </div>
        <div className="x-right-sidebar-container"></div>
        <div
          className="x-modal modal "
          id="themeSwitcherModal"
          tabIndex={-1}
          role="dialog"
          aria-hidden="true"
          data-loading-container=".js-modal-content"
          data-ajax-modal-always-reload="true"
        >
          <div
            className="modal-dialog -modal-size modal-dialog-centered modal-dialog-scrollable modal-dialog-centered modal-dialog-scrollable"
            role="document"
          >
            <div className="modal-content -modal-content">
              <div className="modal-body -modal-body">
                <div className="x-theme-switcher">
                  <ul className="nav">
                    <li
                      className="nav-item -sa "
                      data-animatable="fadeInUp"
                      data-delay={100}
                    >
                      <a href="/" className="nav-link" rel="ugc,nofollow">
                        <img
                          src="/build/web/shared/img/logo-sa-1.png"
                          alt="SA Casino คาสิโนออนไลน์ สล็อตออนไลน์ ดีที่สุดในประเทศไทย logo png"
                          className="-logo"
                          width={50}
                          height={50}
                        />
                        <div className="-text">SA Casino</div>
                      </a>
                    </li>
                    <li
                      className="nav-item -label -active"
                      data-animatable="fadeInUp"
                      data-delay={100}
                    >
                      <a href="/" className="nav-link" rel="ugc,nofollow">
                        <img
                          src="/build/web/shared/img/logo-wm-1.png"
                          alt="Ae sexy  Casino คาสิโนออนไลน์ สล็อตออนไลน์ ดีที่สุดในประเทศไทย logo png"
                          className="-logo"
                          width={50}
                          height={50}
                        />
                        <div className="-text">Ae sexy  Casino</div>
                      </a>
                    </li>
                    <li
                      className="nav-item -sexy "
                      data-animatable="fadeInUp"
                      data-delay={100}
                    >
                      <a href="/" className="nav-link" rel="ugc,nofollow">
                        <img
                          src="/build/web/shared/img/logo-sexy-1.png"
                          alt="Sexy Gaming คาสิโนออนไลน์ สล็อตออนไลน์ ดีที่สุดในประเทศไทย logo png"
                          className="-logo"
                          width={50}
                          height={50}
                        />
                        <div className="-text">Sexy Gaming</div>
                      </a>
                    </li>
                    <li
                      className="nav-item -dream "
                      data-animatable="fadeInUp"
                      data-delay={100}
                    >
                      <a href="/" className="nav-link" rel="ugc,nofollow">
                        <img
                          src="/build/web/shared/img/logo-dream-1.png"
                          alt="Dream Gaming คาสิโนออนไลน์ สล็อตออนไลน์ ดีที่สุดในประเทศไทย logo png"
                          className="-logo"
                          width={50}
                          height={50}
                        />
                        <div className="-text">Dream Gaming</div>
                      </a>
                    </li>
                    <li
                      className="nav-item -pretty "
                      data-animatable="fadeInUp"
                      data-delay={100}
                    >
                      <a href="/" className="nav-link" rel="ugc,nofollow">
                        <img
                          src="/build/web/shared/img/logo-pretty-1.png"
                          alt="Pretty Gaming คาสิโนออนไลน์ สล็อตออนไลน์ ดีที่สุดในประเทศไทย logo png"
                          className="-logo"
                          width={50}
                          height={50}
                        />
                        <div className="-text">Pretty Gaming</div>
                      </a>
                    </li>
                    <li
                      className="nav-item -ae "
                      data-animatable="fadeInUp"
                      data-delay={100}
                    >
                      <a href="/" className="nav-link" rel="ugc,nofollow">
                        <img
                          src="/build/web/shared/img/logo-ae-1.png"
                          alt="Momobet คาสิโนออนไลน์ สล็อตออนไลน์ ดีที่สุดในประเทศไทย logo png"
                          className="-logo"
                          width={50}
                          height={50}
                        />
                        <div className="-text">Momobet</div>
                      </a>
                    </li>
                    <li
                      className="nav-item -allbet "
                      data-animatable="fadeInUp"
                      data-delay={100}
                    >
                      <a href="/" className="nav-link" rel="ugc,nofollow">
                        <img
                          src="/build/web/shared/img/logo-allbet-1.png"
                          alt="Allbet คาสิโนออนไลน์ สล็อตออนไลน์ ดีที่สุดในประเทศไทย logo png"
                          className="-logo"
                          width={50}
                          height={50}
                        />
                        <div className="-text">Allbet</div>
                      </a>
                    </li>
                    <li
                      className="nav-item -eg "
                      data-animatable="fadeInUp"
                      data-delay={100}
                    >
                      <a href="/" className="nav-link" rel="ugc,nofollow">
                        <img
                          src="/build/web/shared/img/logo-eg.png"
                          alt="Evo Gaming คาสิโนออนไลน์ สล็อตออนไลน์ ดีที่สุดในประเทศไทย logo png"
                          className="-logo"
                          width={50}
                          height={50}
                        />
                        <div className="-text">Evo Gaming</div>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* หน้าเลือกโปรก่อนเติม */}
        {/* <div
          className="x-modal modal chooseprodps show"
          id="depositChoosePromotionModal"
          tabIndex={-1}
          role="dialog"
          data-container="#depositChoosePromotionModal"
          style={{ paddingRight: 6 }}
          aria-modal="true"
        >
          <div
            className="modal-dialog -modal-size modal-dialog-centered modal-dialog-scrollable         -modal-bigger -modal-deposit-promotion -no-fixed-button
               "
            role="document"
          >
            <div className="modal-content -modal-content">
              <button
                type="button"
                className="close f-1 "
                data-dismiss="modal"
                aria-label="Close"
              >
                <i className="fas fa-times" />
              </button>
              <div className="modal-header -modal-header">
                <h3 className="x-title-modal m-auto">{t(lang,'ap_deposit')}</h3>
              </div>
              <div className="modal-body -modal-body">
                <div className="x-deposit-promotion d-flex flex-column">
                  <div className="-promotion-container row">

                    <a
                      href="#deposit"
                      className="col-md-4 col-sm-6 col-12 js-account-approve-aware js-cancel-promotion -promotion-card-link cancel-probtn"
                      data-toggle="modal"
                      data-dismiss="modal"
                      data-target="#depositModal"
                    >
                      <div className="x-card card -pure-deposit">
                        <div className="-img-container">
                          <img
                            src="/build/web/igame-index-lobby-wm/img/ic-promotion-not-received.png"
                            alt="บาคาร่า คาสิโน สล็อตออนไลน์ promotion default"
                            className="-img-no-accept-promotion -img img-fluid"
                          />
                        </div>
                        <div className="card-footer">

                          <button
                            onClick={(e) => this.confirmdeposit(e, 4)}
                            className="btn -btn -cancel-promotion-btn">
                            <span>{t(lang,'ap_topup')}</span>
                          </button>
                        </div>
                      </div>
                    </a>
                    <div className="col-md-4 col-sm-6 col-12 -promotion-card-link -real-content" >
                      <a className="d-block h-100 confirm-probtn"
                      >
                        <div className="x-card card  -pure-deposit">
                          <div className="-img-container ">
                            <img src="https://cdn.javisx.com/image/e9e975c7-f1b3-42dc-9e62-b2c5980c1196.png"
                              className="-img-no-accept-promotion -img img-fluid"
                              alt="ฝาก 1000 ฟรี 100 ไม่ติดเงื่อนไข"
                            />
                          </div>
                          <div className="card-footer">
                            <button className="btn -btn -cancel-promotion-btn" onClick={(e) => this.confirmdeposit(e, 6)}>
                              <span>{t(lang,'ap_topup_payment')}</span>
                            </button>
                            <button id="depositPaymentModalxz" style={{ display: "none" }} data-toggle="modal" data-target="#depositPaymentModal" data-dismiss="modal"  >
                            </button>
                          </div>
                        </div>
                      </a>
                    </div>
                    {this.state.tblPopupMenu2.map((listitem, i) => (
                      <div key={i} className="col-md-4 col-sm-6 col-12 -promotion-card-link -real-content">
                        <a
                          className="d-block h-100 confirm-probtn"
                        >
                          <div className="x-card card  -pure-deposit">
                            <div className="-img-container ">
                              <img
                                src={listitem.img}
                                className="-img-no-accept-promotion -img img-fluid"
                                alt="ฝาก 1000 ฟรี 100 ไม่ติดเงื่อนไข"
                                width={500}
                                height={500}
                              />
                            </div>
                            <div className="card-footer">
                              <button className="btn -btn -cancel-promotion-btn" onClick={(e) => this.confirmdepositweb(e, listitem.Popuplink)}>
                                <span>{listitem.PopupName}</span>
                              </button>
                            </div>
                          </div>
                        </a>
                      </div>
                    ))}
                  </div>
                  <div className="my-3 mt-auto">
                    <div className="x-admin-contact -bg -no-fixed">
                      <span className="x-text-with-link-component">
                        <label className="-text-message ">{t(lang,'ap_problem')}</label>
                        <a
                          href={this.state.linelink}
                          className="-link-message "
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <u>{t(lang,'ap_contact_support')}</u>
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        {/* หน้าเลือกโปรก่อนเติม */}
        {/* เติมเงิน */}
        <div
          className="x-modal modal show"
          id="depositModal"
          tabIndex={-1}
          role="dialog"
          style={{ paddingRight: 6 }}
          aria-modal="true"
        >
          <div
            className="modal-dialog -modal-size modal-dialog-centered modal-dialog-scrollable -modal-deposit"
            role="document"
          >
            <div className="modal-content -modal-content">
              <button
                type="button"
                className="close f-1 "
                data-dismiss="modal"
                aria-label="Close"
              >
                <i className="fas fa-times" />
              </button>
              <div className="modal-header -modal-header">
                <h3 className="x-title-modal m-auto">{t(lang,'ap_deposit')}</h3>
              </div>
              <div className="modal-body -modal-body">
                <div className="x-deposit-form">
                  <div className="row -deposit-container" style={{ display: (this.state.depositstate === 0 ? " none" : "") }} >
                    <div
                      data-animatable="fadeInModal"
                      className="col-lg order-lg-2 -form order-0  fadeInModal"
                    >
                      <div className="-deposit-notice-inner-wrapper">
                        <div className="x-deposit-notice  ">
                          <div className="my-3 -spacer" style={{ textAlign: "center" }}>
                            {this.state.qrcode !== null ?
                              <img
                                src={this.state.qrcode}
                                className="-img-text-promotion img-fluid ls-is-cached lazyloaded"
                                style={{ backgroundColor: "black" }}
                                alt=""
                                width={150}
                                height={50}
                              /> : ""
                            }
                          </div>
                          <div className="my-3 -spacer">
                            <div className="-fake-input py-3 m-auto h3 -value-deposit x-input-operator  -text-big ">
                              <input
                                type="text"
                                id="depoamount"
                                style={{ color: "black", font: "large" }}
                                value={this.state.depositamount}
                                disabled
                                name="deposit1"
                                required="required"
                                pattern="[0-9]*"
                                className="x-form-control -text-big text-center js-deposit-input-amount form-control"
                                placeholder={t(lang,'ap_min_deposit_100')}
                                inputMode="text"
                              />

                              <span className=""></span>
                            </div>
                          </div>
                          {mainacc !== null && mainacc !== undefined && mainacc !== '' ? <div className="mt-4 -spacer">
                            <div className="x-deposit-bank-info-container -v2">
                              <div className="media m-auto">
                                <img src={mainacc.img_path} className="-img rounded-circle" width="50" height="50" alt="bank-bay" />
                                <div className="-content-wrapper">
                                  <span className="-name">{t(lang,'ap_bank_prefix')}{mainacc.fullname_th}</span>
                                  <span className="-own-name">{mainacc.first_name_en + " " + mainacc.last_name_en} </span>
                                  <span id="depositBankNumber" className="-number">{
                                    mainacc.accnumber.substring(0, 3) + "-" + mainacc.accnumber.substring(3, 9) + "-" + mainacc.accnumber.substring(9, 12)
                                  }</span>
                                </div>
                                <div className="-copy-wrapper">
                                  <a role="button" style={{ cursor: "pointer" }} onClick={() => navigator.clipboard.writeText(mainacc.accnumber)} className="btn -btn js-copy-to-clipboard" data-container="depositModal" data-message={t(lang,'ap_copied')} data-copy-me={mainacc.accnumber}>{t(lang,'ap_copy')}</a>
                                </div>
                              </div>
                            </div>

                          </div> : ""}
                          <div className="mt-3 -spacer">
                            <div className="x-danger-zone -v2 ">
                              <span>{t(lang,'ap_use_registered_account_only')}</span>
                            </div>
                          </div>
                          <button
                            type="button"
                            onClick={(e) => {
                              this.confirmdeposit(e, 2)
                            }}
                            className="btn btn-block btn-primary  mt-4 "
                            data-dismiss="modal"
                          >
                            {t(lang,'ap_acknowledge')}
                          </button>
                          <div className="mt-4">
                            <div className="x-admin-contact -no-fixed">
                              <span className="x-text-with-link-component">
                                <label className="-text-message ">{t(lang,'ap_if_problem')}</label>
                                <a
                                  href={this.state.linelink}
                                  className="-link-message "
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <u>{t(lang,'ap_contact_support')}</u>
                                </a>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                  <div className="row -deposit-container" style={{ display: (this.state.depositstate === 1 ? " none" : "") }}>
                    <div
                      data-animatable="fadeInModal"
                      className="col-lg order-lg-2 -form order-0  fadeInModal"
                    >
                      <div className="-deposit-form-inner-wrapper">
                        <div
                          noValidate=""
                          name="deposit"
                          method="post"
                        >
                          {this.renderDepositChannelBar()}
                          {this.state.depositChannel === 'auto' && (<>
                          <div className="-modal-body-top">
                            <div className="text-center d-flex flex-column">

                              {proderedeem.length === 0 ?
                                <div className="m-auto">
                                  <img
                                    src="/build/web/igame-index-lobby-wm/img/ic-deposit-heading.png"
                                    className="img-fluid -ic-deposit"
                                    alt="ฝากเงินออโต้ 24 ชั่วโมง คาสืโนออนไลน์"
                                    width={140}
                                    height={140}
                                  />
                                </div>
                                : <div className="x-deposit-promotion-outer-container js-scroll-ltr -fade -on-left -on-right">
                                  <div className="x-deposit-promotion -v2 -slide pt-0" data-scroll-booster-container=".x-deposit-promotion-outer-container" data-scroll-booster-content=".x-deposit-promotion" style={{ transform: 'translate(0px, 0px)' }}>
                                    {proderedeem.map((listitem, i) => (
                                      <div key={i} className="-promotion-box-wrapper">
                                        <button type="button" className="btn -promotion-box-apply-btn js-promotion-apply" data-type="deposit" data-display-slide-mode="true">
                                          <img src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezc/ic-gift.png" className="-img" alt={listitem.proname} width={26} height={26} />
                                          <span className="-title">{listitem.proname}</span>
                                        </button>
                                        <a role="button" style={{ cursor: "pointer" }} className="-promotion-box-cancel-btn js-cancel-promotion d-none" data-display-slide-mode="true">
                                          <i className="fas fa-times" />
                                        </a>
                                      </div>
                                    ))}
                                  </div>
                                </div>}
                            </div>
                            <div className="-promotion-intro-deposit">
                              <a
                                href="#deposit-choose-promotion"
                                className="-deposit-back-btn js-account-approve-aware btn -back-btn"
                                data-toggle="modal"
                                data-target="#depositChoosePromotionModal"
                                data-dismiss="modal"
                              >
                                <div className="-text">{t(lang,'ap_want_promo')}</div>
                              </a>
                              <div className="js-promotion-active-html"></div>
                            </div>
                            <div className="-x-input-icon x-input-operator mb-4 flex-column">

                              <input
                                type="text"
                                id="depositamount"
                                onChange={this.onChangexdep}
                                value={this.state.depositamount}
                                name="depositamount"
                                required="required"
                                pattern="[0-9]*"
                                className="x-form-control -text-big text-center js-deposit-input-amount form-control"
                                placeholder={(limits === null) ? "" : t(lang,'ap_min_deposit_dyn_prefix') + limits.min + t(lang,'ap_max_dyn_mid') + limits.max + t(lang,'ap_baht_suffix')}
                                inputMode="text"
                              />
                            </div>
                            <div
                              className="x-select-amount js-quick-amount"
                              data-target-input="#deposit_amount"
                            >
                              <div className="-amount-container">
                                <button
                                  onClick={(e) => this.handleClickdeposit(e, 300)}
                                  type="button"
                                  className="btn btn-block -btn-select-amount"
                                  data-amount={300}
                                >
                                  <img
                                    src="/build/web/igame-index-lobby-wm/img/deposit-coin.png"
                                    className="-deposit-coin"
                                    alt=""
                                  />
                                  <span className="-no">300</span>
                                </button>
                              </div>
                              <div className="-amount-container">
                                <button
                                  type="button"
                                  onClick={(e) => this.handleClickdeposit(e, 500)}
                                  className="btn btn-block -btn-select-amount"
                                  data-amount={500}
                                >
                                  <img
                                    src="/build/web/igame-index-lobby-wm/img/deposit-coin.png"
                                    className="-deposit-coin"
                                    alt=""
                                  />
                                  <span className="-no">500</span>
                                </button>
                              </div>
                              <div className="-amount-container">
                                <button
                                  type="button"
                                  className="btn btn-block -btn-select-amount"
                                  onClick={(e) => this.handleClickdeposit(e, 1000)}
                                  data-amount={1000}
                                >
                                  <img
                                    src="/build/web/igame-index-lobby-wm/img/deposit-coin.png"
                                    className="-deposit-coin"
                                    alt=""
                                  />
                                  <span className="-no">1000</span>
                                </button>
                              </div>
                              <div className="-amount-container">
                                <button
                                  type="button"
                                  className="btn btn-block -btn-select-amount"
                                  onClick={(e) => this.handleClickdeposit(e, 2000)}
                                  data-amount={2000}
                                >
                                  <img
                                    src="/build/web/igame-index-lobby-wm/img/deposit-coin.png"
                                    className="-deposit-coin"
                                    alt=""
                                  />
                                  <span className="-no">2000</span>
                                </button>
                              </div>
                              <div className="-amount-container">
                                <button
                                  type="button"
                                  className="btn btn-block -btn-select-amount"
                                  onClick={(e) => this.handleClickdeposit(e, 5000)}
                                  data-amount={5000}
                                >
                                  <img
                                    src="/build/web/igame-index-lobby-wm/img/deposit-coin.png"
                                    className="-deposit-coin"
                                    alt=""
                                  />
                                  <span className="-no">5000</span>
                                </button>
                              </div>
                              <div className="-amount-container">
                                <button
                                  type="button"
                                  className="btn btn-block -btn-select-amount"
                                  onClick={(e) => this.handleClickdeposit(e, 10000)}
                                  data-amount={10000}
                                >
                                  <img
                                    src="/build/web/igame-index-lobby-wm/img/deposit-coin.png"
                                    className="-deposit-coin"
                                    alt=""
                                  />
                                  <span className="-no">10000</span>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div className="text-center">
                            <button
                              type="submitx"
                              onClick={(e) => this.confirmdeposit(e, 0)}
                              className="btn  btn-primary my-0 my-lg-3"
                            >
                              {t(lang,'ap_confirm')}
                            </button>
                          </div>
                          </>)}
                          {this.state.depositChannel === 'bank' && this.renderBankSlipPanel()}
                          {this.state.depositChannel === 'truewallet' && this.renderTrueWalletPanel()}
                          {this.state.depositChannel === 'true' && this.renderTrueDepositPanel()}
                          {this.state.depositChannel === 'crypto' && this.renderCryptoPanel()}
                          {this.state.depositChannel === 'auto' && (
                          <div className="x-admin-contact ">
                            <span className="x-text-with-link-component">
                              <label className="-text-message ">{t(lang,'ap_found_problem')}</label>
                              <a
                                href={this.state.linelink}
                                className="-link-message "
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <u>{t(lang,'ap_contact_support')}</u>
                              </a>
                            </span>
                          </div>
                          )}
                          <input
                            type="hidden"
                            id="deposit__token"
                            name="deposit[_token]"
                            defaultValue="d8iYDTklPETlCIEBA5CM4b1J9xZS1ZFfMKUoJ-c21fE"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="x-modal modal show"
          id="depositPaymentModal"
          tabIndex={-1}
          role="dialog"
          style={{ paddingRight: 6 }}
          aria-modal="true"
        >
          <div
            className="modal-dialog -modal-size modal-dialog-centered modal-dialog-scrollable -modal-deposit"
            role="document"
          >
            <div className="modal-content -modal-content">
              <button
                type="button"
                className="close f-1 "
                data-dismiss="modal"
                aria-label="Close"
              >
                <i className="fas fa-times" />
              </button>
              <div className="modal-header -modal-header">
                <h3 className="x-title-modal m-auto">{t(lang,'ap_deposit')}</h3>
              </div>
              <div className="modal-body -modal-body">
                <div className="x-deposit-form">
                  <div className="row -deposit-container" style={{ display: (this.state.depositstate === 0 ? " none" : "") }} >
                    <div
                      data-animatable="fadeInModal"
                      className="col-lg order-lg-2 -form order-0  fadeInModal"
                    >
                      <div className="-deposit-notice-inner-wrapper">
                        <div className="x-deposit-notice  ">
                          <div className="my-3 -spacer" style={{ textAlign: "center" }}>
                            {this.state.qrcode !== null ?
                              <img
                                src={this.state.qrcode}
                                className="-img-text-promotion img-fluid ls-is-cached lazyloaded"
                                style={{ backgroundColor: "black" }}
                                alt=""
                                width={150}
                                height={50}
                              /> : ""
                            }
                          </div>
                          <div className="my-3 -spacer">
                            <div className="-fake-input py-3 m-auto h3 -value-deposit x-input-operator  -text-big ">
                              <input
                                type="text"
                                id="depoamount"
                                style={{ color: "black", font: "large" }}
                                value={this.state.depositamount}
                                disabled
                                name="deposit1"
                                required="required"
                                pattern="[0-9]*"
                                className="x-form-control -text-big text-center js-deposit-input-amount form-control"
                                placeholder={t(lang,'ap_min_deposit_100')}
                                inputMode="text"
                              />

                              <span className=""></span>
                            </div>
                          </div>
                          {mainacc !== null && mainacc !== undefined && mainacc !== '' ? <div className="mt-4 -spacer">
                            <div className="x-deposit-bank-info-container -v2">
                              <div className="media m-auto">
                                <img src={mainacc.img_path} className="-img rounded-circle" width="50" height="50" alt="bank-bay" />
                                <div className="-content-wrapper">
                                  <span className="-name">{t(lang,'ap_bank_prefix')}{mainacc.fullname_th}</span>
                                  <span className="-own-name">{mainacc.first_name_en + " " + mainacc.last_name_en} </span>
                                  <span id="depositBankNumber" className="-number">{
                                    mainacc.accnumber.substring(0, 3) + "-" + mainacc.accnumber.substring(3, 9) + "-" + mainacc.accnumber.substring(9, 12)
                                  }</span>
                                </div>
                                <div className="-copy-wrapper">
                                  <a role="button" style={{ cursor: "pointer" }} onClick={() => navigator.clipboard.writeText(mainacc.accnumber)} className="btn -btn js-copy-to-clipboard" data-container="depositModal" data-message={t(lang,'ap_copied')} data-copy-me={mainacc.accnumber}>{t(lang,'ap_copy')}</a>
                                </div>
                              </div>
                            </div>

                          </div> : ""}
                          <div className="mt-3 -spacer">
                            <div className="x-danger-zone -v2 ">
                              <span>{t(lang,'ap_use_registered_account_only')}</span>
                            </div>
                          </div>
                          <button
                            type="button"
                            onClick={(e) => {
                              this.confirmdeposit(e, 2)
                            }}
                            className="btn btn-block btn-primary  mt-4 "
                            data-dismiss="modal"
                          >
                            {t(lang,'ap_acknowledge')}
                          </button>
                          <div className="mt-4">
                            <div className="x-admin-contact -no-fixed">
                              <span className="x-text-with-link-component">
                                <label className="-text-message ">{t(lang,'ap_if_problem')}</label>
                                <a
                                  href={this.state.linelink}
                                  className="-link-message "
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <u>{t(lang,'ap_contact_support')}</u>
                                </a>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                  <div className="row -deposit-container" style={{ display: (this.state.depositstate === 2 ? " none" : "") }}>
                    <div
                      data-animatable="fadeInModal"
                      className="col-lg order-lg-2 -form order-0  fadeInModal"
                    >
                      <div className="-deposit-form-inner-wrapper">
                        <div
                          noValidate=""
                          name="deposit"
                          method="post"
                        >
                          <div className="-modal-body-top">
                            <div className="text-center d-flex flex-column">

                              {proderedeem.length === 0 ?
                                <div className="m-auto">
                                  <img
                                    src="/build/web/igame-index-lobby-wm/img/ic-deposit-heading.png"
                                    className="img-fluid -ic-deposit"
                                    alt="ฝากเงินออโต้ 24 ชั่วโมง คาสืโนออนไลน์"
                                    width={140}
                                    height={140}
                                  />
                                </div>
                                : <div className="x-deposit-promotion-outer-container js-scroll-ltr -fade -on-left -on-right">
                                  <div className="x-deposit-promotion -v2 -slide pt-0" data-scroll-booster-container=".x-deposit-promotion-outer-container" data-scroll-booster-content=".x-deposit-promotion" style={{ transform: 'translate(0px, 0px)' }}>
                                    {proderedeem.map((listitem, i) => (
                                      <div key={i} className="-promotion-box-wrapper">
                                        <button type="button" className="btn -promotion-box-apply-btn js-promotion-apply" data-type="deposit" data-display-slide-mode="true">
                                          <img src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezc/ic-gift.png" className="-img" alt={listitem.proname} width={26} height={26} />
                                          <span className="-title">{listitem.proname}</span>
                                        </button>
                                        <a role="button" style={{ cursor: "pointer" }} className="-promotion-box-cancel-btn js-cancel-promotion d-none" data-display-slide-mode="true">
                                          <i className="fas fa-times" />
                                        </a>
                                      </div>
                                    ))}
                                  </div>
                                </div>}
                            </div>
                            <div className="-promotion-intro-deposit">
                              <a
                                href="#deposit-choose-promotion"
                                className="-deposit-back-btn js-account-approve-aware btn -back-btn"
                                data-toggle="modal"
                                data-target="#depositChoosePromotionModal"
                                data-dismiss="modal"
                              >
                                <div className="-text">{t(lang,'ap_want_promo')}</div>
                              </a>
                              <div className="js-promotion-active-html"></div>
                            </div>
                            <div className="-x-input-icon x-input-operator mb-4 flex-column">

                              <input
                                type="text"
                                id="depositamount"
                                onChange={this.onChangexdep}
                                value={this.state.depositamount}
                                name="depositamount"
                                required="required"
                                pattern="[0-9]*"
                                className="x-form-control -text-big text-center js-deposit-input-amount form-control"
                                placeholder={(limits === null) ? "" : t(lang,'ap_min_deposit_dyn_prefix') + limits.min + t(lang,'ap_max_dyn_mid') + limits.max + t(lang,'ap_baht_suffix')}
                                inputMode="text"
                              />
                            </div>
                            <div
                              className="x-select-amount js-quick-amount"
                              data-target-input="#deposit_amount"
                            >
                              <div className="-amount-container">
                                <button
                                  onClick={(e) => this.handleClickdeposit(e, 300)}
                                  type="button"
                                  className="btn btn-block -btn-select-amount"
                                  data-amount={300}
                                >
                                  <img
                                    src="/build/web/igame-index-lobby-wm/img/deposit-coin.png"
                                    className="-deposit-coin"
                                    alt=""
                                  />
                                  <span className="-no">300</span>
                                </button>
                              </div>
                              <div className="-amount-container">
                                <button
                                  type="button"
                                  onClick={(e) => this.handleClickdeposit(e, 500)}
                                  className="btn btn-block -btn-select-amount"
                                  data-amount={500}
                                >
                                  <img
                                    src="/build/web/igame-index-lobby-wm/img/deposit-coin.png"
                                    className="-deposit-coin"
                                    alt=""
                                  />
                                  <span className="-no">500</span>
                                </button>
                              </div>
                              <div className="-amount-container">
                                <button
                                  type="button"
                                  className="btn btn-block -btn-select-amount"
                                  onClick={(e) => this.handleClickdeposit(e, 1000)}
                                  data-amount={1000}
                                >
                                  <img
                                    src="/build/web/igame-index-lobby-wm/img/deposit-coin.png"
                                    className="-deposit-coin"
                                    alt=""
                                  />
                                  <span className="-no">1000</span>
                                </button>
                              </div>
                              <div className="-amount-container">
                                <button
                                  type="button"
                                  className="btn btn-block -btn-select-amount"
                                  onClick={(e) => this.handleClickdeposit(e, 2000)}
                                  data-amount={2000}
                                >
                                  <img
                                    src="/build/web/igame-index-lobby-wm/img/deposit-coin.png"
                                    className="-deposit-coin"
                                    alt=""
                                  />
                                  <span className="-no">2000</span>
                                </button>
                              </div>
                              <div className="-amount-container">
                                <button
                                  type="button"
                                  className="btn btn-block -btn-select-amount"
                                  onClick={(e) => this.handleClickdeposit(e, 5000)}
                                  data-amount={5000}
                                >
                                  <img
                                    src="/build/web/igame-index-lobby-wm/img/deposit-coin.png"
                                    className="-deposit-coin"
                                    alt=""
                                  />
                                  <span className="-no">5000</span>
                                </button>
                              </div>
                              <div className="-amount-container">
                                <button
                                  type="button"
                                  className="btn btn-block -btn-select-amount"
                                  onClick={(e) => this.handleClickdeposit(e, 10000)}
                                  data-amount={10000}
                                >
                                  <img
                                    src="/build/web/igame-index-lobby-wm/img/deposit-coin.png"
                                    className="-deposit-coin"
                                    alt=""
                                  />
                                  <span className="-no">10000</span>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div className="text-center">
                            <button
                              type="submitx"
                              onClick={(e) => this.confirmdeposit(e, 2)}
                              className="btn  btn-primary my-0 my-lg-3"
                            >
                              {t(lang,'ap_confirm')}
                            </button>
                          </div>
                          <div className="x-admin-contact ">
                            <span className="x-text-with-link-component">
                              <label className="-text-message ">{t(lang,'ap_found_problem')}</label>
                              <a
                                href={this.state.linelink}
                                className="-link-message "
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <u>{t(lang,'ap_contact_support')}</u>
                              </a>
                            </span>
                          </div>
                          <input
                            type="hidden"
                            id="deposit__token"
                            name="deposit[_token]"
                            defaultValue="d8iYDTklPETlCIEBA5CM4b1J9xZS1ZFfMKUoJ-c21fE"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="x-modal modal show"
          id="deposittruemoneyModal"
          tabIndex={-1}
          role="dialog"
          style={{ paddingRight: 6 }}
          aria-modal="true"
        >
          <div
            className="modal-dialog -modal-size modal-dialog-centered modal-dialog-scrollable -modal-deposit"
            role="document"
          >
            <div className="modal-content -modal-content">
              <button
                type="button"
                className="close f-1 "
                data-dismiss="modal"
                aria-label="Close"
              >
                <i className="fas fa-times" />
              </button>
              <div className="modal-header -modal-header">
                <h3 className="x-title-modal m-auto">{t(lang,'ap_deposit_truemoney_title')}</h3>
              </div>
              <div className="modal-body -modal-body">
                <div className="x-deposit-form">
                  <div className="row -deposit-container" >
                    <div
                      data-animatable="fadeInModal"
                      className="col-lg order-lg-2 -form order-0  fadeInModal"
                    >
                      <div className="-deposit-form-inner-wrapper">
                        <div
                          noValidate=""
                          name="deposit"
                          method="post"
                        >
                          <div className="-modal-body-top">
                            <div className="text-center d-flex flex-column">

                              {proderedeem.length === 0 ?
                                <div className="m-auto">
                                  <img
                                    src="/build/web/igame-index-lobby-wm/img/ic-deposit-heading.png"
                                    className="img-fluid -ic-deposit"
                                    alt="ฝากเงินออโต้ 24 ชั่วโมง คาสืโนออนไลน์"
                                    width={140}
                                    height={140}
                                  />
                                </div>
                                : <div className="x-deposit-promotion-outer-container js-scroll-ltr -fade -on-left -on-right">
                                  <div className="x-deposit-promotion -v2 -slide pt-0" data-scroll-booster-container=".x-deposit-promotion-outer-container" data-scroll-booster-content=".x-deposit-promotion" style={{ transform: 'translate(0px, 0px)' }}>
                                    {proderedeem.map((listitem, i) => (
                                      <div key={i} className="-promotion-box-wrapper">
                                        <button type="button" className="btn -promotion-box-apply-btn js-promotion-apply" data-type="deposit" data-display-slide-mode="true">
                                          <img src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezc/ic-gift.png" className="-img" alt={listitem.proname} width={26} height={26} />
                                          <span className="-title">{listitem.proname}</span>
                                        </button>
                                        <a role="button" style={{ cursor: "pointer" }} className="-promotion-box-cancel-btn js-cancel-promotion d-none" data-display-slide-mode="true">
                                          <i className="fas fa-times" />
                                        </a>
                                      </div>
                                    ))}

                                  </div>
                                </div>}
                            </div>
                            <div className="-promotion-intro-deposit">
                              <a
                                href="#"
                                className="-deposit-back-btn js-account-approve-aware btn -back-btn"
                              >
                                <div className="-text">

                                  <img
                                    style={{ display: (this.state.btnisActive) ? "none" : "" }}
                                    src="/build/web/igame-index-lobby-wm/img/please-wait-animation.gif"
                                    className="img-fluid -ic-deposit"
                                    alt="ฝากเงินออโต้ 24 ชั่วโมง คาสืโนออนไลน์"
                                    width={140}
                                    height={140}
                                  />
                                  <br></br>
                                  {this.state.statetrue}

                                </div>
                              </a>
                              <div className="js-promotion-active-html"></div>
                            </div>
                            <div className="-x-input-icon x-input-operator mb-4 flex-column">
                              <input
                                type="text"
                                id="depositamount"
                                onChange={this.onChangexgiftlink}
                                value={this.state.truegiftlink}
                                name="depositamount"
                                placeholder={t(lang,'ap_enter_gift_link_placeholder')}
                                required="required"
                                className="x-form-control -text-big text-center js-deposit-input-amount form-control"
                                inputMode="text"
                              />
                            </div>
                            {trueaccount !== null ? <div className="mt-4 -spacer" style={{ color: "black" }}>
                              <div className="x-deposit-bank-info-container -v2">
                                <div className="media m-auto">
                                  <img src="https://cdn.javisx.com/image/b96e16da-57f3-47f6-997a-77e06a58488f.png" className="-img rounded-circle" width="50" height="50" alt="bank-bay" />
                                  <div className="-content-wrapper">
                                    <span className="-name">{t(lang,'ap_wallet_prefix')}{trueaccount.telnumber}</span>
                                    <span className="-own-name">{trueaccount.name} </span>
                                    <span id="depositBankNumber" className="-number">{
                                      trueaccount.telnumber
                                    }</span>
                                  </div>
                                  <div className="-copy-wrapper">
                                    <a role="button" style={{ cursor: "pointer" }} onClick={() => navigator.clipboard.writeText(trueaccount.telnumber)} className="btn -btn js-copy-to-clipboard" data-container="depositModal" data-message={t(lang,'ap_copied')} data-copy-me={trueaccount.telnumber}>{t(lang,'ap_copy')}</a>
                                  </div>
                                </div>
                              </div>

                            </div> : ""}
                          </div>
                          <div className="text-center">
                            <button
                              type="submitx"
                              onClick={(e) => this.confirmdeposittrue(e, 0)}
                              className="btn  btn-primary my-0 my-lg-3"
                            >
                              {t(lang,'ap_confirm')}
                            </button>
                          </div>
                          <div className="x-admin-contact ">
                            <span className="x-text-with-link-component">
                              <label className="-text-message ">{t(lang,'ap_found_problem')}</label>
                              <a
                                href={this.state.linelink}
                                className="-link-message "
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <u>{t(lang,'ap_contact_support')}</u>
                              </a>
                            </span>
                          </div>
                          <input
                            type="hidden"
                            id="deposit__token"
                            name="deposit[_token]"
                            defaultValue="d8iYDTklPETlCIEBA5CM4b1J9xZS1ZFfMKUoJ-c21fE"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* เติมเงิน */}
        {/* หน้าถอนเงิน */}
        <div
          className="x-modal modal show"
          id="withdrawModal"
          tabIndex={-1}
          role="dialog"
          data-container="#withdrawModal"
          style={{ paddingRight: 6 }}
          aria-modal="true"
        >
          <div
            className="modal-dialog -modal-size modal-dialog-centered modal-dialog-scrollable -modal-mobile"
            role="document"
          >
            <div className="modal-content -modal-content">
              <button
                type="button"
                className="close f-1 "
                data-dismiss="modal"
                aria-label="Close"
              >
                <i className="fas fa-times" />
              </button>
              <div className="modal-header -modal-header">
                <h3 className="x-title-modal m-auto">{t(lang,'ap_withdraw')}</h3>
              </div>
              <div className="modal-body -modal-body">
                <div className="x-withdraw-form">
                  <div
                    noValidate=""
                    name="withdraw"
                    method="post"
                    data-ajax-form="/account/_ajax_/withdraw"
                    data-container="#withdrawModal"
                  >
                    <div
                      data-animatable="fadeInModal"
                      className="-animatable-container  fadeInModal"
                    >
                      <div className="text-center d-flex flex-column">
                        {/* บัญชีปลายทางที่จะรับเงินถอน */}
                        <div className="x-withdraw-bank-card">
                          <span className="-wd-label">{t(lang,'wd_to_account')}</span>
                          <div className="-wd-bank-row">
                            <img
                              className="-wd-bank-logo"
                              src={accnumber !== null ? accnumberx.img_path : ""}
                              onError={(e) => { e.target.onerror = null; e.target.style.display = "none"; }}
                              alt=""
                            />
                            <div className="-wd-bank-info">
                              <span className="-wd-bank-name">{accnumber !== null ? accnumberx.fullname_th : ""}</span>
                              <span className="-wd-acc-name">{fullname}</span>
                            </div>
                            <span className="-wd-acc-no">{accnumber !== null ? accnumberx.accno : ""}</span>
                          </div>
                        </div>
                        <div className="m-auto">
                          <img
                            src="/build/web/igame-index-lobby-wm/img/ic-withdraw-heading.png"
                            className="img-fluid -ic-withdraw"
                            alt="ถอนเงินออโต้ 24 ชั่วโมง คาสืโนออนไลน์"
                            width={140}
                            height={140}
                          />
                        </div>
                        <div className="-x-input-icon x-input-operator mb-3 flex-column">
                          {/* <button
                            type="button"
                            className="-icon-left -btn-icon js-adjust-amount-by-operator"
                            data-operator="-"
                            data-value={10}
                          > 
                            <i className="fas fa-minus-circle" />
                          </button>*/}
                          <input
                            type="text"
                            id="withdraw_amount"
                            onChange={this.onChange}
                            value={this.state.withdrawamount}
                            name="withdrawamount"
                            required="required"
                            pattern="[0-9]*"
                            className="x-form-control -text-big text-center js-withdraw-input-amount form-control"
                            placeholder={t(lang,'ap_min_withdraw_1')}
                            inputMode="text"
                          />
                          {/* <button
                            type="button"
                            className="-icon-right -btn-icon js-adjust-amount-by-operator"
                            data-operator="+"
                            data-value={10}
                          >
                            <i className="fas fa-plus-circle" />
                          </button> */}
                        </div>
                        <div
                          className="x-select-amount js-quick-amount"
                          data-target-input="#withdraw_amount"
                        >
                          <div className="-amount-container">
                            <button
                              onClick={(e) => this.handleClick(e, 100)}
                              type="button"
                              className="btn btn-block -btn-select-amount"
                              data-amount={100}
                            >
                              <img
                                src="/build/web/igame-index-lobby-wm/img/deposit-coin.png"
                                className="-deposit-coin"
                                alt=""
                              />
                              <span className="-no">100</span>
                            </button>
                          </div>
                          <div className="-amount-container">
                            <button
                              type="button"
                              onClick={(e) => this.handleClick(e, 300)}
                              className="btn btn-block -btn-select-amount"
                              data-amount={300}
                            >
                              <img
                                src="/build/web/igame-index-lobby-wm/img/deposit-coin.png"
                                className="-deposit-coin"
                                alt=""
                              />
                              <span className="-no">300</span>
                            </button>
                          </div>
                          <div className="-amount-container">
                            <button
                              type="button"
                              className="btn btn-block -btn-select-amount"
                              onClick={(e) => this.handleClick(e, 1000)}
                              data-amount={1000}
                            >
                              <img
                                src="/build/web/igame-index-lobby-wm/img/deposit-coin.png"
                                className="-deposit-coin"
                                alt=""
                              />
                              <span className="-no">1000</span>
                            </button>
                          </div>
                          <div className="-amount-container">
                            <button
                              type="button"
                              className="btn btn-block -btn-select-amount"
                              onClick={(e) => this.handleClick(e, 2000)}
                              data-amount={2000}
                            >
                              <img
                                src="/build/web/igame-index-lobby-wm/img/deposit-coin.png"
                                className="-deposit-coin"
                                alt=""
                              />
                              <span className="-no">2000</span>
                            </button>
                          </div>
                          <div className="-amount-container">
                            <button
                              type="button"
                              className="btn btn-block -btn-select-amount"
                              onClick={(e) => this.handleClick(e, 5000)}
                              data-amount={5000}
                            >
                              <img
                                src="/build/web/igame-index-lobby-wm/img/deposit-coin.png"
                                className="-deposit-coin"
                                alt=""
                              />
                              <span className="-no">5000</span>
                            </button>
                          </div>
                          <div className="-amount-container">
                            <button
                              type="button"
                              className="btn btn-block -btn-select-amount"
                              onClick={(e) => this.handleClick(e, 10000)}
                              data-amount={10000}
                            >
                              <img
                                src="/build/web/igame-index-lobby-wm/img/deposit-coin.png"
                                className="-deposit-coin"
                                alt=""
                              />
                              <span className="-no">10000</span>
                            </button>
                          </div>
                        </div>

                      </div>
                      <div className="x-transaction-current-balance">
                        <span className="-label">{t(lang,'ap_credit_available')}</span>
                        <div className="-balance-wrapper">
                          <span id="customer-transaction-balance" className="js-customer-balance">
                            <span className="-amount">{balance}</span>
                          </span>
                          <button type="button"
                            onClick={(e) => {
                              this.recheccredit(e)
                            }}
                            id="btn-transaction-balance-reload"
                            className="btn btn-link -reload-btn p-0" >
                            <i className="fas fa-sync-alt "></i>
                          </button>
                        </div>
                      </div>
                      <div className="text-center">
                        <button
                          onClick={(e) => this.submitwithdraw(e)}
                          type="submitx"
                          className="btn  btn-primary my-0 my-lg-3"
                        >
                          {t(lang,'ap_confirm')}
                        </button>
                      </div>
                      <div className="x-admin-contact  ">
                        <span className="x-text-with-link-component">
                          <label className="-text-message ">{t(lang,'ap_found_problem')}</label>
                          <a
                            href={this.state.linelink}
                            className="-link-message "
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <u>{t(lang,'ap_contact_support')}</u>
                          </a>
                        </span>
                      </div>
                    </div>
                    <input
                      type="hidden"
                      id="withdraw__token"
                      name="withdraw[_token]"
                      defaultValue="c9r5ElsPc_p6xmEjh7dv3LZcDaRwsVryr1p19a0qEcY"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* เปลี่ยนรหัสผ่าน (modal แยก) */}
        <div
          className="x-modal modal show"
          id="changePasswordModal"
          tabIndex={-1}
          role="dialog"
          data-container="#changePasswordModal"
          style={{ paddingRight: 6 }}
          aria-modal="true"
        >
          <div
            className="modal-dialog -modal-size modal-dialog-centered modal-dialog-scrollable -modal-mobile"
            role="document"
          >
            <div className="modal-content -modal-content">
              <button
                type="button"
                className="close f-1 "
                data-dismiss="modal"
                aria-label="Close"
              >
                <i className="fas fa-times" />
              </button>
              <div className="modal-header -modal-header">
                <h3 className="x-title-modal m-auto">{t(lang, 'ap_change_password')}</h3>
              </div>
              <div className="modal-body -modal-body">
                <div className="x-change-password-form">
                  <div className="form-group">
                    <label className="-cp-label">{t(lang, 'ap_current_password_placeholder')}</label>
                    <input
                      onChange={this.onChangex}
                      type="password"
                      name="oldpassword"
                      required="required"
                      placeholder={t(lang, 'ap_current_password_placeholder')}
                      className="x-form-control form-control"
                    />
                  </div>
                  <div className="form-group">
                    <label className="-cp-label">{t(lang, 'ap_new_password_placeholder')}</label>
                    <input
                      onChange={this.onChangex}
                      type="password"
                      name="password"
                      required="required"
                      placeholder={t(lang, 'ap_new_password_placeholder')}
                      className="x-form-control form-control"
                    />
                  </div>
                  <div className="form-group">
                    <label className="-cp-label">{t(lang, 'ap_confirm_placeholder')}</label>
                    <input
                      onChange={this.onChangex}
                      type="password"
                      name="passwordcf"
                      required="required"
                      placeholder={t(lang, 'ap_confirm_placeholder')}
                      className="x-form-control form-control"
                    />
                  </div>
                  <div className="text-center">
                    <button
                      onClick={(e) => { this.resetpassword(e, 1); }}
                      type="button"
                      className="btn btn-primary -btn-change-password my-2"
                    >
                      {t(lang, 'ap_confirm')}
                    </button>
                  </div>
                  <div className="x-admin-contact">
                    <span className="x-text-with-link-component">
                      <label className="-text-message ">{t(lang, 'ap_found_problem')}</label>
                      <a href={this.state.linelink} className="-link-message " target="_blank" rel="noopener noreferrer">
                        <u>{t(lang, 'ap_contact_support')}</u>
                      </a>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* หน้าถอนเงิน */}
        <div
          className="x-modal modal -v2 show"
          id="accountModalMobile"
          tabIndex={-1}
          role="dialog"
          data-container="#accountModalMobile"
          aria-modal="true"
        >
          <div
            className="modal-dialog -modal-size  modal-dialog-centered modal-dialog-scrollable -modal-mobile -no-fixed-button"
            role="document"
          >
            <div className="modal-content -modal-content">
              <button
                type="button"
                className="close f-1 "
                data-dismiss="modal"
                aria-label="Close"
              >
                <i className="fas fa-times" />
              </button>
              <div className="modal-header -modal-header">
                <div className="x-modal-mobile-header">
                  <div className="-header-mobile-container">
                    <h3 className="x-title-modal mx-auto text-center d-inline-block">
                      {t(lang,'ap_account_info')}
                    </h3>
                  </div>
                </div>
              </div>
              <div className="modal-body -modal-body">
                <div className="x-account-profile -v2">
                  <div
                    data-animatable="fadeInModal"
                    className="-profile-container  fadeInModal"
                  >
                    <div className="x-profile-group-trace-body" >
                      <div className="my-3 ">
                        <div className="-profile-info-wrapper">
                          <div className=" x-profile-info -group-trace-type" >
                            <div className="-profile-image-wrapper">
                              <div className="x-profile-info-image">
                                <img
                                  style={{ marginTop: "30px" }}
                                  className="img-fluid -profile-image"
                                  src={"/build/rank/" + this.state.rankpic}
                                  alt=""
                                />
                              </div>
                            </div>
                            <div className="-inner-wrapper">
                              <div className="-username-wrapper">
                                <span className="-label">
                                  Rank : <span className="-label-highlight"> {this.state.rankname}</span>
                                </span>
                                <span className="-value">{username}</span>

                              </div>
                              <a role="button" style={{ cursor: "pointer" }}
                                onClick={(e) => {
                                  this.openchangepassword(e, 'bonusaccount')
                                }}
                                className="-link-change-password" ><u>{t(lang,'ap_change_password')}</u></a>
                              <div className="x-checkbox-primary">
                                <div
                                  className={"-change-password-container js-change-password-collapse collapse" + (changepassword ? "d-none" : "")}
                                >
                                  <div className="js-collapse-content">
                                    <div
                                      noValidate=""
                                      name="sylius_user_change_password"
                                      method="post"
                                    >
                                      <div className="form-group mt-3">
                                        <input
                                          onChange={this.onChangex}
                                          type="password"
                                          id="oldpassword"
                                          name="oldpassword"
                                          required="required"
                                          placeholder={t(lang,'ap_current_password_placeholder')}
                                          className="x-form-control form-control"
                                        />
                                      </div>
                                      <div className="form-group">
                                        <input
                                          onChange={this.onChangex}
                                          type="password"
                                          id="password"
                                          name="password"
                                          required="required"
                                          placeholder={t(lang,'ap_new_password_placeholder')}
                                          className="x-form-control form-control"
                                        />
                                      </div>
                                      <div className="form-group">
                                        <input
                                          onChange={this.onChangex}
                                          type="password"
                                          id="passwordcf"
                                          name="passwordcf"
                                          required="required"
                                          placeholder={t(lang,'ap_confirm_placeholder')}
                                          className="x-form-control form-control"
                                        />
                                      </div>
                                      <button
                                        onClick={(e) => {
                                          this.resetpassword(e, 1)
                                        }}
                                        type="submit"
                                        style={{ background: "radial-gradient(100% 100% at 50% 0%, #ff82b6 0%, #c10655 100%)" }}
                                        className="text-white js-account-approve-aware btn -btn-deposit"
                                      >
                                        <span>{t(lang,'ap_confirm')}</span>
                                      </button>
                                      <input
                                        type="hidden"
                                        id="sylius_user_change_password__token"
                                        name="sylius_user_change_password[_token]"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                        <div className="-group-trace-wrapper">
                          <div className="x-profile-group-trace-condition ">
                            <div className="-card-condition-wrapper">
                              <div className="-card-condition-heading">
                                <span className="-title">
                                  {t(lang,'ap_rank_condition_prefix')}{(tblnextrank === null) ? "" : tblnextrank.name}
                                  {(tblnextrank === null) ? "" : <img
                                    style={{ marginLeft: "10px" }}
                                    className="img-fluid -profile-image"
                                    src={"/build/rank/" + tblnextrank.image}
                                    alt=""
                                  />}
                                </span>
                              </div>
                              <div className="-card-condition-description">
                                {t(lang,'ap_deposit_more_prefix')}<span className="-highlight">{(rankob === null) ? "" : (Number(rankob.highamount) - rankpoint + 1).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}</span>{t(lang,'ap_baht_suffix')}
                              </div>
                              <p className="-note">{t(lang,'ap_member_benefit')}</p>
                              <div className="containerx">
                                <div className="skill php" style={{ width: (rankob === null) ? "" : ((rankpoint / Number(rankob.highamount)) * 100) + "%" }} >  {(Number(rankpoint) || 0).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}</div>
                              </div>
                              <a role="button" data-container="#accountModal" onClick={(e) => {
                                this.openAccout(e, 'bonusrankaccount')
                              }} style={{ marginTop: "10px", cursor: "pointer" }} className="text-white js-account-approve-aware btn -btn-deposit"><div className="f-7">{t(lang,'ap_claim')}</div></a>
                              <div style={{ float: "left" }} >{(rankob === null) ? "" : (Number(rankob.lowamount) || 0).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} {t(lang,'ap_baht')}</div>
                              <div style={{ float: "right" }} >{(rankob === null) ? "" : (Number(rankob.highamount) + 1).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} {t(lang,'ap_baht')}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="-bank-info-wrapper">
                        <div className="x-profile-bank-info" id="shareAccountProfileBankInfo">
                          <span className="-heading-title">{t(lang,'ap_account_info')}</span>
                          <div className="-bank-detail">
                            <img
                              src={accnumber !== null ? accnumberx.img_path : ""}
                              alt={fullname}
                              width="50px"
                              className="mr-3 rounded-circle"
                            />
                            <span className="-name">{accnumber !== null ? accnumberx.fullname_th : ""}</span>
                          </div>
                          <div className="-bank-number">
                            <span className="-label">{t(lang,'ap_account_number_label')}</span>
                            <a role="button" style={{ cursor: "pointer" }} className="-copy-wrapper js-copy-to-clipboard" data-container="shareAccountProfileBankInfo" data-message={t(lang,'ap_copied_excl')} data-copy-me={accnumberx}>
                              {accnumber !== null ? accnumberx.accno.substring(0, 3) + "-" + accnumberx.accno.substring(3, 9) + "-" + accnumberx.accno.substring(9, 12) : ""}
                            </a>
                          </div>

                          <div className="-bank-name">
                            <span className="-label">{t(lang,'ap_account_name_label')}</span>
                            <span className="-value">{fullname}</span>
                          </div>
                        </div>
                        <div className="x-admin-contact -no-fixed text-center text-lg-left">
                          <span className="x-text-with-link-component">
                            <label className="-text-message ">{t(lang,'ap_change_account_contact')}</label>
                            <a href={this.state.linelink} className="-link-message " target="_blank" rel="noopener noreferrer">
                              <u>{t(lang,'ap_contact_support')}</u>
                            </a>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="js-has-info" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="x-modal modal -v2 show"
          id="couponModalMobile"
          tabIndex={-1}
          role="dialog"
          data-container="#couponModalMobile"
          aria-modal="true"
        >
          <div
            className="modal-dialog -modal-size  modal-dialog-centered modal-dialog-scrollable -modal-mobile"
            role="document"
          >
            <div className="modal-content -modal-content">
              <button
                type="button"
                className="close f-1 "
                data-dismiss="modal"
                aria-label="Close"
              >
                <i className="fas fa-times" />
              </button>
              <div className="modal-header -modal-header">
                <div className="x-modal-mobile-header">
                  <div className="-header-mobile-container">
                    <h3 className="x-title-modal mx-auto text-center d-inline-block">
                      {t(lang,'ap_use_coupon')}
                    </h3>
                  </div>
                </div>
              </div>
              <div className="modal-body -modal-body">
                <div className="x-account-coupon">
                  <div
                    data-animatable="fadeInModal"
                    className="-coupon-container  fadeInModal"
                  >
                    <div className="-coupon-member-detail">
                      <div className="-coupon-box">
                        <img
                          src="/build/web/igame-index-lobby-wm/img/ic-coupon.png"
                          alt="คูปองเล่นคาสิโนออนไลน์ โบนัสสล็อตออนไลน์"
                          className="img-fluid -ic-coupon m-auto"
                          width={220}
                          height={94}
                        />
                      </div>
                    </div>
                    <div className="-form-coupon-container">
                      <form
                        name="coupon"
                        method="post"
                        action="/account/_ajax_/coupon-apply?isMobileView=1"
                        data-ajax-form="/account/_ajax_/coupon-apply?isMobileView=1"
                        data-callback="_onCouponApply_"
                        data-dismiss-modal="#couponModalMobile"
                        data-container="#couponModalMobile"
                      >
                        <div className="my-4 -x-input-icon">
                          <img
                            src="/build/web/igame-index-lobby-wm/img/ic-coupon-input.png"
                            className="-icon"
                            alt="icon-coupon"
                          />
                          <input
                            type="text"
                            onChange={this.onChangex}
                            id="couponkey"
                            name="couponkey"
                            required="required"
                            className="x-coupon-input form-control"
                            placeholder={t(lang,'ap_coupon_code_placeholder')}
                          />
                        </div>
                        <div className="-btn-container">
                          <button type="submit"
                            onClick={(e) => {
                              this.couponredeem(e)
                            }} className="btn  btn-primary">

                            {t(lang,'ap_confirm')}
                          </button>
                        </div>
                        <input
                          type="hidden"
                          id="coupon__token"
                          name="coupon[_token]"
                          defaultValue="kg4A5PhTS8tsqjpMl7ef3x1ECaVkawFij6MAsvN55G0"
                        />
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="x-modal modal -v2 show"
          id="promotionReturnByUserModalMobile"
          tabIndex={-1}
          role="dialog"
          data-container="#promotionReturnByUserModalMobile"
          aria-modal="true"
        >
          <div
            className="modal-dialog -modal-size  modal-dialog-centered modal-dialog-scrollable -modal-mobile -no-fixed-button"
            role="document"
          >
            <div className="modal-content -modal-content">
              <button
                type="button"
                className="close f-1 "
                data-dismiss="modal"
                aria-label="Close"
              >
                <i className="fas fa-times" />
              </button>
              <div className="modal-header -modal-header">
                <div className="x-modal-mobile-header">
                  <div className="-header-mobile-container">
                    <h3 className="x-title-modal mx-auto text-center d-inline-block">
                      {t(lang,'ap_get_cashback_bonus_prefix')}{cashoutSet.percent} %
                    </h3>
                  </div>
                </div>
              </div>
              <div className="modal-body -modal-body">
                <div className="x-promotion-return-by-user-container">
                  <div className="-group-round-container -no-data">
                    <div className="-date-range-container text-center">
                      {t(lang,'ap_bonus_amount_period')}{moment(cashoutSet.LastStartDate).format('DD') + " " + this.showClockRealTime(cashoutSet.LastStartDate) + " - " + moment(cashoutSet.LastEndDate).format('DD') + " " + this.showClockRealTime(cashoutSet.LastStartDate) + "  "}
                    </div>
                  </div>
                  <div className="text-center">
                    <button
                      type="button"
                      className="btn btn-primary -promotion-return-btn"
                      onClick={(e) => {
                        this.opencliamcashout(e, 'bonusrankaccount')
                      }}
                    >
                      {tblprofile.Cashtotal > 0 ? <span className="-text-btn">{t(lang,'ap_get_loss')}</span> : <span className="-text-btn">{t(lang,'ap_not_eligible')}</span>}

                    </button>
                  </div>
                  <div className="-description-container">
                    {tblprofile.Cashtotal > 0 ? <div>{t(lang,'ap_you_got_loss_prefix')}{tblprofile.Cashtotal}{t(lang,'ap_baht_suffix')}</div> : <div>{t(lang,'ap_not_eligible_bonus')}</div>}
                    <div>
                      <span className="-text-description">
                        {t(lang,'ap_read_condition_join')}
                      </span>
                      {t(lang,'ap_below')}
                    </div>
                  </div>
                  <div className="-condition-container">
                    <div className="-condition-title">
                      <u>{t(lang,'ap_read_condition')}</u>
                    </div>
                    <div className="x-promotion-content">
                      <h2>
                        <strong>
                          {t(lang,'ap2_tc_play_more_lose_back_prefix')}{cashoutSet.percent}{t(lang,'ap2_tc_play_more_lose_back_suffix')}
                        </strong>
                      </h2>
                      {t(lang,'ap2_tc_calc_week_mon')}
                      <br />
                      {t(lang,'ap2_tc_turnover_5x')}
                      <br />
                      {t(lang,'ap2_tc_bonus_every_mon')}
                      <br />
                      {t(lang,'ap2_tc_bonus_no_turnover')}
                      <br />
                      {t(lang,'ap2_tc_min_winloss_500')}
                      <br />
                      {t(lang,'ap2_tc_credit_expire_7')}&nbsp;
                      <br />
                      &nbsp;
                      <a href="/term-and-condition">
                        {t(lang,'ap2_tc_basic_rules')}
                      </a>

                    </div>
                  </div>
                  <div className="my-3">
                    <div className="x-admin-contact -no-fixed">
                      <span className="x-text-with-link-component">
                        <label className="-text-message ">{t(lang,'ap_problem')}</label>
                        <a
                          href={this.state.linelink}
                          className="-link-message "
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <u>{t(lang,'ap_contact_support')}</u>
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="x-modal modal -v2 show"
          id="promotionReturnByUserModalMobileRedeem"
          tabIndex={-1}
          role="dialog"
          data-container="#promotionReturnByUserModalMobileRedeem"
          aria-modal="true"
        >
          <div
            className="modal-dialog -modal-size  modal-dialog-centered modal-dialog-scrollable -modal-mobile -no-fixed-button"
            role="document"
          >
            <div className="modal-content -modal-content">
              <button
                type="button"
                className="close f-1 "
                data-dismiss="modal"
                aria-label="Close"
              >
                <i className="fas fa-times" />
              </button>
              <div className="modal-header -modal-header">
                <div className="x-modal-mobile-header">
                  <div className="-header-mobile-container">
                    <h3 className="x-title-modal mx-auto text-center d-inline-block">
                      {t(lang,'ap_get_rank_bonus')}
                    </h3>
                  </div>
                </div>
              </div>
              <div className="modal-body -modal-body">
                <div className="x-promotion-return-by-user-container">
                  <div className="-description-container">
                    <div>
                      <span className="-text-description">
                        {t(lang,'ap_read_condition_join')}
                      </span>
                      {t(lang,'ap_below')}
                    </div>
                  </div>
                  <div className="-condition-container" style={{ height: "450px", width: "480px" }}>
                    <div className="x-promotion-content">
                      <table className="table table-borderless table-striped">
                        <tbody>
                          {this.state.tblrankall.map((listitem, i) => (
                            <tr key={i} id={listitem.no}>
                              <td className="-description-body-wrapper">
                                <img
                                  width={"100px"}
                                  className="img-fluid -profile-image"
                                  src={"/build/rank/" + listitem.image}
                                  alt=""
                                />
                                <div className="-title-wrapper">
                                  <p><span className="-title">{listitem.name}</span>        </p>
                                </div>
                                <div className="-state-wrapper">
                                  <span className="-text-description">{t(lang,'ap2_topup_word') + " " + (Number(listitem.lowamount) || 0).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}{t(lang,'ap2_topup_word_baht')}{(listitem.no === 1) ? "" : t(lang,'ap2_bonus_word') + (Number(listitem.claimamount) || 0).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') + t(lang,'ap2_bonus_baht_invite') + listitem.advicepercent + "%"} </span>
                                </div>
                              </td>
                              <td className="-transaction-body-wrapper">
                                {
                                  (listitem.no === 1) ? "" :
                                    (listitem.lowamount <= rankpoint && !listitem.checked) ? <div> <img
                                      src="https://asset.cloudigame.co/build/admin/img/wt_theme/popular_3/ic_success.png"
                                      className="-ic"
                                      width={"30px"}
                                      alt=""
                                    /><span className="-state-title" style={{ marginLeft: "10px" }}>{t(lang,'ap_status_success')}</span></div> :
                                      (!listitem.checked) ? t(lang,'ap_not_passed_condition') : <a role="button" style={{ cursor: "pointer" }} className="text-white js-account-approve-aware btn -btn-deposit active" onClick={(e) => {
                                        this.redeemrank(e, listitem)
                                      }}><div className="f-7">Cliam</div></a>}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="my-3">
                    <div className="x-admin-contact -no-fixed">
                      <span className="x-text-with-link-component">
                        <label className="-text-message ">{t(lang,'ap_problem')}</label>
                        <a
                          href={this.state.linelink}
                          className="-link-message "
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <u>{t(lang,'ap_contact_support')}</u>
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* หน้าข้อมูลบัญชี */}

        <div
          className="x-modal modal show"
          id="accountModal"
          tabIndex={-1}
          role="dialog"
          data-container="#accountModal"
          style={{ paddingRight: 6 }}
          aria-modal="true"
        >
          <div
            className="modal-dialog -modal-size -v2 modal-dialog-centered modal-dialog-scrollable     -modal-big -modal-main-account"
            role="document"
          >
            <div className="modal-content -modal-content">
              <button
                type="button"
                className="close f-1 "
                data-dismiss="modal"
                aria-label="Close"
              >
                <i className="fas fa-times" />
              </button>
              <div className="modal-body -modal-body">
                <div className="x-modal-account-menu">
                  <ul className="navbar-nav">
                    <li
                      className="nav-item -account-profile tabaccount active"
                      onClick={(e) => {
                        this.openAccout(e, 'mainaccount')
                      }}

                    >
                      <button
                        type="button"
                        className="nav-link js-close-account-sidebar"
                        data-container="#accountModal"
                      >
                        <img
                          className="img-fluid -icon-image"
                          src="/build/web/igame-index-lobby-wm/img/ic-menu-account-user.png"
                          alt="icon user"
                          width={34}
                          height={34}
                        />
                        <span className="-text-menu">{t(lang,'ap_menu_account_info')}</span>
                      </button>
                    </li>
                    <li
                      className="nav-item -account-link-social tabaccount"
                      onClick={(e) => {
                        try { if (window.jQuery) { window.jQuery('#accountModal').modal('hide'); window.jQuery('#socialsharemodal1').modal('show'); } } catch (err) { }
                      }}
                    >
                      <button
                        type="button"
                        className="nav-link js-close-account-sidebar"
                        data-container="#accountModal"
                      >
                        <div className="-text-menu-wrapper">
                          <img
                            className="img-fluid -icon-image"
                            src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/ic-account-menu-link-social-media.png"
                            onError={(e) => { e.target.onerror = null; e.target.style.visibility = "visible"; }}
                            alt="icon social"
                            width={34}
                            height={34}
                          />
                          <span className="-text-menu">{t(lang,'ap_menu_social')}</span>
                        </div>
                      </button>
                    </li>
                    <li
                      className="nav-item -account-provider tabaccount"
                      onClick={(e) => {
                        this.openAccout(e, 'appaccount')
                      }}
                    >
                      <button
                        type="button"
                        className="nav-link js-close-account-sidebar"
                        data-container="#accountModal"
                        onClick={(e) => {
                          this.checkuseradvice()
                        }}
                      >
                        <img
                          className="img-fluid -icon-image"
                          src="/build/web/igame-index-lobby-wm/img/ic-menu-account-provider.png"
                          alt="icon phone"
                          width={34}
                          height={34}
                        />
                        <span className="-text-menu">{t(lang,'ap_menu_invite_friend')}</span>
                      </button>
                    </li>
                    <li
                      className="nav-item -account-provider tabaccount"
                      onClick={(e) => {
                        this.openAccout(e, 'appcashout')
                      }}
                    >
                      <button
                        type="button"
                        className="nav-link js-close-account-sidebar"
                        data-container="#accountModal"
                      >
                        <img
                          className="img-fluid -icon-image"
                          src="/build/web/igame-index-lobby-wm/img/ic-withdraw-heading.png"
                          alt="icon phone"
                          width={34}
                          height={34}
                        />
                        <span className="-text-menu">{t(lang,'ap_menu_cashback')}</span>
                      </button>
                    </li>
                    <li className="nav-item  -account-provider -account-bill-history tabaccount"
                      onClick={(e) => {
                        this.openAccout(e, 'apphistory')
                      }}>
                      <button
                        type="button"
                        className="nav-link js-close-account-sidebar"
                        data-container="#accountModal"
                      >
                        <img
                          alt="ประวัติ เว็บไซต์พนันออนไลน์ คาสิโนออนไลน์ สล็อตออนไลน์"
                          className="img-fluid -icon-image"
                          width={34}
                          height={34}
                          src="/build/web/igame-index-lobby-wm/img/ic-menu-account-bill-history.png?v=5"
                        />
                        <span className="-text-menu">{t(lang,'ap_menu_history')}</span>
                      </button>
                    </li>

                    <li
                      className="nav-item -coupon tabaccount"
                      onClick={(e) => {
                        this.openAccout(e, 'couponaccount')
                      }}
                    >
                      <button
                        type="button"
                        className="nav-link js-close-account-sidebar"
                        data-container="#accountModal"
                      >
                        <img
                          className="img-fluid -icon-image"
                          src="/build/web/igame-index-lobby-wm/img/ic-menu-account-coupon.png"
                          alt="icon coupon"
                          width={34}
                          height={34}
                        />
                        <span className="-text-menu">{t(lang,'ap_menu_use_coupon')}</span>
                      </button>
                    </li>
                    <li
                      className="nav-item -join-promotion tabaccount"
                      onClick={(e) => {
                        this.openAccout(e, 'proaccount')
                      }}
                    >
                      <button
                        type="button"
                        className="nav-link js-close-account-sidebar"
                        data-container="#accountModal"
                        onClick={(e) => {
                          this.checkpro(e, 999)
                        }}
                      >
                        <img
                          className="img-fluid -icon-image"
                          src="/build/web/igame-index-lobby-wm/img/ic-menu-account-promotion.png"
                          alt="icon promotion"
                          width={34}
                          height={34}
                        />
                        <span className="-text-menu">{t(lang,'ap_menu_joined_promo')}</span>
                      </button>
                    </li>
                    <li className="nav-item js-close-account-sidebar -logout">
                      <a
                        href="/logout"
                        className="nav-link js-require-confirm"
                        data-title={t(lang,'ap_logout_confirm_title')}
                      >
                        <img
                          className="img-fluid -icon-image"
                          src="/build/web/igame-index-lobby-wm/img/ic-menu-account-logout.png"
                          alt="icon logout"
                          width={34}
                          height={34}
                        />
                        <span className="-text-menu">{t(lang,'ap_menu_logout')}</span>
                      </a>
                    </li>
                  </ul>
                </div>
                <div
                  className="js-profile-account-modal -layout-account" id="mainaccount" style={{ display: "block" }}
                >
                  <div className="x-account-profile">
                    <div
                      data-animatable="fadeInModal"
                      className="-profile-container  fadeInModal"
                    >
                      <h3 className="x-title-modal mx-auto text-center ">
                        {t(lang,'ap_account_info')}
                      </h3>
                      <div className="x-profile-group-trace-body" >
                        <div className="my-3 ">
                          <div className="-profile-info-wrapper">
                            <div className=" x-profile-info -group-trace-type" >
                              <div className="-profile-image-wrapper">
                                <div className="x-profile-info-image">
                                  <img
                                    style={{ marginTop: "30px" }}
                                    className="img-fluid -profile-image"
                                    src={this.state.rankpic || "https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/profile_icon_level_06.png"}
                                    onError={(e) => { e.target.onerror = null; e.target.style.visibility = "visible"; e.target.src = "https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/profile_icon_level_06.png"; }}
                                    alt=""
                                  />
                                </div>
                              </div>
                              <div className="-inner-wrapper">
                                <div className="-username-wrapper">
                                  <span className="-label">
                                    Rank : <span className="-label-highlight"> {this.state.rankname}</span>
                                  </span>
                                  <span className="-value">{username}</span>

                                </div>
                                <a role="button" style={{ cursor: "pointer" }}
                                  onClick={(e) => {
                                    this.openchangepassword(e, 'bonusaccount')
                                  }}
                                  className="-link-change-password" ><u>{t(lang,'ap_change_password')}</u></a>
                                <div className="x-checkbox-primary">
                                  <div
                                    className={"-change-password-container js-change-password-collapse collapse" + (changepassword ? "d-none" : "")}
                                  >
                                    <div className="js-collapse-content">
                                      <div
                                        noValidate=""
                                        name="sylius_user_change_password"
                                        method="post"
                                      >
                                        <div className="form-group mt-3">
                                          <input
                                            onChange={this.onChangex}
                                            type="password"
                                            id="oldpassword"
                                            name="oldpassword"
                                            required="required"
                                            placeholder={t(lang,'ap_current_password_placeholder')}
                                            className="x-form-control form-control"
                                          />
                                        </div>
                                        <div className="form-group">
                                          <input
                                            onChange={this.onChangex}
                                            type="password"
                                            id="password"
                                            name="password"
                                            required="required"
                                            placeholder={t(lang,'ap_new_password_placeholder')}
                                            className="x-form-control form-control"
                                          />
                                        </div>
                                        <div className="form-group">
                                          <input
                                            onChange={this.onChangex}
                                            type="password"
                                            id="passwordcf"
                                            name="passwordcf"
                                            required="required"
                                            placeholder={t(lang,'ap_confirm_placeholder')}
                                            className="x-form-control form-control"
                                          />
                                        </div>
                                        <button
                                          onClick={(e) => {
                                            this.resetpassword(e, 1)
                                          }}
                                          type="submit"
                                          style={{ background: "radial-gradient(100% 100% at 50% 0%, #ff82b6 0%, #c10655 100%)" }}
                                          className="text-white js-account-approve-aware btn -btn-deposit"
                                        >
                                          <span>{t(lang,'ap_confirm')}</span>
                                        </button>
                                        <input
                                          type="hidden"
                                          id="sylius_user_change_password__token"
                                          name="sylius_user_change_password[_token]"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>
                          <div className="-group-trace-wrapper">
                            <div className="x-profile-group-trace-condition ">
                              <div className="-card-condition-wrapper">
                                <div className="-card-condition-heading">
                                  <span className="-title">
                                    {t(lang,'ap_rank_condition_prefix')}{(tblnextrank === null) ? "" : tblnextrank.name}
                                    {(tblnextrank === null) ? "" : <img
                                      width="50px"
                                      className="mr-3 rounded-circle"
                                      src={(tblnextrank.image == null || tblnextrank.image == "") ? "https://apixgen.javisx.com/build/rank/1.jpeg" : (tblnextrank.picrack == null || tblnextrank.picrack == "") ? "https://apixgen.javisx.com/build/rank/" + tblnextrank.image : tblnextrank.picrack}
                                      alt=""
                                    />}
                                  </span>
                                </div>
                                <div className="-card-condition-description">
                                  {t(lang,'ap_deposit_more_prefix')}<span className="-highlight">{(rankob === null) ? "" : (Number(rankob.highamount) - rankpoint + 1).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}</span>{t(lang,'ap_baht_suffix')}
                                </div>
                                <p className="-note">{t(lang,'ap_member_benefit')}</p>
                                <div className="containerx">
                                  <div className="skill php" style={{ width: (rankob === null) ? "" : ((rankpoint / Number(rankob.highamount)) * 100) + "%" }} >  {(Number(rankpoint) || 0).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}</div>
                                </div>
                                <a

                                  onClick={(e) => {
                                    this.openAccout(e, 'bonusrankaccount')
                                  }}
                                  data-container="#accountModal"
                                  style={{ marginTop: "10px", cursor: "pointer" }}
                                  className="text-white js-account-approve-aware btn -btn-deposit">
                                  <div className="f-7">{t(lang,'ap_claim')}</div>
                                </a>

                                <div style={{ float: "left", color: "black" }} >{(rankob === null) ? "" : (Number(rankob.lowamount) || 0).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} {t(lang,'ap_baht')}</div>
                                <div style={{ float: "right", color: "black" }} >{(rankob === null) ? "" : (Number(rankob.highamount) + 1).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} {t(lang,'ap_baht')}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="-bank-info-wrapper">
                          <div className="x-profile-bank-info" id="shareAccountProfileBankInfo">
                            <span className="-heading-title">{t(lang,'ap_account_info')}</span>
                            <div className="-bank-detail">
                              <img
                                src={accnumber !== null ? accnumberx.img_path : ""}
                                alt={fullname}
                                width="50px"
                                className="mr-3 rounded-circle"
                              />
                              <span className="-name">{accnumber !== null ? accnumberx.fullname_th : ""}</span>
                            </div>
                            <div className="-bank-number">
                              <span className="-label">{t(lang,'ap_account_number_label')}</span>
                              <a role="button" style={{ cursor: "pointer" }} onClick={() => { if (accnumberx && accnumberx.accno) { navigator.clipboard.writeText(accnumberx.accno); this.notify("success", t(lang, 'ap_copied_excl')); } }} className="-copy-wrapper js-copy-to-clipboard" data-container="shareAccountProfileBankInfo" data-message={t(lang,'ap_copied_excl')} data-copy-me={accnumber !== null ? accnumberx.accno : ""}>
                                {accnumber !== null ? accnumberx.accno : ""}
                              </a>
                            </div>

                            <div className="-bank-name">
                              <span className="-label">{t(lang,'ap_account_name_label')}</span>
                              <span className="-value">{fullname}</span>
                            </div>
                          </div>
                          <div className="x-admin-contact -no-fixed text-center text-lg-left">
                            <span className="x-text-with-link-component">
                              <label className="-text-message ">{t(lang,'ap_change_account_contact')}</label>
                              <a
                                href={this.state.linelink}
                                className="-link-message "
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <u>{t(lang,'ap_contact_support')}</u>
                              </a>
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* <div className="-bank-info-container">
                        <div className="media">
                          <img
                            src={accnumber !== null ? accnumberx.img_path : ""}
                            alt={fname}
                            width="50px"
                            className="mr-3 rounded-circle"
                          />
                          <div className="media-body text-left">
                            <div className="f-6">{accnumber !== null ? accnumberx.accno.substring(0, 3) + "-" + accnumberx.accno.substring(3, 9) + "-" + accnumberx.accno.substring(9, 12) : ""}</div>
                            <b>{fname}</b>
                          </div>
                        </div>
                      </div> */}
                      <div className="js-has-info" />
                    </div>
                  </div>
                </div>
                <div className="js-profile-account-modal -layout-account" id="apphistory" style={{ display: "none" }}>
                  <h3 className="x-title-modal mt-0 mb-3 mx-auto text-center">
                    {t(lang,'ap_history_title')}
                  </h3>
                  <div className="-outer-history-wrapper">
                    <div className="x-bill-history-container">
                      <div
                        className="wg-container wg-container__wg_bill_history wg--loaded"
                        data-widget-name="wg_bill_history"
                        data-widget-options='{"script_path":null,"style_path":null,"image_path":null,"visibility":"away","visibility_offset":"100%","render_url":"\/_widget","render_method":"GET","attr_style":null,"attr_class":null,"scroll_position":"current","options":{},"callback":{},"mode":"clear","mask_mode":"over","mask_style":"wg-loading","limit":20,"page":1,"template":"@Base\/Widget\/billHistory.html.twig","name":"wg_bill_history"}'
                        data-widget-user-options='{"page":1}'
                      >
                        <div className="wg-content " style={{ display: (this.state.historylist.length === 0) ? "" : "none" }}>
                          <div className="-no-result-wrapper mt-3">
                            <div className="-heading-title">
                              <i className="fas fa-times-circle -icon" />
                              <div className="-title">{t(lang,'ap_no_data')}</div>
                              <div className="-sub-title">{t(lang,'ap_no_history')}</div>
                            </div>
                          </div>
                        </div>
                        <div className="wg-content" style={{ display: (this.state.historylist.length === 0) ? "none" : "" }}>
                          <table className="table table-borderless table-striped">
                            <tbody>
                              {this.state.historylist.map((listitem, i) => (
                                <tr key={i} id={listitem.tid}>
                                  <td className="-description-body-wrapper">
                                    <div className="-title-wrapper">
                                      <span className="-title">{(listitem.type === "BN") ? t(lang,'ap_bonus_special') : (listitem.type === "DE") ? t(lang,'ap_deposit') : t(lang,'ap_withdraw')}</span>
                                      <span style={{ display: (listitem.status === "0") ? "" : "none", margin: "5px" }}>
                                        <a role="button" style={{ cursor: "pointer" }} onClick={(e) => {
                                          this.cancelwithdraw(e, listitem)
                                        }}
                                          className="-link-change-password" ><u>{t(lang,'ap_cancel')}</u></a>
                                      </span>
                                    </div>
                                    <div className="-state-wrapper" style={{ display: (listitem.status === "2") ? "" : "none" }}>
                                      <span className="-state-text">{t(lang,'ap_status_label')}</span>
                                      <i className="fas fa-spinner fa-spin"></i>
                                      <span className="-state-title">{t(lang,'ap_status_processing')}</span>
                                      <span className="-state-title -short">{t(lang,'ap_status_processing')}</span>
                                    </div>
                                    <div className="-state-wrapper" style={{ display: (listitem.status === "0") ? "" : "none" }}>
                                      <span className="-state-text">{t(lang,'ap_status_label')}</span>
                                      <i className="fas fa-spinner fa-spin"></i>
                                      <span className="-state-title">{t(lang,'ap_status_pending')}</span>
                                      <span className="-state-title -short">{t(lang,'ap_status_pending')}</span>

                                    </div>
                                    <div className="-state-wrapper" style={{ display: (listitem.status === "4") ? "" : "none" }}>
                                      <span className="-state-text">{t(lang,'ap_status_label')}</span>
                                      <img
                                        src="https://asset.cloudigame.co/build/admin/img/wt_theme/popular_3/ic_fail.png"
                                        className="-ic"
                                        alt=""
                                      />
                                      <span className="-state-title">{t(lang,'ap_status_cancel_by_player')}</span>
                                      <span className="-state-title -short">{t(lang,'ap_status_cancel_by_player_short')}</span>
                                    </div>
                                    <div className="-state-wrapper" style={{ display: (listitem.status === "5") ? "" : "none" }}>
                                      <span className="-state-text">{t(lang,'ap_status_label')}</span>
                                      <img
                                        src="https://asset.cloudigame.co/build/admin/img/wt_theme/popular_3/ic_fail.png"
                                        className="-ic"
                                        alt=""
                                      />
                                      <span className="-state-title">{t(lang,'ap_status_fail_by_system')}</span>
                                      <span className="-state-title -short">{t(lang,'ap_status_fail_by_system')}</span>
                                    </div>
                                    <div className="-state-wrapper" style={{ display: (listitem.status === "1") ? "" : "none" }}>
                                      <span className="-state-text">{t(lang,'ap_status_label')}</span>
                                      <img
                                        src="https://asset.cloudigame.co/build/admin/img/wt_theme/popular_3/ic_success.png"
                                        className="-ic"
                                        alt=""
                                      />
                                      <span className="-state-title">{t(lang,'ap_status_success')}</span>
                                      <span className="-state-title -short">{t(lang,'ap_status_success')}</span>
                                    </div>
                                  </td>
                                  <td className="-transaction-body-wrapper">
                                    <div className={(listitem.type === "DE" || listitem.type === "BN") ? "-amount -deposit" : "-amount -withdraw"}>{(Number(listitem.amount) || 0).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} {t(lang,'ap_baht')}</div>
                                    <div className="-datetime">{moment(listitem.createdate).format('DD/MM/YY') + " - " + moment(listitem.createdate).format('HH:mm') + " " + t(lang,'ap2_time_suffix')} </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="js-profile-account-modal -layout-account" style={{ display: "none" }}
                  id="appaccount"
                >
                  <div id="accountProviderUser" className="x-account-provider ">
                    <div
                      data-animatable="fadeInModal"
                      className="-account-provider-container animated fadeInModal"
                    >
                      <h3 className="x-title-modal mx-auto text-center ">{t(lang,'ap_invite_friend_title')}</h3>
                      <div className="-group-trace-wrapper">
                        <div className="x-profile-group-trace-condition ">
                          <div className="-card-condition-wrapper">
                            <div className="-card-condition-heading">
                              <span className="-title">
                                {t(lang,'ap_get_invite_link')}
                              </span>
                            </div>
                            <div className="-card-condition-description">
                              {t(lang,'ap_click_link')}<span className="-highlight">
                                <a role="button" style={{ cursor: "pointer" }} onClick={() => this.copyCode()} className="-copy-wrapper js-copy-to-clipboard" data-container="shareAccountProfileBankInfo" data-message={t(lang,'ap_copied_excl')} >
                                  {linkaff}
                                </a>
                              </span>
                            </div>
                            <p className="-note">{t(lang,'ap_name_list')}
                              <img src="/build/web/igame-index-lobby-wm/img/ic-coin.png"
                                className="-ic"
                                style={{ marginLeft: "5px" }}
                                width={"20px"}
                                alt=""
                              />  {t(lang,'ap_complete_min_deposit_100')}</p>
                            <span className="-title">
                              {t(lang,'ap_you_got_invite_credit')}<span className="-title" style={{ color: "#d9ad70" }}  > {tblprofile.AffiliateCash}  </span> {t(lang,'ap_calc_every_sunday')}
                            </span>
                            <br></br>
                          </div>

                          {/* <span className="-title">
                            คุณได้เปอเซนต์  <span className="-title" style={{ color: "#d9ad70" }}  >{cashoutSet != null ? cashoutSet.percent : "0"}%</span> จากยอดเสีย ยอดได้รับ <span className="-title" style={{ color: "#d9ad70" }}  > {tblprofile.AffiliateCash}  </span> บาท
                          </span> */}
                          <br></br>
                          {(cashoutSet != null) ? tblprofile.AffiliateCash <= cashoutSet.minwithdraw ? "" : <a
                            onClick={(e) => {
                              this.opencliaminvite(e, 'bonusrankaccount')
                            }}
                            data-container="#accountModal"
                            style={{ marginTop: "10px", cursor: "pointer" }}
                            className="text-white js-account-approve-aware btn -btn-deposit">
                            <div className="f-7">{t(lang,'ap_claim')}</div>
                          </a> : ""}
                          <div className="-outer-history-wrapper" style={{ marginTop: "10px" }} >
                            <div className="x-bill-history-container">
                              <div
                                className="wg-container wg-container__wg_bill_history wg--loaded"
                                data-widget-name="wg_bill_history"
                                data-widget-options='{"script_path":null,"style_path":null,"image_path":null,"visibility":"away","visibility_offset":"100%","render_url":"\/_widget","render_method":"GET","attr_style":null,"attr_class":null,"scroll_position":"current","options":{},"callback":{},"mode":"clear","mask_mode":"over","mask_style":"wg-loading","limit":20,"page":1,"template":"@Base\/Widget\/billHistory.html.twig","name":"wg_bill_history"}'
                                data-widget-user-options='{"page":1}'
                              >
                                <div className="wg-content" style={{ display: (this.state.useradvice.length === 0) ? "" : "none" }}>
                                  <div className="-no-result-wrapper mt-3">
                                    <div className="-heading-title">
                                      <i className="fas fa-times-circle -icon" />
                                      <div className="-title">{t(lang,'ap_no_data')}</div>
                                      <div className="-sub-title" style={{ color: "black" }}>{t(lang,'ap_no_affiliate')}</div>
                                    </div>
                                  </div>
                                </div>
                                <div className="wg-content " style={{ display: (this.state.useradvice.length === 0) ? "none" : "" }}>
                                  <table className="table table-borderless table-striped">
                                    <tbody>
                                      {this.state.useradvice.map((listitem, i) => (
                                        <tr key={i} id={listitem.tid}>
                                          <td className="-description-body-wrapper">
                                            <div className="-title-wrapper">

                                              {i + 1 + "."} <span className="-title" style={{ marginLeft: "0px" }}> {listitem.playerid}
                                                {(listitem.checked !== 1) ? "" : <img src="/build/web/igame-index-lobby-wm/img/ic-coin.png"
                                                  className="-ic"
                                                  style={{ marginLeft: "5px", marginBottom: "3px" }}
                                                  width={"20px"}
                                                  alt=""
                                                />}
                                              </span>
                                            </div>
                                          </td>
                                          <td className="-transaction-body-wrapper">
                                            <div className="-datetime">{moment(listitem.DateCreate).format('DD/MM/YY') + " - " + moment(listitem.DateCreate).format('HH:mm') + " " + t(lang,'ap2_time_suffix')} </div>
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <div className="js-profile-account-modal -layout-account" style={{ display: "none" }}
                  id="appcashout"
                >
                  <div id="accountProviderUser" className="x-account-provider ">
                    <div
                      data-animatable="fadeInModal"
                      className="-account-provider-container animated fadeInModal"
                    >
                      <h3 className="x-title-modal mx-auto text-center ">{t(lang,'ap_cashback_title')}</h3>
                      <div className="-group-trace-wrapper" >
                        <div className="x-profile-group-trace-condition ">
                          <div className="-card-condition-wrapper " style={{ textAlign: "left" }}>
                            <span className="-title" style={{ textAlign: "left" }}>
                              {t(lang,'ap_cashback_condition')}<span className="-title" style={{ color: "#d9ad70" }}  > {cashoutSet.percent}  </span> %
                              <br></br>
                              {t(lang,'ap_you_got_cashback')}<span className="-title" style={{ color: "#d9ad70" }}  > {tblprofile.Cashtotal}  </span> {t(lang,'ap_baht')}
                            </span>
                            {/* <span className="-title" style={{textAlign:"left"}}>   <br></br>
                              ให้เครดิตชวนเพื่อน<span className="-title" style={{ color: "#d9ad70" }}  > {tblprofile.AffiliateCash}  </span> บาท 
                            </span>
                            <span className="-title" style={{textAlign:"left"}}>   <br></br>
                              ให้เครดิตเติมครั้งแรก<span className="-title" style={{ color: "#d9ad70" }}  > {tblprofile.AffiliateCash}  </span> บาท 
                            </span> */}

                            <br></br>
                          </div>

                          {/* <span className="-title">
                            คุณได้เปอเซนต์  <span className="-title" style={{ color: "#d9ad70" }}  >{cashoutSet != null ? cashoutSet.percent : "0"}%</span> จากยอดเสีย ยอดได้รับ <span className="-title" style={{ color: "#d9ad70" }}  > {tblprofile.AffiliateCash}  </span> บาท
                          </span> */}
                          <br></br>
                          {(cashoutSet != null) ? tblprofile.Cashtotal <= cashoutSet.minwithdraw ? "" : <a
                            onClick={(e) => {
                              this.opencliamcashout(e, 'bonusrankaccount')
                            }}
                            data-container="#accountModal"
                            style={{ marginTop: "10px", cursor: "pointer" }}
                            className="text-white js-account-approve-aware btn -btn-deposit">
                            <div className="f-7">{t(lang,'ap_claim')}</div>
                          </a> : ""}
                          <div className="-outer-history-wrapper" style={{ marginTop: "10px" }} >
                            <div className="x-bill-history-container">
                              <div
                                className="wg-container wg-container__wg_bill_history wg--loaded"
                                data-widget-name="wg_bill_history"
                                data-widget-options='{"script_path":null,"style_path":null,"image_path":null,"visibility":"away","visibility_offset":"100%","render_url":"\/_widget","render_method":"GET","attr_style":null,"attr_class":null,"scroll_position":"current","options":{},"callback":{},"mode":"clear","mask_mode":"over","mask_style":"wg-loading","limit":20,"page":1,"template":"@Base\/Widget\/billHistory.html.twig","name":"wg_bill_history"}'
                                data-widget-user-options='{"page":1}'
                              >
                                <div className="wg-content" style={{ display: (this.state.cashoutlist.length === 0) ? "" : "none" }}>
                                  <div className="-no-result-wrapper mt-3">
                                    <div className="-heading-title">
                                      <i className="fas fa-times-circle -icon" />
                                      <div className="-title">{t(lang,'ap_no_data')}</div>
                                      <div className="-sub-title" style={{ color: "black" }}>{t(lang,'ap_no_cashback')}</div>
                                      <div className="-sub-title" style={{ color: "black" }}>{t(lang,'ap_calc_every_sunday2')}</div>

                                    </div>
                                  </div>
                                </div>
                                <div className="wg-content " style={{ display: (this.state.cashoutlist.length === 0) ? "none" : "" }}>
                                  <table className="table table-borderless table-striped">
                                    <tbody>
                                      {this.state.cashoutlist.map((listitem, i) => (
                                        <tr key={i} id={listitem.tid}>
                                          <td className="-description-body-wrapper">
                                            <div className="-title-wrapper">

                                              {i + 1 + "."} <span className="-title" style={{ marginLeft: "0px" }}> {listitem.playerid}
                                                {(listitem.checked !== 1) ? "" : <img src="/build/web/igame-index-lobby-wm/img/ic-coin.png"
                                                  className="-ic"
                                                  style={{ marginLeft: "5px", marginBottom: "3px" }}
                                                  width={"20px"}
                                                  alt=""
                                                />}
                                              </span>
                                            </div>
                                          </td>
                                          <td className="-transaction-body-wrapper">
                                            <div className="-datetime">{moment(listitem.enddate).format('DD/MM/YY') + " - " + moment(listitem.enddate).format('HH:mm') + " " + t(lang,'ap2_time_suffix')} </div>
                                          </td>
                                          <td className="-transaction-body-wrapper">
                                            <span>
                                              {
                                                listitem.amount
                                              } {t(lang,'ap_baht')}
                                            </span>
                                          </td>
                                        </tr>

                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <div className="js-profile-account-modal -layout-account" style={{ display: "none" }}
                  id="couponaccount"
                >
                  <div className="x-account-coupon">
                    <div
                      data-animatable="fadeInModal"
                      className="-coupon-container  fadeInModal"

                    >
                      <h3 className="x-title-modal mx-auto text-center ">{t(lang,'ap_use_coupon')}</h3>
                      <div className="-coupon-member-detail" style={{ marginTop: "50px" }}>
                        <div className="-coupon-box">
                          <img
                            src="/build/web/igame-index-lobby-wm/img/ic-coupon.png"
                            alt="คูปองเล่นคาสิโนออนไลน์ โบนัสสล็อตออนไลน์"
                            className="img-fluid -ic-coupon m-auto"
                            width={220}
                            height={94}
                          />
                        </div>
                      </div>
                      <div className="-form-coupon-container" >

                        <div className="my-4 -x-input-icon">
                          <img
                            src="/build/web/igame-index-lobby-wm/img/ic-coupon-input.png"
                            className="-icon"
                            alt="icon-coupon"
                          />
                          <input
                            type="text"
                            onChange={this.onChangex}
                            id="couponkey"
                            name="couponkey"
                            required="required"
                            className="x-coupon-input form-control"
                            placeholder={t(lang,'ap_coupon_code_placeholder')}
                          />
                        </div>
                        <div className="-btn-container">
                          <button
                            onClick={(e) => {
                              this.couponredeem(e)
                            }}
                            type="submitx" className="btn  btn-primary">
                            {t(lang,'ap_confirm')}
                          </button>
                        </div>
                        <input
                          type="hidden"
                          id="coupon__token"
                          name="coupon[_token]"
                          defaultValue="kg4A5PhTS8tsqjpMl7ef3x1ECaVkawFij6MAsvN55G0"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="js-profile-account-modal -layout-account" style={{ display: "none" }}
                  id="proaccount"
                >
                  <h3 className="x-title-modal mt-0 mb-3 mx-auto text-center">
                    {t(lang,'ap_joined_promo')}
                  </h3>
                  <div className="-outer-history-wrapper">
                    <div className="x-bill-history-container">
                      <div
                        className="wg-container wg-container__wg_bill_history wg--loaded"
                        data-widget-name="wg_bill_history"
                        data-widget-options='{"script_path":null,"style_path":null,"image_path":null,"visibility":"away","visibility_offset":"100%","render_url":"\/_widget","render_method":"GET","attr_style":null,"attr_class":null,"scroll_position":"current","options":{},"callback":{},"mode":"clear","mask_mode":"over","mask_style":"wg-loading","limit":20,"page":1,"template":"@Base\/Widget\/billHistory.html.twig","name":"wg_bill_history"}'
                        data-widget-user-options='{"page":1}'
                      >
                        <div className="wg-content" style={{ display: (proderedeemlist.length === 0) ? "" : "none" }}>
                          <div className="-no-result-wrapper mt-3">
                            <div className="-heading-title">
                              <i className="fas fa-times-circle -icon" />
                              <div className="-title">{t(lang,'ap_no_data')}</div>
                              <div className="-sub-title">{t(lang,'ap_no_history')}</div>
                            </div>
                          </div>
                        </div>
                        <div className="wg-content" style={{ display: (proderedeemlist.length === 0) ? "none" : "" }}>
                          <table className="table table-borderless table-striped">
                            <tbody>
                              {proderedeemlist.map((listitem, i) => (
                                <tr key={i} id={i}>
                                  <td className="-description-body-wrapper">
                                    <div className="-title-wrapper">
                                      <span className="-title">{listitem.proname}</span>
                                      <span style={{ display: (listitem.status === 1) ? "" : "none", margin: "5px" }}>
                                        <a role="button" style={{ cursor: "pointer" }}
                                          onClick={(e) => {
                                            this.cancelredeempromotion(e, listitem)
                                          }}
                                          className="-link-change-password" ><u>{t(lang,'ap_cancel')}</u></a>
                                      </span>
                                    </div>
                                    <div className="-state-wrapper" style={{ display: (listitem.status === 1) ? "" : "none" }}>
                                      <span className="-state-text">{t(lang,'ap_status_label')}</span>
                                      <i className="fas fa-spinner fa-spin"></i>
                                      <span className="-state-title">{t(lang,'ap_status_pending')}</span>
                                      <span className="-state-title -short">{t(lang,'ap_status_pending')}</span>
                                    </div>
                                    <div className="-state-wrapper" style={{ display: (listitem.status === 4) ? "" : "none" }}>
                                      <span className="-state-text">{t(lang,'ap_status_label')}</span>
                                      <img
                                        src="https://asset.cloudigame.co/build/admin/img/wt_theme/popular_3/ic_fail.png"
                                        className="-ic"
                                        alt=""
                                      />
                                      <span className="-state-title">{t(lang,'ap_status_cancel_by_player')}</span>
                                      <span className="-state-title -short">{t(lang,'ap_status_cancel_by_player_short')}</span>
                                    </div>
                                    <div className="-state-wrapper" style={{ display: (listitem.status === 3) ? "" : "none" }}>
                                      <span className="-state-text">{t(lang,'ap_status_label')}</span>
                                      <img
                                        src="https://asset.cloudigame.co/build/admin/img/wt_theme/popular_3/ic_fail.png"
                                        className="-ic"
                                        alt=""
                                      />
                                      <span className="-state-title">{t(lang,'ap_status_fail_by_system')}</span>
                                      <span className="-state-title -short">{t(lang,'ap_status_fail_by_system')}</span>
                                    </div>
                                    <div className="-state-wrapper" style={{ display: (listitem.status === 2) ? "" : "none" }}>
                                      <span className="-state-text">{t(lang,'ap_status_label')}</span>
                                      <img
                                        src="https://asset.cloudigame.co/build/admin/img/wt_theme/popular_3/ic_success.png"
                                        className="-ic"
                                        alt=""
                                      />
                                      <span className="-state-title">{t(lang,'ap_status_success')}</span>
                                      <span className="-state-title -short">{t(lang,'ap_status_success')}</span>
                                    </div>
                                  </td>
                                  <td className="-transaction-body-wrapper">
                                    <div className="-amount -deposit">{(Number(listitem.amount) || 0).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} {t(lang,'ap_credit_unit')}</div>
                                    <div className="-datetime">{moment(listitem.datecreate).format('DD/MM/YY') + " - " + moment(listitem.datecreate).format('HH:mm') + " " + t(lang,'ap2_time_suffix')} </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="js-profile-account-modal -layout-account" style={{ display: "none" }} id="bonusaccount"   >
                  <h3 className="x-title-modal mt-0 mb-3 mx-auto text-center">
                    {t(lang,'ap_get_bonus_not_open')}
                  </h3>
                  <div className="x-promotion-return-by-user-container">
                    <div className="-group-round-container -no-data">
                      <div className="-date-range-container text-center">
                        {t(lang,'ap_promo_not_open')}
                        {/* ยอดโบนัสระหว่างวันที่ 20 - 26 พ.ย. 2021 */}
                      </div>
                    </div>
                    <div className="text-center">
                      <button
                        type="button"
                        disabled
                        className="btn btn-primary -promotion-return-btn"
                      >
                        <span className="-text-btn">{t(lang,'ap_not_eligible')}</span>
                      </button>
                    </div>
                    <div className="-description-container">
                      <div>{t(lang,'ap_not_eligible_bonus')}</div>
                      <div>
                        <span className="-text-description">
                          {t(lang,'ap_read_condition_join')} {t(lang,'ap_below')}
                        </span>
                      </div>
                    </div>
                    <div className="-condition-container">
                      <div className="-condition-title">
                        <u>{t(lang,'ap_read_condition')}</u>
                      </div>
                      <div className="x-promotion-content">
                        <h2>
                          <strong>
                            {t(lang,'ap2_tc_play_more_lose_back_5')}
                          </strong>
                        </h2>
                        {t(lang,'ap2_tc_calc_week_sat')}
                        <br />
                        {t(lang,'ap2_tc_turnover_5x')}
                        <br />
                        {t(lang,'ap2_tc_bonus_every_sat')}
                        <br />
                        {t(lang,'ap2_tc_bonus_no_turnover')}
                        <br />
                        {t(lang,'ap2_tc_min_winloss_2000')}
                        <br />
                        {t(lang,'ap2_tc_credit_expire_3')}&nbsp;
                        <br />
                        &nbsp;
                        <a href="/term-and-condition">
                          {t(lang,'ap2_tc_basic_rules')}
                        </a>
                      </div>
                    </div>
                    <div className="my-3">
                      <div className="x-admin-contact -no-fixed">
                        <span className="x-text-with-link-component">
                          <label className="-text-message ">{t(lang,'ap_problem')}</label>
                          <a
                            href={this.state.linelink}
                            className="-link-message "
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <u>{t(lang,'ap_contact_support')}</u>
                          </a>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="js-profile-account-modal -layout-account" style={{ display: "none" }}
                  id="bonusrankaccount"
                >
                  <h3 className="x-title-modal mx-auto text-center mt-0 mb-2">
                    {t(lang,'ap_get_rank_bonus')}
                  </h3>
                  <div className="x-promotion-return-by-user-container">
                    <div className="-description-container">
                      <div>
                        <span className="-text-description">
                          {t(lang,'ap_read_condition_join')} {t(lang,'ap_below')}
                        </span>

                      </div>
                    </div>
                    <div className="-condition-container" style={{ height: "450px", width: "480px" }}>
                      <div className="x-promotion-content">
                        <table className="table table-borderless table-striped">
                          <tbody>
                            {this.state.tblrankall.map((listitem, i) => (
                              <tr key={i} id={listitem.no}>
                                <td className="-description-body-wrapper">
                                  <img
                                    width={"100px"}
                                    className="img-fluid -profile-image"
                                    src={(listitem.image == null || listitem.image == "") ? "https://apixgen.javisx.com/build/rank/1.jpeg" : (listitem.picrack == null || listitem.picrack == "") ? "https://apixgen.javisx.com/build/rank/" + listitem.image : listitem.picrack}
                                    alt=""
                                  />
                                  <div className="-title-wrapper">
                                    <p><span className="-title" style={{ color: "black" }}>{listitem.name}</span>        </p>
                                  </div>
                                  <div className="-state-wrapper">
                                    <span className="-text-description" style={{ color: "black" }}>{t(lang,'ap2_topup_word') + " " + (Number(listitem.lowamount) || 0).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}{t(lang,'ap2_topup_word_baht')}{(listitem.no === 1) ? "" : t(lang,'ap2_bonus_word') + (Number(listitem.claimamount) || 0).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') + t(lang,'ap2_bonus_baht_invite') + listitem.advicepercent + "%"} </span>
                                  </div>
                                </td>
                                <td className="-transaction-body-wrapper" style={{ color: "black" }}>
                                  {
                                    (listitem.no === 1) ? "" :
                                      (listitem.lowamount <= rankpoint && !listitem.checked) ? <div> <img
                                        src="https://asset.cloudigame.co/build/admin/img/wt_theme/popular_3/ic_success.png"
                                        className="-ic"
                                        width={"30px"}
                                        alt=""
                                      /><span className="-state-title" style={{ marginLeft: "10px" }}>{t(lang,'ap_status_success')}</span></div> :
                                        (!listitem.checked) ? t(lang,'ap_not_passed_condition') : <a role="button" style={{ cursor: "pointer" }} className="text-white js-account-approve-aware btn -btn-deposit active" onClick={(e) => {
                                          this.redeemrank(e, listitem)
                                        }}><div className="f-7">Cliam</div></a>}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="my-3">
                      <div className="x-admin-contact -no-fixed">
                        <span className="x-text-with-link-component">
                          <label className="-text-message ">{t(lang,'ap_problem')}</label>
                          <a
                            href={this.state.linelink}
                            className="-link-message "
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <u>{t(lang,'ap_contact_support')}</u>
                          </a>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        {/* หน้าข้อมูลบัญชี */}
        <div
          className="x-modal modal -v2 -scrollable -no-button js-modal-scrollable"
          id="historyModal"
          tabIndex={-1}
          role="dialog"
          data-loading-container=".modal-body"
          data-container="#historyModal .modal-body"
          style={{ display: "none" }}
          aria-hidden="true"
        >
          <div
            className="modal-dialog -modal-size -v2 modal-dialog-centered modal-dialog-scrollable "
            role="document"
          >
            <div className="modal-content -modal-content">
              <button
                type="button"
                className="close f-1 "
                data-dismiss="modal"
                aria-label="Close"
              >
                <i className="fas fa-times" />
              </button>
              <div className="modal-header -modal-header">
                <h3 className="x-title-modal -v2 mt-0">{t(lang,'ap_history_title')}</h3>
              </div>
              <div className="modal-body -modal-body">
                <div className="-outer-history-wrapper">
                  <div className="x-bill-history-container">
                    <div
                      className="wg-container wg-container__wg_bill_history wg--loaded"
                      data-widget-name="wg_bill_history"
                      data-widget-options='{"script_path":null,"style_path":null,"image_path":null,"visibility":"away","visibility_offset":"100%","render_url":"\/_widget","render_method":"GET","attr_style":null,"attr_class":null,"scroll_position":"current","options":{},"callback":{},"mode":"clear","mask_mode":"over","mask_style":"wg-loading","limit":20,"page":1,"template":"@Base\/Widget\/billHistory.html.twig","name":"wg_bill_history"}'
                      data-widget-user-options='{"page":1}'
                    >
                      <div className="wg-content" style={{ display: (this.state.historylist.length === 0) ? "" : "none" }}>
                        <div className="-no-result-wrapper mt-3">
                          <div className="-heading-title">
                            <i className="fas fa-times-circle -icon" />
                            <div className="-title">{t(lang,'ap_no_data')}</div>
                            <div className="-sub-title">{t(lang,'ap_no_history')}</div>
                          </div>
                        </div>
                      </div>
                      <div className="wg-content" style={{ display: (this.state.historylist.length === 0) ? "none" : "" }}>
                        <table className="table table-borderless table-striped">
                          <tbody>
                            {this.state.historylist.map((listitem, i) => (
                              <tr key={i} id={listitem.tid}>
                                <td className="-description-body-wrapper">
                                  <div className="-title-wrapper">
                                    <span className="-title">{(listitem.type === "DE") ? t(lang,'ap_deposit') : t(lang,'ap_withdraw')}</span>
                                    <span style={{ display: (listitem.status === "0") ? "" : "none", margin: "5px" }}>
                                      <a role="button" style={{ cursor: "pointer" }} onClick={(e) => {
                                        this.cancelwithdraw(e, listitem)
                                      }}
                                        className="-link-change-password" ><u>{t(lang,'ap_cancel')}</u></a>
                                    </span>
                                  </div>
                                  <div className="-state-wrapper" style={{ display: (listitem.status === "2") ? "" : "none" }}>
                                    <span className="-state-text">{t(lang,'ap_status_label')}</span>
                                    <i className="fas fa-spinner fa-spin"></i>
                                    <span className="-state-title">{t(lang,'ap_status_processing')}</span>
                                    <span className="-state-title -short">{t(lang,'ap_status_processing')}</span>
                                  </div>
                                  <div className="-state-wrapper" style={{ display: (listitem.status === "0") ? "" : "none" }}>
                                    <span className="-state-text">{t(lang,'ap_status_label')}</span>
                                    <i className="fas fa-spinner fa-spin"></i>
                                    <span className="-state-title">{t(lang,'ap_status_pending')}</span>
                                    <span className="-state-title -short">{t(lang,'ap_status_pending')}</span>

                                  </div>
                                  <div className="-state-wrapper" style={{ display: (listitem.status === "4") ? "" : "none" }}>
                                    <span className="-state-text">{t(lang,'ap_status_label')}</span>
                                    <img
                                      src="https://asset.cloudigame.co/build/admin/img/wt_theme/popular_3/ic_fail.png"
                                      className="-ic"
                                      alt=""
                                    />
                                    <span className="-state-title">{t(lang,'ap_status_cancel_by_player')}</span>
                                    <span className="-state-title -short">{t(lang,'ap_status_cancel_by_player_short')}</span>
                                  </div>
                                  <div className="-state-wrapper" style={{ display: (listitem.status === "5") ? "" : "none" }}>
                                    <span className="-state-text">{t(lang,'ap_status_label')}</span>
                                    <img
                                      src="https://asset.cloudigame.co/build/admin/img/wt_theme/popular_3/ic_fail.png"
                                      className="-ic"
                                      alt=""
                                    />
                                    <span className="-state-title">{t(lang,'ap_status_fail_by_system')}</span>
                                    <span className="-state-title -short">{t(lang,'ap_status_fail_by_system')}</span>
                                  </div>
                                  <div className="-state-wrapper" style={{ display: (listitem.status === "1") ? "" : "none" }}>
                                    <span className="-state-text">{t(lang,'ap_status_label')}</span>
                                    <img
                                      src="https://asset.cloudigame.co/build/admin/img/wt_theme/popular_3/ic_success.png"
                                      className="-ic"
                                      alt=""
                                    />
                                    <span className="-state-title">{t(lang,'ap_status_success')}</span>
                                    <span className="-state-title -short">{t(lang,'ap_status_success')}</span>
                                  </div>

                                </td>
                                <td className="-transaction-body-wrapper">
                                  <div className={(listitem.type === "DE") ? "-amount -deposit" : "-amount -withdraw"}>{listitem.amount} {t(lang,'ap_baht')}</div>
                                  <div className="-datetime">{moment(listitem.createdate).format('DD/MM/YY') + " - " + moment(listitem.createdate).format('HH:mm') + " " + t(lang,'ap2_time_suffix')} </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div
          id="ProDetailModal1"
          tabIndex={-1}
          className="modal x-modal -promotion-detail-modal promotion-detail-modal-149 show"
          aria-modal="true"
        >
          <div
            className="modal-dialog -modal-size modal-dialog-centered modal-dialog-scrollable -modal-mobile"
            role="document"
          >
            <div className="modal-content -modal-content">
              <button
                type="button"
                className="close f-1 "
                data-dismiss="modal"
                aria-label="Close"
              >
                <i className="fas fa-times" />
              </button>
              <div className="modal-body -modal-body" >
                <div className="container">
                  <div className="col-12 mt-4">
                    <div className="x-page-title-component -midsize">
                      <div className="-inner-wrapper">
                        <div className="-title">{t(lang,'ap_promo_rank_more')}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex flex-column" >
                  <div className="-real-content" >
                    <div className="x-card card -card-promotion-detail ">
                      <div className="card-body" >
                        <table className="table table-borderless table-striped">
                          <tbody>
                            {this.state.tblrankall.map((listitem, i) => (
                              <tr key={i} id={listitem.no}>
                                <td className="-description-body-wrapper">
                                  <img
                                    width={"100px"}
                                    className="img-fluid -profile-image"
                                    src={"/build/rank/" + listitem.image}
                                    alt=""
                                  />
                                  <div className="-title-wrapper">
                                    <p><span className="-title">{listitem.name}</span>        </p>
                                  </div>
                                  <div className="-state-wrapper">
                                    <span className="-text-description">{t(lang,'ap2_topup_word') + " " + (Number(listitem.lowamount) || 0).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}{t(lang,'ap2_topup_word_baht_more')}{(listitem.no === 1) ? "" : t(lang,'ap2_bonus_word') + (Number(listitem.claimamount) || 0).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') + t(lang,'ap2_bonus_baht_only')} </span>
                                  </div>
                                </td>
                                <td className="-transaction-body-wrapper">
                                  {
                                    (listitem.no === 1) ? "" :
                                      (listitem.lowamount <= rankpoint && !listitem.checked) ? <div> <img
                                        src="https://asset.cloudigame.co/build/admin/img/wt_theme/popular_3/ic_success.png"
                                        className="-ic"
                                        width={"30px"}
                                        alt=""
                                      /><span className="-state-title" style={{ marginLeft: "10px" }}>{t(lang,'ap_status_success')}</span></div> :
                                        (!listitem.checked) ? t(lang,'ap_not_passed_condition') : <a role="button" style={{ cursor: "pointer" }} className="text-white js-account-approve-aware btn -btn-deposit active" onClick={(e) => {
                                          this.redeemrank(e, listitem)
                                        }}><div className="f-7">Cliam</div></a>}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                    </div>
                  </div>
                  <a
                    href="#deposit-choose-promotion"
                    className="js-account-approve-aware btn -back-btn"
                    data-toggle="modal"
                    data-dismiss="modal"
                  >
                    <i className="fas fa-arrow-left" />
                    <div className="f-6 -text">{t(lang,'ap_back2')}</div>
                  </a>
                  <div className="mx-3 mb-3">
                    <div className="x-admin-contact -no-fixed">
                      <span className="x-text-with-link-component">
                        <label className="-text-message ">{t(lang,'ap_problem')}</label>
                        <a
                          href={this.state.linelink}
                          className="-link-message "
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <u>{t(lang,'ap_contact_support')}</u>
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* รายละเอียดโปร */}
        <div
          id="ProDetailModal"
          tabIndex={-1}
          className="modal x-modal -promotion-detail-modal promotion-detail-modal-149 show"
          aria-modal="true"
        >
          <div
            className="modal-dialog -modal-size modal-dialog-centered modal-dialog-scrollable -modal-mobile"
            role="document"
          >
            <div className="modal-content -modal-content">
              <button
                type="button"
                className="close f-1 "
                data-dismiss="modal"
                aria-label="Close"
              >
                <i className="fas fa-times" />
              </button>
              <div className="modal-body -modal-body">
                <div className="container">
                  <div className="row">
                    <div className="col-12 mt-4">
                      <div className="x-page-title-component -midsize">
                        <div className="-inner-wrapper">
                          <div className="-title">{t(lang,'ap_promotion')}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex flex-column" >
                  {(prodetail.length === 0) ? <div className="x-card card -card-promotion-detail ">
                    <div className="card-body">
                      <div className="-title">{t(lang,'ap_promo_not_active')}</div>
                      <div className="-img-container">
                        <img
                          src="/media/cache/strip/202109/promotion/7AB3F352-6DE2-44CC-A5FC-D4359FCB2122.png"
                          alt="โปรโมชั่นยังไม่ได้เปิดใช้งาน"
                          className="-img-promotion img-fluid"
                          width={398}
                          height={143}
                        />
                      </div>
                    </div>
                  </div>
                    :
                    <div className="-real-content" style={{ fontSize: "1em !important" }}>
                      <div className="x-card card -card-promotion-detail ">
                        <section
                          dangerouslySetInnerHTML={{ __html: prodetail.detail }}
                        />
                        <div className="card-footer">
                          <button
                            className="btn "
                            style={{ fontWeight: "300", background: "radial-gradient(100% 100% at 50% 0, #f9cf95 0, #c69a5d 100%)" }}
                            onClick={(e) => this.redeempro(e, prodetail.no)}
                          >
                            <span>{t(lang,'ap_get_promo')}</span>
                          </button>
                          <button id="opendeposit" onClick={(e) => this.confirmdeposit(e, 4)} className="btn -btn -get-promotion-btn  " style={{ display: "none" }} data-toggle="modal" data-target="#deposittruemoneyModal" data-dismiss="modal"  >
                          </button>
                        </div>
                      </div>
                    </div>}
                  <a
                    href="#deposit-choose-promotion"
                    className="js-account-approve-aware btn -back-btn"
                    data-toggle="modal"
                    data-target="#depositChoosePromotionModal"
                    data-dismiss="modal"
                  >
                    <i className="fas fa-arrow-left" />
                    <div className="f-6 -text">{t(lang,'ap_back2')}</div>
                  </a>
                  <div className="mx-3 mb-3">
                    <div className="x-admin-contact -no-fixed">
                      <span className="x-text-with-link-component">
                        <label className="-text-message ">{t(lang,'ap_problem')}</label>
                        <a
                          href={this.state.linelink}
                          className="-link-message "
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <u>{t(lang,'ap_contact_support')}</u>
                        </a>
                        <button id="openpopup"
                          style={{ display: "none" }} data-toggle="modal" data-target="#promotionSuggestionModalxx" data-dismiss="modal"  >
                          <button id="depositChoosePromo" style={{ display: "none" }} data-toggle="modal" data-target="#depositChoosePromotionModalxx" data-dismiss="modal"  ></button>
                        </button>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        {/* รายละเอียดโปร */}
        {/* Alert */}
        {/* <div className="x-right-sidebar-container">
          <div className="x-notification-entrance-container js-notification-entry">
            <a
              href="#notificationCenter"
              className="-link-wrapper "
              data-toggle="modal"
              data-target="#notificationCenterModal"
            >
              <div className="-img-wrapper">
                <img
                  src="/build/web/igame-index-lobby-wm/img/notification-ic-bell.png"
                  className="-img"
                  alt=""
                  width={40}
                  height={44}
                />
              </div>
            </a>
          </div>
        </div> */}
        {/* Alert */}
        {/* Alert List */}
        {/* <div
          className="x-modal modal show"
          id="notificationCenterModal"
          tabIndex={-1}
          role="dialog"
          style={{ paddingRight: 6 }}
          aria-modal="true"
        >
          <div
            className="modal-dialog -modal-size modal-dialog-centered modal-dialog-scrollable "
            role="document"
          >
            <div className="modal-content -modal-content">
              <button
                type="button"
                className="close f-1 "
                data-dismiss="modal"
                aria-label="Close"
              >
                <i className="fas fa-times" />
              </button>
              <div className="modal-header -modal-header">
                <div className="-outer-wrapper">
                  <img
                    src="/build/web/igame-index-lobby-wm/img/notification-title-bg.png"
                    className="-title-bg"
                    alt=""
                    width={320}
                    height={64}
                  />
                  <h3 className="x-title-modal">
                    <img
                      src="/build/web/igame-index-lobby-wm/img/notification-ic-bell.png"
                      className="-ic-title"
                      alt=""
                      width={40}
                      height={40}
                    />
                    <span className="-text">{t(lang,'ap_notify_board')}</span>
                  </h3>
                </div>
              </div>
              <div className="modal-body -modal-body">
                <div className="x-notification-center-render-container">
                  <div className="x-notification-history-list-container js-infinite-scroll-list-container">
                    <div className="wg-container wg-container__wg_inbox wg--loaded">
                      <div className="wg-content">
                        <div className="x-notification-list-item-wrapper -global ">
                          <img
                            src="/build/web/igame-index-lobby-wm/img/notification-ic-alert.png"
                            className="-ic-img"
                            alt=""
                            width={70}
                            height={70}
                          />
                          <div className="-details-wrapper">
                            <div className="-title">{t(lang,'ap_bank_down')}</div>
                            <p className="-description">{t(lang,'ap_sorry_inconvenience')}</p>
                            <span className="-datetime">{t(lang,'ap_2_months_ago')}</span>
                          </div>
                          <div className="-actions-wrapper">
                            <button
                              type="button"
                              className="btn -delete-btn js-notification-remove-item"
                              aria-label="Remove item 3699921"
                              data-remove-url="/account/_ajax_/notifitaion/3699921/remove"
                            >
                              <i className="fas fa-trash-alt" />
                            </button>
                          </div>
                        </div>
                        <div className="x-notification-list-item-wrapper -global ">
                          <img
                            src="/build/web/igame-index-lobby-wm/img/notification-ic-alert.png"
                            className="-ic-img"
                            alt=""
                            width={70}
                            height={70}
                          />
                          <div className="-details-wrapper">
                            <div className="-title">{t(lang,'ap_invite_more_get_more')}</div>
                            <p className="-description">
                              {t(lang,'ap_invite_friend_play')}
                              {t(lang,'ap_get_extra_1000')}
                              {t(lang,'ap_contact_service')}
                            </p>
                            <span className="-datetime">{t(lang,'ap_3_months_ago')}</span>
                          </div>
                          <div className="-actions-wrapper">
                            <button
                              type="button"
                              className="btn -delete-btn js-notification-remove-item"
                              aria-label="Remove item 3110659"
                              data-remove-url="/account/_ajax_/notifitaion/3110659/remove"
                            >
                              <i className="fas fa-trash-alt" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button
                    type="button"
                    className="-delete-all-btn js-notification-remove-all"
                    data-remove-url="/account/_ajax_/notifitaion/remove-all"
                  >
                    <i className="fas fa-trash-alt" />
                    <span className="-text">{t(lang,'ap_delete_all')}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        {/* Alert List */}
        {/* เลือกโปรก่อนเล่นเกม */}
        <div
          className="x-modal modal show"
          id="gameproselect"
          tabIndex={-1}
          role="dialog"
          style={{ paddingRight: 6 }}
          aria-modal="true"
        >
          <div
            className="modal-dialog -modal-size modal-dialog-centered modal-dialog-scrollable -modal-deposit"
            role="document"
          >
            <div className="modal-content -modal-content">
              <button
                type="button"
                className="close f-1 "
                data-dismiss="modal"
                aria-label="Close"
              >
                <i className="fas fa-times" />
              </button>
              <div className="modal-header -modal-header">
                <h3 className="x-title-modal m-auto">{t(lang,'ap_enter_game')}</h3>
              </div>
              <div className="showgamepro">
                <img src="/build/admin/img/sexy-bac/ezc-sexy-bac-direct-COSPLAY.webp?v=5" alt="" />
              </div>
              <div className="modal-body -modal-body">
                <div className="x-deposit-form">
                  <div className="row -deposit-container">
                    <div
                      data-animatable="fadeInModal"
                      className="col-lg order-lg-2 -form order-0  fadeInModal"
                    >
                      <div className="-deposit-form-inner-wrapper d-block ">
                        <div
                          noValidate=""
                          name="deposit"
                          method="post"
                          data-container="#depositModal"
                        >
                          <div className="-modal-body-top">
                            <div className="text-center d-flex flex-column">
                              <div className="m-auto"></div>
                            </div>
                            <div className="-x-input-icon x-input-operator mb-4 flex-column">
                              <button
                                type="button"
                                className="-icon-left -btn-icon js-adjust-amount-by-operator"
                                data-operator="-"
                                data-value={10}
                              >
                                <i className="fas fa-minus-circle" />
                              </button>
                              <input
                                type="text"
                                id="depoamount"
                                value={this.state.depositamount}
                                readOnly
                                pattern="[0-9]*"
                                className="x-form-control -text-big text-center js-deposit-input-amount form-control"
                                placeholder={t(lang,'ap_min_deposit_10')}
                                inputMode="text"
                              />
                              <button
                                type="button"
                                className="-icon-right -btn-icon js-adjust-amount-by-operator"
                                data-operator="+"
                                data-value={10}
                              >
                                <i className="fas fa-plus-circle" />
                              </button>
                            </div>
                          </div>
                          {/* เลือกโปร ก่อนเล่นเกม */}
                          <div className="selectprogame">
                            {/* ไม่รับโบนัส */}
                            <input
                              type="radio"
                              name="choiceprogame"
                              id="choose-1"
                              defaultValue={1}
                            />
                            <label htmlFor="choose-1">
                            </label>
                            {/* ไม่รับโบนัส */}
                            {/* โปร 1 */}
                            <input
                              type="radio"
                              name="choiceprogame"
                              id="choose-2"
                              defaultValue={2}
                            />
                            <label htmlFor="choose-2">
                              <img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" alt="" />
                            </label>
                            {/* โปร 1 */}
                            {/* โปร 2 */}
                            <input
                              type="radio"
                              name="choiceprogame"
                              id="choose-3"
                              defaultValue={3}
                            />
                            <label htmlFor="choose-3">
                              <img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" alt="" />
                            </label>
                            {/* โปร 2 */}
                          </div>
                          {/* เลือกโปร ก่อนเล่นเกม */}
                          <div className="text-center">
                            <button
                              type="submit"
                              className="btn  btn-primary my-0 my-lg-3"
                            >
                              {t(lang,'ap_confirm')}
                            </button>
                          </div>
                          <input
                            type="hidden"
                            id="deposit__token"
                            name="deposit[_token]"
                            defaultValue="d8iYDTklPETlCIEBA5CM4b1J9xZS1ZFfMKUoJ-c21fE"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* เลือกโปรก่อนเล่นเกม */}
        <div className="d-lg-none">
          <div
            className="x-modal modal "
            id="bookmarkModal"
            tabIndex={-1}
            role="dialog"
            aria-hidden="true"
            data-loading-container=".js-modal-content"
            data-ajax-modal-always-reload="true"
          >
            <div
              className="modal-dialog -modal-size modal-dialog-centered modal-dialog-scrollable         -no-fixed-button
                  "
              role="document"
            >
              <div className="modal-content -modal-content">
                <button
                  type="button"
                  className="close f-1 "
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="fas fa-times" />
                </button>
                <div className="modal-header -modal-header">
                  <h3 className="x-title-modal d-inline-block m-auto">
                    <span>Bookmark</span>
                  </h3>
                </div>
                <div className="modal-body -modal-body">
                  <div className="x-bookmark-modal-container">
                    <nav>
                      <div
                        className="nav nav-tabs x-bookmark-tabs-header-wrapper"
                        id="nav-tab"
                        role="tablist"
                      >
                        <a
                          className="nav-link active"
                          id="nav-android-tab"
                          data-toggle="tab"
                          href="#nav-android"
                          role="tab"
                          aria-controls="nav-android"
                          aria-selected="true"
                        >
                          Android
                        </a>
                        <a
                          className="nav-link "
                          id="nav-ios-tab"
                          data-toggle="tab"
                          href="#nav-ios"
                          role="tab"
                          aria-controls="nav-ios"
                          aria-selected="true"
                        >
                          iOS
                        </a>
                      </div>
                    </nav>
                    <div
                      className="tab-content x-bookmark-tabs-content-wrapper"
                      id="nav-tabContent"
                    >
                      <div
                        className="tab-pane fade show active"
                        id="nav-android"
                        role="tabpanel"
                        aria-labelledby="nav-android-tab"
                      >
                        <div
                          className="-slide-wrapper -bookmark-slider-for-android"
                          data-slickable='{"arrows":false,"dots":true,"slidesToShow":1,"fade":true,"infinite":true,"autoplay":false,"asNavFor":".-bookmark-slider-nav-android"}'
                        >
                          <div className="-slide-inner-wrapper">
                            <img
                              src="/build/web/igame-index-lobby-wm/img/bookmark-android-1.png"
                              className="-img"
                              alt="บาคาร่าออนไลน์ คาสิโนออนไลน์ อันดับ 1 ของไทย"
                            />
                          </div>
                          <div className="-slide-inner-wrapper">
                            <img
                              src="/build/web/igame-index-lobby-wm/img/bookmark-android-2.png"
                              className="-img"
                              alt="บาคาร่าออนไลน์ คาสิโนออนไลน์ อันดับ 1 ของไทย"
                            />
                          </div>
                          <div className="-slide-inner-wrapper">
                            <img
                              src="/build/web/igame-index-lobby-wm/img/bookmark-android-3.png"
                              className="-img"
                              alt="บาคาร่าออนไลน์ คาสิโนออนไลน์ อันดับ 1 ของไทย"
                            />
                          </div>
                          <div className="-slide-inner-wrapper">
                            <img
                              src="/build/web/igame-index-lobby-wm/img/bookmark-android-4.png"
                              className="-img"
                              alt="บาคาร่าออนไลน์ คาสิโนออนไลน์ อันดับ 1 ของไทย"
                            />
                          </div>
                        </div>
                        <div
                          className="-slide-wrapper -bookmark-slider-nav-android"
                          data-slickable='{"arrows":false,"dots":false,"slidesToShow":1,"fade":true,"infinite":true,"autoplay":false,"asNavFor":".-bookmark-slider-for-android"}'
                        >
                          <div className="-slide-inner-wrapper px-3 pt-3">
                            <div className="-content-wrapper">
                              <div className="-number">1</div>
                              <div className="-description">
                                {t(lang,'ap_chrome_step1a')}
                                <br /> {t(lang,'ap_chrome_step1b')}
                              </div>
                            </div>
                          </div>
                          <div className="-slide-inner-wrapper px-3 pt-3">
                            <div className="-content-wrapper">
                              <div className="-number">2</div>
                              <div className="-description">
                                {t(lang,'ap_chrome_step2a')}<i className="fas fa-ellipsis-v" />
                                <br /> {t(lang,'ap_chrome_step2b')}
                              </div>
                            </div>
                          </div>
                          <div className="-slide-inner-wrapper px-3 pt-3">
                            <div className="-content-wrapper">
                              <div className="-number">3</div>
                              <div className="-description">
                                {t(lang,'ap_chrome_step3a')}
                                <br /> {t(lang,'ap_chrome_step3b')}
                              </div>
                            </div>
                          </div>
                          <div className="-slide-inner-wrapper px-3 pt-3">
                            <div className="-content-wrapper">
                              <div className="-number">4</div>
                              <div className="-description">
                                {t(lang,'ap_chrome_step4a')}
                                <br /> {t(lang,'ap_chrome_step4b')}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="tab-pane fade "
                        id="nav-ios"
                        role="tabpanel"
                        aria-labelledby="nav-ios-tab"
                      >
                        <div
                          className="-slide-wrapper -bookmark-slider-for-ios"
                          data-slickable='{"arrows":false,"dots":true,"slidesToShow":1,"fade":true,"infinite":true,"autoplay":false,"asNavFor":".-bookmark-slider-nav-ios"}'
                        >
                          <div className="-slide-inner-wrapper">
                            <img
                              src="/build/web/igame-index-lobby-wm/img/bookmark-ios-1.png"
                              className="-img"
                              alt="บาคาร่าออนไลน์ คาสิโนออนไลน์ อันดับ 1 ของไทย"
                            />
                          </div>
                          <div className="-slide-inner-wrapper">
                            <img
                              src="/build/web/igame-index-lobby-wm/img/bookmark-ios-2.png"
                              className="-img"
                              alt="บาคาร่าออนไลน์ คาสิโนออนไลน์ อันดับ 1 ของไทย"
                            />
                          </div>
                          <div className="-slide-inner-wrapper">
                            <img
                              src="/build/web/igame-index-lobby-wm/img/bookmark-ios-3.png"
                              className="-img"
                              alt="บาคาร่าออนไลน์ คาสิโนออนไลน์ อันดับ 1 ของไทย"
                            />
                          </div>
                          <div className="-slide-inner-wrapper">
                            <img
                              src="/build/web/igame-index-lobby-wm/img/bookmark-ios-4.png"
                              className="-img"
                              alt="บาคาร่าออนไลน์ คาสิโนออนไลน์ อันดับ 1 ของไทย"
                            />
                          </div>
                        </div>
                        <div
                          className="-slide-wrapper -bookmark-slider-nav-ios"
                          data-slickable='{"arrows":false,"dots":false,"slidesToShow":1,"fade":true,"infinite":true,"autoplay":false,"asNavFor":".-bookmark-slider-for-ios"}'
                        >
                          <div className="-slide-inner-wrapper px-3 pt-3">
                            <div className="-content-wrapper">
                              <div className="-number">1</div>
                              <div className="-description">
                                {t(lang,'ap_chrome_step1a')}
                                <br /> {t(lang,'ap_chrome_step1b')}
                              </div>
                            </div>
                          </div>
                          <div className="-slide-inner-wrapper px-3 pt-3">
                            <div className="-content-wrapper">
                              <div className="-number">2</div>
                              <div className="-description">
                                {t(lang,'ap_chrome_step2a')}<i className="fas fa-ellipsis-v" />
                                <br /> {t(lang,'ap_chrome_step2b')}
                              </div>
                            </div>
                          </div>
                          <div className="-slide-inner-wrapper px-3 pt-3">
                            <div className="-content-wrapper">
                              <div className="-number">3</div>
                              <div className="-description">
                                {t(lang,'ap_chrome_step3a')}
                                <br /> {t(lang,'ap_chrome_step3b')}
                              </div>
                            </div>
                          </div>
                          <div className="-slide-inner-wrapper px-3 pt-3">
                            <div className="-content-wrapper">
                              <div className="-number">4</div>
                              <div className="-description">
                                {t(lang,'ap_chrome_step4a')}
                                <br /> {t(lang,'ap_chrome_step4b')}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="account-actions" className>
            <div className="x-button-actions" id="account-actions-mobile">
              <div className="-outer-wrapper">
                <div className="-left-wrapper" style={{ display: (this.state.loginstate ? "" : "none") }}>

                  <a
                    href="#register"
                    className="-item-wrapper -shimmer -register"
                    data-toggle="modal"
                    data-target="#depositChoosePromotionModal"
                  >
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="https://cdn.javisx.com/image/1023407a-04d6-434a-b3d2-1dbcd07298c2.png"
                      />
                      <source
                        type="image/png"
                        srcSet="https://cdn.javisx.com/image/1023407a-04d6-434a-b3d2-1dbcd07298c2.png"
                      />
                      <img
                        src="https://cdn.javisx.com/image/1023407a-04d6-434a-b3d2-1dbcd07298c2.png"
                        className="-ic-img"
                        alt="รูปไอคอนไลน์"
                        width={34}
                        height={34}
                      />
                    </picture>
                    <span className="-text d-none d-sm-inline-block">{t(lang,'ap_deposit')}</span>
                    <span className="-text d-sm-none">{t(lang,'ap_deposit')}</span>
                  </a>
                  <a
                    href="#login"
                    className="-item-wrapper -login"
                    data-toggle="modal"
                    data-target="#withdrawModal"
                  >
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="https://cdn.javisx.com/image/271c67a1-6cce-49b4-8a54-4972155b0b61.png"
                      />
                      <source
                        type="image/png"
                        srcSet="https://cdn.javisx.com/image/271c67a1-6cce-49b4-8a54-4972155b0b61.png"
                      />
                      <img
                        src="https://cdn.javisx.com/image/271c67a1-6cce-49b4-8a54-4972155b0b61.png"
                        className="-ic-img"
                        alt="รูปไอคอนไลน์"
                        width={34}
                        height={34}
                      />
                    </picture>
                    <span className="-text d-none d-sm-inline-block">{t(lang,'ap_withdraw')}</span>
                    <span className="-text d-sm-none">{t(lang,'ap_withdraw')}</span>
                  </a>
                </div>
                <div className="-left-wrapper" style={{ display: (this.state.loginstate ? "none" : "") }} >
                  <a
                    className="-item-wrapper -shimmer -register"
                    data-target="#registerModal" data-toggle="modal"
                  >
                    <picture>
                      <source type="image/webp" srcSet="/build/web/igame-index-lobby-wm/img/footer-menu-ic-right-anon-1.webp" />
                      <source type="image/png" srcSet="/build/web/igame-index-lobby-wm/img/footer-menu-ic-right-anon-1.png" />
                      <img src="/build/web/igame-index-lobby-wm/img/footer-menu-ic-right-anon-1.png" className="-ic-img" alt="รูปไอคอนไลน์" width={34} height={34} />
                    </picture>
                    <span className="-text d-none d-sm-inline-block">{t(lang,'ap_register')}</span>
                    <span className="-text d-sm-none">{t(lang,'ap_register_now')}</span>
                  </a>
                  <a href="#login" className="-item-wrapper -login" data-toggle="modal" data-target="#loginModal">
                    <picture>
                      <source type="image/webp" srcSet="/build/web/igame-index-lobby-wm/img/footer-menu-ic-right-anon-2.webp" />
                      <source type="image/png" srcSet="/build/web/igame-index-lobby-wm/img/footer-menu-ic-right-anon-2.png" />
                      <img src="/build/web/igame-index-lobby-wm/img/footer-menu-ic-right-anon-2.png" className="-ic-img" alt="รูปไอคอนไลน์" width={34} height={34} />
                    </picture>
                    <span className="-text d-none d-sm-inline-block">{t(lang,'ap_login')}</span>
                    <span className="-text d-sm-none">{t(lang,'ap_login_short')}</span>
                  </a>
                </div>
                <a href="/" className="-center-wrapper">
                  <div className="-selected">
                    <img src={this.state.logoimg || "/build/web/igame-index-lobby-wm/img/logo.png?v=1"} style={{ marginTop: "12px" }} className="-top-curve" alt="คาสิโนออนไลน์อันดับ 1" />
                  </div>
                </a>
                <div className="-fake-center-bg-wrapper">
                  <svg viewBox="-10 -1 30 12">
                    <defs>
                      <linearGradient id="rectangleGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                        <stop offset="25%" stopColor="#b50062"></stop>
                        <stop offset="95%" stopColor="#4a134b"></stop>
                      </linearGradient>
                    </defs>

                    <path d="M-10 -1 H30 V12 H-10z M 5 5 m -5, 0 a 5,5 0 1,0 10,0 a 5,5 0 1,0 -10,0z"></path>
                  </svg>
                </div>
                {/* <ul className="navbar-nav -sub-menu-lobby-wrapper">
                  <li className="nav-item -casino">
                    <button className="nav-link" data-target=".js-game-container" data-menu-container=".js-menu-container" data-loading="_onLoading_" data-menu-mobile-container=".js-menu-mobile-container" data-menu-mobile="data-menu-mobile" data-category="casino">
                      <div className="-nav-icon-bg" style={{ backgroundImage: "url(build/web/igame-index-lobby-wm/img/ic-nav-menu-all.png)" }}>
                      </div>
                      <span className="-text">
                        {t(lang,'ap_baccarat')}
                      </span>
                    </button>
                  </li>
                  <li className="nav-item -slot">
                    <button className="nav-link" data-target=".js-game-container" data-menu-container=".js-menu-container" data-loading="_onLoading_" data-menu-mobile-container=".js-menu-mobile-container" data-menu-mobile="data-menu-mobile" data-category="slot">
                      <div className="-nav-icon-bg" style={{ backgroundImage: "url(build/web/igame-index-lobby-wm/img/ic-nav-menu-all.png)" }}>
                      </div>
                      <span className="-text">
                        {t(lang,'ap_casino')}
                      </span>
                    </button>
                  </li>
                  <li className="nav-item -skill-game">
                    <button className="nav-link" data-target=".js-game-container" data-menu-container=".js-menu-container" data-loading="_onLoading_" data-menu-mobile-container=".js-menu-mobile-container" data-menu-mobile="data-menu-mobile" data-category="skill-game">
                      <div className="-nav-icon-bg" style={{ backgroundImage: "url(build/web/igame-index-lobby-wm/img/ic-nav-menu-all.png)" }}>
                      </div>
                      <span className="-text">
                        SKILL<br />GAME
                      </span>
                    </button>
                  </li>
                  <li className="nav-item -sport">
                    <button className="nav-link" data-target=".js-game-container" data-menu-container=".js-menu-container" data-loading="_onLoading_" data-menu-mobile-container=".js-menu-mobile-container" data-menu-mobile="data-menu-mobile" data-category="sport">
                      <div className="-nav-icon-bg" style={{ backgroundImage: "url(build/web/igame-index-lobby-wm/img/ic-nav-menu-all.png)" }}>
                      </div>
                      <span className="-text">
                        SPORT
                      </span>
                    </button>
                  </li>
                  <li className="nav-item -fishing-game">
                    <button className="nav-link" data-target=".js-game-container" data-menu-container=".js-menu-container" data-loading="_onLoading_" data-menu-mobile-container=".js-menu-mobile-container" data-menu-mobile="data-menu-mobile" data-category="fishing-game">
                      <div className="-nav-icon-bg" style={{ backgroundImage: "url(build/web/igame-index-lobby-wm/img/ic-nav-menu-all.png)" }}>
                      </div>
                      <span className="-text">
                        FISHING
                      </span>
                    </button>
                  </li>
                  <li className="nav-item -skill-game">
                    <button className="nav-link" data-target=".js-game-container" data-menu-container=".js-menu-container" data-loading="_onLoading_" data-menu-mobile-container=".js-menu-mobile-container" data-menu-mobile="data-menu-mobile" data-category="fishing-game">
                      <div className="-nav-icon-bg" style={{ backgroundImage: "url(build/web/igame-index-lobby-wm/img/ic-nav-menu-all.png)" }}>
                      </div>
                      <span className="-text">
                        FREEGAME
                      </span>
                    </button>
                  </li>
                </ul> */}
                <div className="-right-wrapper">

                  <a href="/Lucky-fortune" className="-item-wrapper -promotion">
                    <picture>
                      <source type="image/webp" srcSet="https://cdn.javisx.com/image/f491a0be-f4ef-4fca-9e71-c87e16e13a36.png" />
                      <source type="image/png" srcSet="https://cdn.javisx.com/image/f491a0be-f4ef-4fca-9e71-c87e16e13a36.png" />
                      <img src="https://cdn.javisx.com/image/f491a0be-f4ef-4fca-9e71-c87e16e13a36.png" className="-ic-img" alt="รูปไอคอนไลน์" width={34} height={34} />
                    </picture>
                    <span className="-text">{t(lang,'ap_wheel')}</span>
                  </a>

                  <a href={this.state.linelink} className="-item-wrapper -line" target="_blank" rel="noopener noreferrer">
                    <picture>
                      <source type="image/webp" srcSet="/build/web/igame-index-lobby-wm/img/footer-menu-ic-left-1.webp" />
                      <source type="image/png" srcSet="/build/web/igame-index-lobby-wm/img/footer-menu-ic-left-1.png" />
                      <img src="/build/web/igame-index-lobby-wm/img/footer-menu-ic-left-1.png" className="-ic-img" alt="รูปไอคอนไลน์" width={34} height={34} />
                    </picture>
                    <span className="-text">Line</span>
                  </a>

                </div>
                {/* <div className="-right-wrapper" style={{ display: (this.state.loginstate? "none" : "") }}>
              
                </div> */}
                <div className="-fully-overlay js-footer-lobby-overlay" />
              </div>
            </div>
          </div>
          <div className="x-modal modal -alert-modal" id="alertModal" tabIndex={-1} role="dialog" aria-hidden="true" data-loading-container=".js-modal-content" data-ajax-modal-always-reload="true" data-animatable="fadeInRight" data-delay={700} data-dismiss-alert="true">
            <div className="modal-dialog -modal-size  " role="document">
              <div className="modal-content -modal-content">
                <button type="button" className="close f-1 " data-dismiss="modal" aria-label="Close">
                  <i className="fas fa-times" />
                </button>
                <div className="modal-body -modal-body">
                  <div className="d-flex -alert-body">
                    <div className="text-center mr-3 -alert-body-wrapper">
                      <img src="/build/web/igame-index-lobby-wm/img/ic-alert-success.png" alt="SUCCESS" className="-img-alert js-ic-success img-fluid lazyload" />
                      <img src="/build/web/igame-index-lobby-wm/img/ic-alert-failed.png" alt="FAIL" className="-img-alert js-ic-fail img-fluid lazyload" />
                    </div>
                    <div className="my-auto js-modal-content -title" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="x-modal modal " id="loginModal" tabIndex={-1} role="dialog" aria-hidden="true" data-loading-container=".js-modal-content" data-ajax-modal-always-reload="true">
            <div className="modal-dialog -modal-size modal-dialog-centered modal-dialog-scrollable -dialog-in-tab" role="document">
              <div className="modal-content -modal-content">
                <button type="button" className="close f-1 -in-tab" data-dismiss="modal" aria-label="Close">
                  <i className="fas fa-times" />
                </button>
                <div className="x-modal-account-security-tabs">
                  <button type="button" className="-btn -register js-modal-account-security-tab-button"
                    data-target="#registerModal" data-toggle="modal"

                  >
                    {t(lang,'ap_register')}
                  </button>
                  <button type="button" className="-btn -login js-modal-account-security-tab-button -active" data-modal-target="#loginModal">
                    {t(lang,'ap_login')}
                  </button>
                </div>

                <div className="modal-body -modal-body">
                  <div className="x-modal-separator-container x-login-form">
                    <div className="-top ">
                      <div data-animatable="fadeInModal">
                        <div className="-img-container text-center">
                          <img src="/build/web/igame-index-lobby-wm/img/ic-login.png" className="-ic-login img-fluid lazyload" alt="login" width={178} height={112} />
                        </div>
                        <form action="/login-json-check" className="js-login-form">
                          <div className="-x-input-icon mb-3 flex-column">
                            <img src="/build/web/igame-index-lobby-wm/img/ic-input-phone.png" className="-icon img-fluid lazyload" alt="login" width={10} height={14} />
                            <input type="text" id="username" inputMode="text" name="username" pattern="[0-9]*" autoFocus className="form-control x-form-control" placeholder={t(lang,'ap_phone_placeholder')} />
                          </div>
                          <div className="-x-input-icon flex-column">
                            <img src="/build/web/igame-index-lobby-wm/img/ic-input-lock.png" className="-icon img-fluid lazyload" alt="password" width={14} height={14} />
                            <input type="password" id="password" name="password" className="form-control x-form-control" placeholder={t(lang,'ap_password_placeholder')} />
                          </div>
                          <div className="x-reset-pw-text-container">
                            <a href="#resetPassword" data-dismiss="modal" data-toggle="modal" data-target="#resetPasswordModal">
                              <u>{t(lang,'ap_forgot_password')}</u>
                            </a>
                          </div>
                          <div className="text-center">
                            <button type="submit" className="btn btn-primary ">
                              <span>{t(lang,'ap_login')}</span>
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div className="-bottom ">
                      <div data-animatable="fadeInModal">
                        <div className="x-admin-contact ">
                          <span className="x-text-with-link-component">
                            <label className="-text-message ">{t(lang,'ap_found_problem')}</label>
                            <a href={this.state.linelink} className="-link-message " target="_blank" rel="noopener noreferrer">
                              <u>{t(lang,'ap_contact_support')}</u>
                            </a>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="x-modal modal " id="registerModalLegacy" tabIndex={-1} role="dialog" aria-hidden="true" data-loading-container=".modal-body" data-ajax-modal-always-reload="true" data-ajax-modal="/_ajax_/register"
            data-container="#registerModal">
            <div className="modal-dialog -modal-size modal-dialog-centered modal-dialog-scrollable " role="document">
              <div className="modal-content -modal-content">
                <button type="button" className="close f-1 " data-dismiss="modal" aria-label="Close">
                  <i className="fas fa-times" />
                </button>
                <div className="modal-header -modal-header">
                  <h3 className="x-title-modal d-inline-block m-auto">
                    <span />
                  </h3>
                </div>
                <div className="modal-body -modal-body">
                  <div className="js-modal-content" />
                </div>
              </div>
            </div>
          </div>

          <div className="x-modal modal " id="resetPasswordModal" tabIndex={-1} role="dialog" aria-hidden="true" data-loading-container=".modal-body" data-ajax-modal-always-reload="true" data-ajax-modal="/_ajax_/reset-password" data-container="#resetPasswordModal">
            <div className="modal-dialog -modal-size modal-dialog-centered modal-dialog-scrollable " role="document">
              <div className="modal-content -modal-content">
                <button type="button" className="close f-1 " data-dismiss="modal" aria-label="Close">
                  <i className="fas fa-times" />
                </button>
                <div className="modal-header -modal-header">
                  <h3 className="x-title-modal d-inline-block m-auto">
                    <span />
                  </h3>
                </div>
                <div className="modal-body -modal-body">
                  <div className="js-modal-content" />
                </div>
              </div>
            </div>
          </div>
          <div className="x-modal modal " id="alertModal" tabIndex={-1} role="dialog" aria-hidden="true" data-loading-container=".js-modal-content" data-ajax-modal-always-reload="true">
            <div className="modal-dialog -modal-size  " role="document">
              <div className="modal-content -modal-content">
                <button type="button" className="close f-1 " data-dismiss="modal" aria-label="Close">
                  <i className="fas fa-times" />
                </button>
                <div className="modal-header -modal-header">
                  <h3 className="x-title-modal d-inline-block m-auto">
                    <span>{t(lang,'ap_notify')}</span>
                  </h3>
                </div>
                <div className="modal-body -modal-body">
                  <div className="text-center my-3">
                    <img src="/build/web/igame-index-lobby-wm/img/ic-alert-success.png" alt="SUCCESS" className="js-ic-success -img img-fluid lazyload" width={100} height={100} />
                    <img src="/build/web/igame-index-lobby-wm/img/ic-alert-failed.png" alt="FAIL" className="js-ic-fail -img img-fluid lazyload" width={100} height={100} />
                  </div>
                  <div className="js-modal-content text-center f-4" />
                </div>
              </div>
            </div>
          </div>
          <div className="x-right-sidebar-container">
          </div>
          <div className="x-modal modal " id="themeSwitcherModal" tabIndex={-1} role="dialog" aria-hidden="true" data-loading-container=".js-modal-content" data-ajax-modal-always-reload="true">
            <div className="modal-dialog -modal-size modal-dialog-centered modal-dialog-scrollable modal-dialog-centered modal-dialog-scrollable" role="document">
              <div className="modal-content -modal-content">
                <div className="modal-body -modal-body">
                  <div className="x-theme-switcher">
                    <ul className="nav">
                      <li className="nav-item -sa " data-animatable="fadeInUp" data-delay={100}>
                        <a href="index-77.htm" className="nav-link" rel="ugc,nofollow">
                          <img src="/build/web/shared/img/logo-sa-1.png" alt="SA Casino คาสิโนออนไลน์ สล็อตออนไลน์ ดีที่สุดในประเทศไทย logo png" className="-logo" width={50} height={50} />
                          <div className="-text">SA Casino</div>
                        </a>
                      </li>
                      <li className="nav-item -label -active" data-animatable="fadeInUp" data-delay={100}>
                        <a href="/" className="nav-link" rel="ugc,nofollow">
                          <img src="/build/web/shared/img/logo-wm-1.png" alt="Ae sexy  Casino คาสิโนออนไลน์ สล็อตออนไลน์ ดีที่สุดในประเทศไทย logo png" className="-logo" width={50} height={50} />
                          <div className="-text">Ae sexy  Casino</div>
                        </a>
                      </li>
                      <li className="nav-item -sexy " data-animatable="fadeInUp" data-delay={100}>
                        <a href="index-78.htm" className="nav-link" rel="ugc,nofollow">
                          <img src="/build/web/shared/img/logo-sexy-1.png" alt="Sexy Gaming คาสิโนออนไลน์ สล็อตออนไลน์ ดีที่สุดในประเทศไทย logo png" className="-logo" width={50} height={50} />
                          <div className="-text">Sexy Gaming</div>
                        </a>
                      </li>
                      <li className="nav-item -dream " data-animatable="fadeInUp" data-delay={100}>
                        <a href="index-79.htm" className="nav-link" rel="ugc,nofollow">
                          <img src="/build/web/shared/img/logo-dream-1.png" alt="Dream Gaming คาสิโนออนไลน์ สล็อตออนไลน์ ดีที่สุดในประเทศไทย logo png" className="-logo" width={50} height={50} />
                          <div className="-text">Dream Gaming</div>
                        </a>
                      </li>
                      <li className="nav-item -pretty " data-animatable="fadeInUp" data-delay={100}>
                        <a href="index-80.htm" className="nav-link" rel="ugc,nofollow">
                          <img src="/build/web/shared/img/logo-pretty-1.png" alt="Pretty Gaming คาสิโนออนไลน์ สล็อตออนไลน์ ดีที่สุดในประเทศไทย logo png" className="-logo" width={50} height={50} />
                          <div className="-text">Pretty Gaming</div>
                        </a>
                      </li>
                      <li className="nav-item -ae " data-animatable="fadeInUp" data-delay={100}>
                        <a href="index-81.htm" className="nav-link" rel="ugc,nofollow">
                          <img src="/build/web/shared/img/logo-ae-1.png" alt="Momobet คาสิโนออนไลน์ สล็อตออนไลน์ ดีที่สุดในประเทศไทย logo png" className="-logo" width={50} height={50} />
                          <div className="-text">Momobet</div>
                        </a>
                      </li>
                      <li className="nav-item -allbet " data-animatable="fadeInUp" data-delay={100}>
                        <a href="index-82.htm" className="nav-link" rel="ugc,nofollow">
                          <img src="/build/web/shared/img/logo-allbet-1.png" alt="Allbet คาสิโนออนไลน์ สล็อตออนไลน์ ดีที่สุดในประเทศไทย logo png" className="-logo" width={50} height={50} />
                          <div className="-text">Allbet</div>
                        </a>
                      </li>
                      <li className="nav-item -eg " data-animatable="fadeInUp" data-delay={100}>
                        <a href="index-83.htm" className="nav-link" rel="ugc,nofollow">
                          <img src="/build/web/shared/img/logo-eg.png" alt="Evo Gaming คาสิโนออนไลน์ สล็อตออนไลน์ ดีที่สุดในประเทศไทย logo png" className="-logo" width={50} height={50} />
                          <div className="-text">Evo Gaming</div>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="d-lg-none">
            <div className="x-modal modal " id="bookmarkModal" tabIndex={-1} role="dialog" aria-hidden="true" data-loading-container=".js-modal-content" data-ajax-modal-always-reload="true">
              <div className="modal-dialog -modal-size modal-dialog-centered modal-dialog-scrollable         -no-fixed-button
    " role="document">
                <div className="modal-content -modal-content">
                  <button type="button" className="close f-1 " data-dismiss="modal" aria-label="Close">
                    <i className="fas fa-times" />
                  </button>
                  <div className="modal-header -modal-header">
                    <h3 className="x-title-modal d-inline-block m-auto">
                      <span>Bookmark</span>
                    </h3>
                  </div>
                  <div className="modal-body -modal-body">
                    <div className="x-bookmark-modal-container">
                      <nav>
                        <div className="nav nav-tabs x-bookmark-tabs-header-wrapper" id="nav-tab" role="tablist">
                          <a className="nav-link active" id="nav-android-tab" data-toggle="tab" href="#nav-android" role="tab" aria-controls="nav-android" aria-selected="true">Android</a>
                          <a className="nav-link " id="nav-ios-tab" data-toggle="tab" href="#nav-ios" role="tab" aria-controls="nav-ios" aria-selected="true">iOS</a>
                        </div>
                      </nav>
                      <div className="tab-content x-bookmark-tabs-content-wrapper" id="nav-tabContent">
                        <div className="tab-pane fade show active" id="nav-android" role="tabpanel" aria-labelledby="nav-android-tab">
                          <div className="-slide-wrapper -bookmark-slider-for-android" data-slickable="{&quot;arrows&quot;:false,&quot;dots&quot;:true,&quot;slidesToShow&quot;:1,&quot;fade&quot;:true,&quot;infinite&quot;:true,&quot;autoplay&quot;:false,&quot;asNavFor&quot;:&quot;.-bookmark-slider-nav-android&quot;}">
                            <div className="-slide-inner-wrapper">
                              <img src="/build/web/igame-index-lobby-wm/img/bookmark-android-1.png" className="-img" alt="บาคาร่าออนไลน์ คาสิโนออนไลน์ อันดับ 1 ของไทย" />
                            </div>
                            <div className="-slide-inner-wrapper">
                              <img src="/build/web/igame-index-lobby-wm/img/bookmark-android-2.png" className="-img" alt="บาคาร่าออนไลน์ คาสิโนออนไลน์ อันดับ 1 ของไทย" />
                            </div>
                            <div className="-slide-inner-wrapper">
                              <img src="/build/web/igame-index-lobby-wm/img/bookmark-android-3.png" className="-img" alt="บาคาร่าออนไลน์ คาสิโนออนไลน์ อันดับ 1 ของไทย" />
                            </div>
                            <div className="-slide-inner-wrapper">
                              <img src="/build/web/igame-index-lobby-wm/img/bookmark-android-4.png" className="-img" alt="บาคาร่าออนไลน์ คาสิโนออนไลน์ อันดับ 1 ของไทย" />
                            </div>
                          </div>
                          <div className="-slide-wrapper -bookmark-slider-nav-android" data-slickable="{&quot;arrows&quot;:false,&quot;dots&quot;:false,&quot;slidesToShow&quot;:1,&quot;fade&quot;:true,&quot;infinite&quot;:true,&quot;autoplay&quot;:false,&quot;asNavFor&quot;:&quot;.-bookmark-slider-for-android&quot;}">
                            <div className="-slide-inner-wrapper px-3 pt-3">
                              <div className="-content-wrapper">
                                <div className="-number">1</div>
                                <div className="-description">{t(lang,'ap_chrome_step1a')}<br /> {t(lang,'ap_chrome_step1b')}</div>
                              </div>
                            </div>
                            <div className="-slide-inner-wrapper px-3 pt-3">
                              <div className="-content-wrapper">
                                <div className="-number">2</div>
                                <div className="-description">{t(lang,'ap_chrome_step2a')}<i className="fas fa-ellipsis-v" /><br /> {t(lang,'ap_chrome_step2b')}</div>
                              </div>
                            </div>
                            <div className="-slide-inner-wrapper px-3 pt-3">
                              <div className="-content-wrapper">
                                <div className="-number">3</div>
                                <div className="-description">{t(lang,'ap_chrome_step3a')}<br /> {t(lang,'ap_chrome_step3b')}</div>
                              </div>
                            </div>
                            <div className="-slide-inner-wrapper px-3 pt-3">
                              <div className="-content-wrapper">
                                <div className="-number">4</div>
                                <div className="-description">{t(lang,'ap_chrome_step4a')}<br /> {t(lang,'ap_chrome_step4b')}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="tab-pane fade " id="nav-ios" role="tabpanel" aria-labelledby="nav-ios-tab">
                          <div className="-slide-wrapper -bookmark-slider-for-ios" data-slickable="{&quot;arrows&quot;:false,&quot;dots&quot;:true,&quot;slidesToShow&quot;:1,&quot;fade&quot;:true,&quot;infinite&quot;:true,&quot;autoplay&quot;:false,&quot;asNavFor&quot;:&quot;.-bookmark-slider-nav-ios&quot;}">
                            <div className="-slide-inner-wrapper">
                              <img src="/build/web/igame-index-lobby-wm/img/bookmark-ios-1.png" className="-img" alt="บาคาร่าออนไลน์ คาสิโนออนไลน์ อันดับ 1 ของไทย" />
                            </div>
                            <div className="-slide-inner-wrapper">
                              <img src="/build/web/igame-index-lobby-wm/img/bookmark-ios-2.png" className="-img" alt="บาคาร่าออนไลน์ คาสิโนออนไลน์ อันดับ 1 ของไทย" />
                            </div>
                            <div className="-slide-inner-wrapper">
                              <img src="/build/web/igame-index-lobby-wm/img/bookmark-ios-3.png" className="-img" alt="บาคาร่าออนไลน์ คาสิโนออนไลน์ อันดับ 1 ของไทย" />
                            </div>
                            <div className="-slide-inner-wrapper">
                              <img src="/build/web/igame-index-lobby-wm/img/bookmark-ios-4.png" className="-img" alt="บาคาร่าออนไลน์ คาสิโนออนไลน์ อันดับ 1 ของไทย" />
                            </div>
                          </div>
                          <div className="-slide-wrapper -bookmark-slider-nav-ios" data-slickable="{&quot;arrows&quot;:false,&quot;dots&quot;:false,&quot;slidesToShow&quot;:1,&quot;fade&quot;:true,&quot;infinite&quot;:true,&quot;autoplay&quot;:false,&quot;asNavFor&quot;:&quot;.-bookmark-slider-for-ios&quot;}">
                            <div className="-slide-inner-wrapper px-3 pt-3">
                              <div className="-content-wrapper">
                                <div className="-number">1</div>
                                <div className="-description">{t(lang,'ap_chrome_step1a')}<br /> {t(lang,'ap_chrome_step1b')}</div>
                              </div>
                            </div>
                            <div className="-slide-inner-wrapper px-3 pt-3">
                              <div className="-content-wrapper">
                                <div className="-number">2</div>
                                <div className="-description">{t(lang,'ap_chrome_step2a')}<i className="fas fa-ellipsis-v" /><br /> {t(lang,'ap_chrome_step2b')}</div>
                              </div>
                            </div>
                            <div className="-slide-inner-wrapper px-3 pt-3">
                              <div className="-content-wrapper">
                                <div className="-number">3</div>
                                <div className="-description">{t(lang,'ap_chrome_step3a')}<br /> {t(lang,'ap_chrome_step3b')}</div>
                              </div>
                            </div>
                            <div className="-slide-inner-wrapper px-3 pt-3">
                              <div className="-content-wrapper">
                                <div className="-number">4</div>
                                <div className="-description">{t(lang,'ap_chrome_step4a')}<br /> {t(lang,'ap_chrome_step4b')}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <script id="b-loading" type="text/template">
          <div className="x-dice-container py-5 m-auto d-flex">
            <div id="dice" className="mx-auto">
              <div className="side front">
                <div className="dot center bg-danger"></div>
              </div>
              <div className="side front inner"></div>
              <div className="side top">
                <div className="dot dtop dleft"></div>
                <div className="dot dbottom dright"></div>
              </div>
              <div className="side top inner"></div>
              <div className="side right">
                <div className="dot dtop dleft"></div>
                <div className="dot center"></div>
                <div className="dot dbottom dright"></div>
              </div>
              <div className="side right inner"></div>
              <div className="side left">
                <div className="dot dtop dleft"></div>
                <div className="dot dtop dright"></div>
                <div className="dot dbottom dleft"></div>
                <div className="dot dbottom dright"></div>
              </div>
              <div className="side left inner"></div>
              <div className="side bottom">
                <div className="dot center"></div>
                <div className="dot dtop dleft"></div>
                <div className="dot dtop dright"></div>
                <div className="dot dbottom dleft"></div>
                <div className="dot dbottom dright"></div>
              </div>
              <div className="side bottom inner"></div>
              <div className="side back">
                <div className="dot dtop dleft"></div>
                <div className="dot dtop dright"></div>
                <div className="dot dbottom dleft"></div>
                <div className="dot dbottom dright"></div>
                <div className="dot center dleft"></div>
                <div className="dot center dright"></div>
              </div>
              <div className="side back inner"></div>
              <div className="side cover x"></div>
              <div className="side cover y"></div>
              <div className="side cover z"></div>
            </div>
          </div>
        </script>
        <script id="loading" type="text/template">
          <div className="x-dice-container py-5 m-auto d-flex">
            <div id="dice" className="mx-auto">
              <div className="side front">
                <div className="dot center bg-danger"></div>
              </div>
              <div className="side front inner"></div>
              <div className="side top">
                <div className="dot dtop dleft"></div>
                <div className="dot dbottom dright"></div>
              </div>
              <div className="side top inner"></div>
              <div className="side right">
                <div className="dot dtop dleft"></div>
                <div className="dot center"></div>
                <div className="dot dbottom dright"></div>
              </div>
              <div className="side right inner"></div>
              <div className="side left">
                <div className="dot dtop dleft"></div>
                <div className="dot dtop dright"></div>
                <div className="dot dbottom dleft"></div>
                <div className="dot dbottom dright"></div>
              </div>
              <div className="side left inner"></div>
              <div className="side bottom">
                <div className="dot center"></div>
                <div className="dot dtop dleft"></div>
                <div className="dot dtop dright"></div>
                <div className="dot dbottom dleft"></div>
                <div className="dot dbottom dright"></div>
              </div>
              <div className="side bottom inner"></div>
              <div className="side back">
                <div className="dot dtop dleft"></div>
                <div className="dot dtop dright"></div>
                <div className="dot dbottom dleft"></div>
                <div className="dot dbottom dright"></div>
                <div className="dot center dleft"></div>
                <div className="dot center dright"></div>
              </div>
              <div className="side back inner"></div>
              <div className="side cover x"></div>
              <div className="side cover y"></div>
              <div className="side cover z"></div>
            </div>
          </div>
        </script>
        <div
          className="x-modal modal -v2 -with-backdrop -with-separator -with-collapse show"
          id="depositChoosePromotionModal"
          role="dialog"
          data-loading-container=".modal-body"
          data-ajax-modal-always-reload="true"
          tabIndex={-1}
          data-container="#depositChoosePromotionModal"
          style={{ display: "none", paddingRight: 17 }}
          aria-modal="true"
        >
          <div style={{ display: this.state.tabdeposit == 1 ? "" : "none" }} className="modal-dialog -modal-size -v2 modal-dialog-centered modal-dialog-scrollable -modal-deposit -modal-mobile -modal-bigger"
            role="document"
          >
            <div className="modal-content -modal-content">
              <button
                type="button"
                className="close f-1 -in-deposit-promotion-collapse"
                data-dismiss="modal"
                aria-label="Close"
              >
                <i className="fas fa-times" />
              </button>
              <div className="modal-body -modal-body">
                <div className="x-deposit-form -v3">
                  <div className="-deposit-container">
                    <div className="order-1 order-2 js-slide-promotion-content js-slide-left-content x-slide-left-content -collapse-wrapper js-auto-open">
                      <div className="-fake-bg-bottom-wrapper ">
                        <div className="-top-body-wrapper -header-spacer -spacer-smaller">
                          <div className="x-deposit-promotion-collapse-container">
                            <div className="-title-wrapper">
                              <picture>
                                <source
                                  type="image/webp"
                                  data-srcset="https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/ic-deposit-promotion-collapse-gift.webp?v=1"
                                  srcSet="https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/ic-deposit-promotion-collapse-gift.webp?v=1"
                                />
                                <source
                                  type="image/png"
                                  data-srcset="https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/ic-deposit-promotion-collapse-gift.png"
                                  srcSet="https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/ic-deposit-promotion-collapse-gift.png"
                                />
                                <img
                                  alt="icon ฝาก เลือกโปรโมชั่น"
                                  className="img-fluid -icon ls-is-cached lazyloaded "
                                  width={20}
                                  height={24}
                                  data-src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/ic-deposit-promotion-collapse-gift.png"
                                  src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/ic-deposit-promotion-collapse-gift.png"
                                />
                              </picture>
                              <span className="-title">{t(lang,'ap_promo_available')}</span>
                            </div>
                          </div>
                        </div>
                        <div className="x-modal-separator-container ">
                          <div className="-top ">
                            <div className="-spacer-smaller">
                              <div className="js-promotion-active-html -promotion-container-wrapper">
                                <div className="x-deposit-promotion -v2  -in-promotion-collapse -has-promotion">
                                  <div id="deposit-promotion-collapse"
                                    className="-promotion-collapse-container js-scroll-to-top-container"
                                  >

                                    {prolistx.map((prolists, i) => {
                                      const isActive =
                                        proderedeem.length > 0 && proderedeem[0].prono === prolists.no;
                                      return (
                                        <div
                                          className={`-promotion-collapse ${isActive ? "-promotion-active" : ""}`}
                                          key={i}
                                        >
                                          <div
                                            className={`btn -btn-promotion-collapse js-btn-promotion-collapse ${isActive ? "-promotion-active" : ""
                                              }`}
                                            data-toggle="collapse"
                                            data-target={`#collapse_promotion-${i}`}
                                            aria-controls={`collapse_promotion-${i}`}
                                            data-collapse-scroll-to-top-container=".js-scroll-to-top-container"
                                          >
                                            <div className="-row-wrapper">
                                              <div className="-image-wrapper">
                                                <img
                                                  alt="AE SEXY Image"
                                                  className="img-fluid ls-is-cached lazyloaded"
                                                  data-src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/ic-promotion-collapse-default.png"
                                                  src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/ic-promotion-collapse-default.png"
                                                />
                                              </div>
                                              <div className="-title-wrapper">
                                                <div className="-promotion-title">{prolists.proname}</div>
                                              </div>
                                            </div>
                                            {isActive && (
                                              <div className="-promotion-cancel-wrapper">
                                                <a
                                                  role="button"
                                                  className="js-cancel-promotion -promotion-cancel-link"
                                                  onClick={(e) => { e.stopPropagation(); this.cancelredeempromotion(e, (this.state.proderedeem && this.state.proderedeem[0]) || prolists); }}
                                                >
                                                  <i className="fas fa-times" />
                                                </a>
                                              </div>
                                            )}
                                          </div>
                                          <div
                                            id={`collapse_promotion-${i}`}
                                            className="collapse"
                                            data-parent="#deposit-promotion-collapse"
                                          >
                                            <div className="-promotion-collapse-content">
                                              <h2>{prolists.proname}</h2>
                                              <section
                                                dangerouslySetInnerHTML={{ __html: prolists.detail }}
                                              />
                                              {isActive && (
                                                <button
                                                  type="button"
                                                  className="btn -promotion-collapse-cancel-btn js-cancel-promotion"
                                                  onClick={(e) => { e.stopPropagation(); this.cancelredeempromotion(e, (this.state.proderedeem && this.state.proderedeem[0]) || prolists); }}
                                                  data-promotion-collapse-parent="#deposit-promotion-collapse"
                                                >
                                                  <span className="-title">{t(lang,'ap_cancel_promo')}</span>
                                                </button>

                                              )}
                                              {!isActive && (
                                                <button
                                                  type="button"
                                                  className="btn -promotion-collapse-apply-btn js-promotion-apply"
                                                  data-type="deposit"
                                                  onClick={(e) => this.redeempro(e, prolists.no)}
                                                >
                                                  <span className="-title">{t(lang,'ap_receive_promo')}</span>
                                                </button>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })}

                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="-bottom "></div>
                        </div>
                      </div>
                    </div>
                    <div
                      data-animatable="fadeInModal"
                      className="order-lg-2 order-1 -form order-0 animated fadeInModal"
                    >
                      <div className="-fake-bg-top-wrapper">
                        <div className="-top-body-wrapper -header-spacer -spacer-smaller">
                          <div className="-balance-wrapper">
                            <div className="-text">{t(lang,'ap_balance_remaining')}</div>
                            <span id="customer-balance" className="js-customer-balance">
                              <span className="text-green-lighter">{balance}</span>
                            </span>
                          </div>
                          <div className="js-turnover">
                            <div className="-turnover-wrapper">
                              {t(lang,'ap_turnover_label')}<span className="-turnover-number">0</span>
                            </div>
                          </div>
                        </div>
                        <div className="-deposit-form-outer-wrapper">
                          <div className="-deposit-notice-inner-wrapper -spacer">
                            <div className="x-deposit-notice  -group-new">
                              <img
                                className="-cover"
                                alt="เว็บไซต์พนันออนไลน์ คาสิโนออนไลน์ รูปภาพฝากครั้งแรก"
                                src="https://cdn.javisx.com/image/a9e145f4-fb37-4692-bca5-0099c7a9b542.jpg"
                              />
                              <a
                                type="button"
                                aria-label="Close"
                                className="btn btn-block btn-primary mt-5 js-deposit-notice-confirm"
                              >
                                {t(lang,'ap_acknowledge')}
                              </a>
                            </div>
                          </div>
                          <div className="-deposit-form-inner-wrapper d-none">
                            <div
                              className="-deposit-form-v3"
                            >
                              <div className="x-modal-separator-container ">
                                <div className="-top ">
                                  {this.renderDepositChannelBar()}
                                  {this.state.depositChannel === 'auto' && (<>
                                  <div className="-spacer-smaller">
                                    <div className="-x-input-icon x-input-operator -deposit-with-label">
                                      <div className="-label-wrapper">
                                        <label
                                          htmlFor="deposit_amount"
                                          className="form-control-label"
                                        >
                                          {t(lang,'ap_topup')}
                                        </label>
                                      </div>
                                      <div className="-input-wrapper">
                                        <button
                                          type="button"
                                          className="-icon-left -btn-icon js-adjust-amount-by-operator"
                                          data-operator="-"
                                          data-value={10}
                                          onClick={() => this.adjustAmount("-")}
                                        >
                                          <i className="fas fa-minus-circle" />
                                        </button>
                                        <input
                                          type="text"
                                          id="depositamount"
                                          onChange={this.onChangexdep}
                                          value={this.state.depositamount}
                                          name="depositamount"
                                          required="required"
                                          pattern="[0-9]*"
                                          className="x-form-control -no text-center -deposit-with-label-control js-deposit-input-amount form-control"
                                          placeholder={t(lang,'ap_min_deposit_100')}
                                          inputMode="text"
                                        />
                                        <button
                                          type="button"
                                          className="-icon-right -btn-icon js-adjust-amount-by-operator"
                                          data-operator="+"
                                          data-value={10}
                                          onClick={() => this.adjustAmount("+")}
                                        >
                                          <i className="fas fa-plus-circle" />
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="-spacer-smaller">
                                    <div
                                      className="x-select-amount js-quick-amount -v2"
                                      data-target-input="#deposit_amount"
                                    >
                                      {[
                                        100, 300, 500, 1000, 5000, 10000, // Array of amounts
                                      ].map((amount) => (
                                        <div className="-amount-container" key={amount}>
                                          <button
                                            type="button"
                                            className="btn btn-block -btn-select-amount"
                                            data-amount={amount}
                                            onClick={(e) => this.handleClickdeposit(e, amount)} // Add onClick dynamically
                                          >
                                            <span className="-no">{amount.toLocaleString()}</span>
                                          </button>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                  <div className="text-center -spacer-smaller">
                                    <button
                                      onClick={(e) =>
                                        this.confirmdeposit(e, 2)
                                      }
                                      className="btn btn-primary my-0 my-lg-3"
                                    >
                                      <div className="js-deposit-amount-container">
                                        <div className="-deposit-amount-wrapper">
                                          {t(lang,'ap_topup')}{" "}
                                          <span className="js-amount d-none">0</span>
                                        </div>
                                      </div>
                                    </button>
                                  </div>
                                  </>)}
                                  {this.state.depositChannel === 'bank' && this.renderBankSlipPanel()}
                                  {this.state.depositChannel === 'truewallet' && this.renderTrueWalletPanel()}
                                  {this.state.depositChannel === 'true' && this.renderTrueDepositPanel()}
                                  {this.state.depositChannel === 'crypto' && this.renderCryptoPanel()}
                                </div>
                                <div className="-bottom ">
                                  <div className="-spacer-smaller d-lg-block d-none">
                                    <div className="x-admin-contact -in-separator">
                                      <span className="x-text-with-link-component">
                                        <label className="-text-message ">
                                          {t(lang,'ap_found_problem')}
                                        </label>
                                        <a
                                          href={this.state.linelink}
                                          className="-link-message "
                                          target="_blank"
                                          rel="noopener"
                                        >
                                          <u>{t(lang,'ap_contact_support')}</u>
                                        </a>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <input
                                type="hidden"
                                id="deposit__token"
                                name="deposit[_token]"
                                defaultValue="NY2BxkiWIMzC5lzBmY5ozA1UH8v7D0QGmLes-GWveUY"
                              />{" "}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style={{ display: this.state.tabdeposit == 2 ? "" : "none" }} className="modal-dialog -modal-size -v2 modal-dialog-centered modal-dialog-scrollable x-transfer-info -in-pending-dialog"
            role="document"
          >
            <div className="modal-content -modal-content" style={{ paddingBottom: 0 }}>
              <button
                type="button"
                className="close f-1 "
                data-dismiss="modal"
                aria-label="Close"
              >
                <i className="fas fa-times" />
              </button>
              <div className="modal-header -modal-header">
                <h3 className="x-title-modal m-auto">{t(lang,'ap_deposit')}</h3>
              </div>
              <div className="modal-body -modal-body">
                <button
                  onClick={(e) =>
                    this.setState({
                      tabdeposit: 1
                    })}
                  type="button"
                  className="btn -btn-back -mobile js-cancel-billing"
                >
                  <i className="fas fa-arrow-left" />
                  <span>{t(lang,'ap_back')}</span>
                </button>
                <div
                  className="x-pending -v2  js-pending-body"
                  data-is-upload-slip={1}
                  data-user-confirmed=""
                >
                  <div
                    className="js-content text-center -animated-wrapper animated fadeInModal"
                    data-animatable="fadeInModal"
                  >
                    <div className="-fake-bg-top-wrapper">
                      <div className="-step-indicator-wrapper">
                        <div className="x-step-indicator">
                          <button
                            onClick={(e) =>
                              this.setState({
                                tabdeposit: 1
                              })}
                            className="-step -active js-cancel-billing"
                            data-target="#depositModal"
                            aria-label="Close"
                          >
                            1
                          </button>
                          <div className="-indicator-line -active" />
                          <div className="-step -active">2</div>
                          <div className="-indicator-line " />
                          <div className="-step ">3</div>
                        </div>
                      </div>
                    </div>
                    <div className="-fake-bg-bottom-wrapper">
                      <div className="x-modal-separator-container ">
                        <div className="-top ">
                          <div
                            className="-timer-outer-container js-timer -spacer"
                          >
                            <div className="my-3 -spacer" style={{ textAlign: "center" }}>
                              {this.state.qrcode !== null ?
                                <img
                                  src={this.state.qrcode}
                                  className="-img-text-promotion img-fluid ls-is-cached lazyloaded"
                                  style={{ backgroundColor: "black" }}
                                  alt=""
                                  width={150}
                                  height={50}
                                /> : ""
                              }
                            </div>
                            <div className="-ic-wrapper">
                              <picture>
                                <source
                                  type="image/webp"
                                  srcSet="/build/web/igame-index-lobby-wm/img/ic-hourglass.webp"
                                />
                                <source
                                  type="image/png?v=1"
                                  srcSet="/build/web/igame-index-lobby-wm/img/ic-hourglass.png?v=1"
                                />
                                <img
                                  className="-ic-hourglass"
                                  alt="ฝากถอนออนไลน์ 24 ชั่วโมง"
                                  width={37}
                                  height={37}
                                  src="/build/web/igame-index-lobby-wm/img/ic-hourglass.png?v=1"
                                />
                              </picture>
                            </div>
                            <div className="-timer-wrapper">
                              {t(lang,'ap_transfer_within')}<span style={{ color: "red", fontWeight: "bold" }}>{t(lang,'ap_5_minutes')}</span>
                            </div>
                          </div>
                          <div className="my-3 -spacer">
                            <div className="-fake-input py-3 m-auto h3 -value-deposit">
                              <span>{this.state.depositamount}</span>
                              <span className="" />
                            </div>
                          </div>
                          <div className="-spacer">
                            <div className="btn -btn-promotion-collapse -no-promotion">
                              <div className="-no-promotion-text">{t(lang,'ap_no_promo_text')}</div>
                            </div>
                          </div>
                          <div className="mt-3 -spacer">
                            <div className="x-deposit-bank-info-container -v2" style={{ display: accnumber !== null ? accnumberx.accbank !== 99 ? "" : "none" : "none" }}>

                              {mainacc !== null && mainacc !== undefined && mainacc !== '' ?
                                <div className="media m-auto">
                                  <img
                                    src={mainacc.img_path}
                                    className="-img rounded-circle"
                                    width={50}
                                    height={50}
                                    alt={mainacc.fullname_th}
                                  />

                                  <div className="-content-wrapper">
                                    <span className="-name">{mainacc.fullname_th}</span>
                                    <span className="-own-name">{mainacc.first_name_en + " " + mainacc.last_name_en}</span>
                                    <span id="depositBankNumber" className="-number">
                                      {
                                        mainacc.accnumber.substring(0, 3) + "-" + mainacc.accnumber.substring(3, 9) + "-" + mainacc.accnumber.substring(9, 12)
                                      }
                                    </span>
                                  </div>

                                  <div className="-copy-wrapper">
                                    <a
                                      className="btn -btn js-copy-to-clipboard"
                                      data-message={t(lang,'ap_copied')}
                                      onClick={() => this.copyCode(mainacc.accnumber)}
                                    >
                                      {t(lang,'ap_copy')}
                                    </a>
                                  </div>
                                </div>
                                : ""}
                            </div>
                            <div className="x-deposit-bank-info-container -v2" style={{ display: accnumber !== null ? accnumberx.accbank === 99 ? "" : "none" : "none" }}>
                              {trueaccount !== null ?
                                <div className="media m-auto">
                                  <img src="https://play-lh.googleusercontent.com/6I2IYbIg4rhGUgs0UxP_5q6wmJmlBjBrlQ9f0_FAN94yOzwmrtEteifCdPPd1-chY_NX" className="-img rounded-circle"
                                    width="50"
                                    height="50"
                                    alt={trueaccount.name} />
                                  <div className="-content-wrapper">
                                    <span className="-name">{t(lang,'ap_wallet_prefix')}{trueaccount.telnumber}</span>
                                    <span className="-own-name">{trueaccount.name} </span>
                                    <span id="depositBankNumber" className="-number">{
                                      trueaccount.telnumber
                                    }</span>
                                  </div>
                                  <div className="-copy-wrapper">
                                    <a role="button" style={{ cursor: "pointer" }} onClick={() => navigator.clipboard.writeText(trueaccount.telnumber)} className="btn -btn js-copy-to-clipboard" data-container="depositModal" data-message={t(lang,'ap_copied')} data-copy-me={trueaccount.telnumber}>{t(lang,'ap_copy')}</a>
                                  </div>
                                </div> : ""}
                            </div>
                          </div>
                          <div className="-spacer">
                            <div className="x-danger-zone -v2 ">
                              <span>{t(lang,'ap_use_registered_account_only')}</span>
                            </div>
                          </div>
                        </div>
                        <div className="-bottom ">
                          <div className="-confirm-wrapper">
                            <div className="-confirm-text">
                              {t(lang,'ap_after_transfer_press')}{" "}
                              <span className="-highlight">{t(lang,'ap_confirm')}</span>{t(lang,'ap_below_here')}
                            </div>
                            <div className="-confirm-img">
                              <picture>
                                <source
                                  type="image/webp"
                                  srcSet="/build/web/igame-index-lobby-wm/img/ic-deposit-pending-arrow-down.webp"
                                />
                                <source
                                  type="image/png?v=1"
                                  srcSet="/build/web/igame-index-lobby-wm/img/ic-deposit-pending-arrow-down.png?v=1"
                                />
                                <img
                                  className="-ic"
                                  alt="รูปลูกศรตรวจสอบการโอนจากลูกค้า"
                                  src="/build/web/igame-index-lobby-wm/img/ic-deposit-pending-arrow-down.png?v=1"
                                />
                              </picture>
                            </div>
                          </div>
                          <div className="my-3 -spacer">
                            <div className="-btn-submit-group-wrapper">
                              <button
                                type="button"
                                onClick={(e) =>
                                  this.setState({
                                    tabdeposit: 1
                                  })}
                                className="btn -btn-back "
                                data-title={t(lang,'ap_edit_deposit_confirm')}
                                data-target="#depositModal"
                                aria-label="Close"
                              >
                                <i className="fas fa-arrow-left" />
                                <span>{t(lang,'ap_back')}</span>
                              </button>
                              <button
                                data-dismiss="modal"
                                aria-label="Close"
                                className="btn -submit btn-primary text-center m-auto js-upload-slip-btn"
                              >
                                {t(lang,'ap_done')}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="-pending-upload-slip js-upload-slip-body"
                  style={{ display: "none" }}
                >
                  <button
                    type="button"
                    className="btn -btn-back -mobile btn-block js-back-btn"
                  >
                    <i className="fas fa-arrow-left" />
                    <span>{t(lang,'ap_back')}</span>
                  </button>
                  <div
                    className="js-content text-center -animate-wrapper animated fadeInModal"
                    data-animatable="fadeInModal"
                  >
                    <div className="-fake-bg-top-wrapper">
                      <h3 className="x-title-modal mx-auto text-center d-inline-block">
                        {t(lang,'ap_upload_slip')}
                      </h3>
                      <div className="-step-indicator-wrapper">
                        <div className="x-step-indicator">
                          <button
                            className="-step -active js-cancel-billing"
                            data-title={t(lang,'ap_edit_deposit_confirm')}
                            data-target="#depositModal"
                            aria-label="Close"
                          >
                            1
                          </button>
                          <div className="-indicator-line -active" />
                          <button type="button" className="-step -active js-back-btn">
                            2
                          </button>
                          <div className="-indicator-line -active" />
                          <div className="-step -active">3</div>
                        </div>
                      </div>
                      <div className="mt-4 -spacer">
                        <div className="x-upload-slip">
                          <form
                            name="deposit_upload_slip"
                            method="post"
                            data-container="#depositModal"
                            data-reload=""
                            encType="multipart/form-data"
                          >
                            <input type="hidden" defaultValue="POST" name="_method" />
                            <div className="text-center -animate-wrapper">
                              <div className="-img-upload-form-wrapper">
                                <div className="-input-wrapper">
                                  <div className="-input-helper">
                                    <button className="btn -btn-upload-image">
                                      <i className="fas fa-cloud-upload-alt" />
                                      <span>{t(lang,'ap_upload_slip')}</span>
                                    </button>
                                  </div>
                                  <input
                                    type="file"
                                    accept="image/png, image/jpeg"
                                    name="deposit_upload_slip[images][user_slip][file]"
                                    className="form-control js-slip-file-input "
                                    id="deposit_upload_slip_images_user_slip_file"
                                  />
                                  <div className="-img-preview js-img-preview-wrapper " style={{ display: 'none' }}>
                                    <img
                                      src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                                      className="js-img-preview img-fluid"
                                      alt="อัปโหลด slip หลักฐานการชำระเงิน"
                                    />
                                  </div>
                                </div>
                                <div>
                                  <small className="text-muted">
                                    {t(lang,'ap_slip_max_5mb')}
                                  </small>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                      <div className="mt-3 -spacer">
                        <div className="x-danger-zone -v2 ">
                          <span>
                            {t(lang,'ap_slip_required_note')}<br />{t(lang,'ap_and_must_see_qr')}
                            {t(lang,'ap_slip_qr_clear')}
                          </span>
                        </div>
                      </div>
                      <div className="mt-4 -spacer">
                        <button
                          type="button"
                          className="btn -btn-back btn-block js-back-btn"
                        >
                          <i className="fas fa-arrow-left" />
                          <span>{t(lang,'ap_back')}</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <ToastContainer position="bottom-right" />
        <Popup />
      </div >

    );
  }
}

export default App;
